//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class ActivityClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(): Observable<ActivityConfigurationDto[]> {
        let url_ = this.baseUrl + "/api/activities";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityConfigurationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityConfigurationDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ActivityConfigurationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivityConfigurationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(dto: UpsertActivityConfigurationDto): Observable<ActivityConfigurationDto> {
        let url_ = this.baseUrl + "/api/activities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityConfigurationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityConfigurationDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ActivityConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ActivityConfigurationDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(id: number): Observable<ActivityConfigurationDto> {
        let url_ = this.baseUrl + "/api/activities/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityConfigurationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityConfigurationDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<ActivityConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityConfigurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(id: number, dto: UpsertActivityConfigurationDto): Observable<void> {
        let url_ = this.baseUrl + "/api/activities/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/activities/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AreaClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(includeInactive: boolean | undefined): Observable<AreaDto[]> {
        let url_ = this.baseUrl + "/api/areas?";
        if (includeInactive === null)
            throw new globalThis.Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AreaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AreaDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AreaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AreaDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(dto: CreateAreaDto): Observable<AreaDto> {
        let url_ = this.baseUrl + "/api/areas";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AreaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AreaDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AreaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = AreaDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(id: number): Observable<AreaDto> {
        let url_ = this.baseUrl + "/api/areas/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AreaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AreaDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<AreaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AreaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(id: number, dto: UpdateAreaDto): Observable<void> {
        let url_ = this.baseUrl + "/api/areas/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/areas/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateSortOrder(dto: UpdateAreaSortOrderDto): Observable<void> {
        let url_ = this.baseUrl + "/api/areas/sort-order";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSortOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSortOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSortOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AssignmentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(): Observable<AssignmentDto[]> {
        let url_ = this.baseUrl + "/api/assignments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignmentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignmentDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AssignmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssignmentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(dto: CreateAssignmentDto): Observable<AssignmentDto> {
        let url_ = this.baseUrl + "/api/assignments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignmentDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AssignmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = AssignmentDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(id: number): Observable<AssignmentDto> {
        let url_ = this.baseUrl + "/api/assignments/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignmentDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<AssignmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(id: number, dto: UpdateAssignmentDto): Observable<void> {
        let url_ = this.baseUrl + "/api/assignments/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/assignments/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateSortOrder(id: number, dto: UpdateAssignmentSortOrderDto): Observable<void> {
        let url_ = this.baseUrl + "/api/assignments/{id}/sort-order";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSortOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSortOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSortOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CatalogClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getMemberDetailData(): Observable<PersonDetailCatalogDto> {
        let url_ = this.baseUrl + "/api/catalog/for-member-detail";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberDetailData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberDetailData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonDetailCatalogDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonDetailCatalogDto>;
        }));
    }

    protected processGetMemberDetailData(response: HttpResponseBase): Observable<PersonDetailCatalogDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonDetailCatalogDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDivineServiceTypes(): Observable<DivineServiceTypeDto[]> {
        let url_ = this.baseUrl + "/api/catalog/divine-service-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDivineServiceTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDivineServiceTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DivineServiceTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DivineServiceTypeDto[]>;
        }));
    }

    protected processGetDivineServiceTypes(response: HttpResponseBase): Observable<DivineServiceTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DivineServiceTypeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCountries(): Observable<CountryDto[]> {
        let url_ = this.baseUrl + "/api/catalog/countries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryDto[]>;
        }));
    }

    protected processGetCountries(response: HttpResponseBase): Observable<CountryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DivineServiceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getDivineServices(unitId: string | null | undefined, startDate: string | null | undefined, endDate: string | null | undefined, searchTerm: string | null | undefined, divineServiceTypeId: number | null | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined, page: number | undefined, pageSize: number | undefined): Observable<PaginatedResponseOfDivineServiceListDto> {
        let url_ = this.baseUrl + "/api/divine-services?";
        if (unitId !== undefined && unitId !== null)
            url_ += "UnitId=" + encodeURIComponent("" + unitId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (divineServiceTypeId !== undefined && divineServiceTypeId !== null)
            url_ += "DivineServiceTypeId=" + encodeURIComponent("" + divineServiceTypeId) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDivineServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDivineServices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResponseOfDivineServiceListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResponseOfDivineServiceListDto>;
        }));
    }

    protected processGetDivineServices(response: HttpResponseBase): Observable<PaginatedResponseOfDivineServiceListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResponseOfDivineServiceListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createDivineService(request: CreateDivineServiceRequest): Observable<DivineServiceDetailDto> {
        let url_ = this.baseUrl + "/api/divine-services";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDivineService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDivineService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DivineServiceDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DivineServiceDetailDto>;
        }));
    }

    protected processCreateDivineService(response: HttpResponseBase): Observable<DivineServiceDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = DivineServiceDetailDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDivineServiceById(id: string): Observable<DivineServiceDetailDto> {
        let url_ = this.baseUrl + "/api/divine-services/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDivineServiceById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDivineServiceById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DivineServiceDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DivineServiceDetailDto>;
        }));
    }

    protected processGetDivineServiceById(response: HttpResponseBase): Observable<DivineServiceDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DivineServiceDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateDivineService(id: string, request: UpdateDivineServiceRequest): Observable<DivineServiceDetailDto> {
        let url_ = this.baseUrl + "/api/divine-services/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDivineService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDivineService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DivineServiceDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DivineServiceDetailDto>;
        }));
    }

    protected processUpdateDivineService(response: HttpResponseBase): Observable<DivineServiceDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DivineServiceDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteDivineService(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/divine-services/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDivineService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDivineService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDivineService(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    closeDivineService(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/divine-services/{id}/close";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCloseDivineService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloseDivineService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCloseDivineService(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getManageableUnits(): Observable<OrganizationUnitDto[]> {
        let url_ = this.baseUrl + "/api/divine-services/manageable-units";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetManageableUnits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetManageableUnits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto[]>;
        }));
    }

    protected processGetManageableUnits(response: HttpResponseBase): Observable<OrganizationUnitDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationUnitDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMembersWithAttendance(divineServiceId: string, page: number | undefined, pageSize: number | undefined): Observable<PaginatedResponseOfMemberAttendanceDto> {
        let url_ = this.baseUrl + "/api/divine-services/{divineServiceId}/members-attendance?";
        if (divineServiceId === undefined || divineServiceId === null)
            throw new globalThis.Error("The parameter 'divineServiceId' must be defined.");
        url_ = url_.replace("{divineServiceId}", encodeURIComponent("" + divineServiceId));
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMembersWithAttendance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMembersWithAttendance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResponseOfMemberAttendanceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResponseOfMemberAttendanceDto>;
        }));
    }

    protected processGetMembersWithAttendance(response: HttpResponseBase): Observable<PaginatedResponseOfMemberAttendanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResponseOfMemberAttendanceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAttendance(divineServiceId: string, page: number | undefined, pageSize: number | undefined): Observable<AttendanceDto> {
        let url_ = this.baseUrl + "/api/divine-services/{divineServiceId}/attendance?";
        if (divineServiceId === undefined || divineServiceId === null)
            throw new globalThis.Error("The parameter 'divineServiceId' must be defined.");
        url_ = url_.replace("{divineServiceId}", encodeURIComponent("" + divineServiceId));
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttendanceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttendanceDto>;
        }));
    }

    protected processGetAttendance(response: HttpResponseBase): Observable<AttendanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttendanceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    markAttendance(divineServiceId: string, memberId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/divine-services/{divineServiceId}/attendees/{memberId}";
        if (divineServiceId === undefined || divineServiceId === null)
            throw new globalThis.Error("The parameter 'divineServiceId' must be defined.");
        url_ = url_.replace("{divineServiceId}", encodeURIComponent("" + divineServiceId));
        if (memberId === undefined || memberId === null)
            throw new globalThis.Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAttendance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAttendance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarkAttendance(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    unmarkAttendance(divineServiceId: string, memberId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/divine-services/{divineServiceId}/attendees/{memberId}";
        if (divineServiceId === undefined || divineServiceId === null)
            throw new globalThis.Error("The parameter 'divineServiceId' must be defined.");
        url_ = url_.replace("{divineServiceId}", encodeURIComponent("" + divineServiceId));
        if (memberId === undefined || memberId === null)
            throw new globalThis.Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnmarkAttendance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnmarkAttendance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnmarkAttendance(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkMarkAttendance(divineServiceId: string, request: BulkAttendanceDto): Observable<void> {
        let url_ = this.baseUrl + "/api/divine-services/{divineServiceId}/attendees/bulk";
        if (divineServiceId === undefined || divineServiceId === null)
            throw new globalThis.Error("The parameter 'divineServiceId' must be defined.");
        url_ = url_.replace("{divineServiceId}", encodeURIComponent("" + divineServiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkMarkAttendance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkMarkAttendance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkMarkAttendance(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkUnmarkAttendance(divineServiceId: string, request: BulkAttendanceDto): Observable<void> {
        let url_ = this.baseUrl + "/api/divine-services/{divineServiceId}/attendees/bulk";
        if (divineServiceId === undefined || divineServiceId === null)
            throw new globalThis.Error("The parameter 'divineServiceId' must be defined.");
        url_ = url_.replace("{divineServiceId}", encodeURIComponent("" + divineServiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkUnmarkAttendance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkUnmarkAttendance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkUnmarkAttendance(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DivineServiceTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(): Observable<DivineServiceTypeDto[]> {
        let url_ = this.baseUrl + "/api/divine-service-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DivineServiceTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DivineServiceTypeDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DivineServiceTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DivineServiceTypeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(dto: CreateDivineServiceTypeDto): Observable<DivineServiceTypeDto> {
        let url_ = this.baseUrl + "/api/divine-service-types";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DivineServiceTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DivineServiceTypeDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DivineServiceTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = DivineServiceTypeDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(id: number): Observable<DivineServiceTypeDto> {
        let url_ = this.baseUrl + "/api/divine-service-types/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DivineServiceTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DivineServiceTypeDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<DivineServiceTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DivineServiceTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(id: number, dto: UpdateDivineServiceTypeDto): Observable<void> {
        let url_ = this.baseUrl + "/api/divine-service-types/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/divine-service-types/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateSortOrder(dto: UpdateDivineServiceTypeSortOrderDto): Observable<void> {
        let url_ = this.baseUrl + "/api/divine-service-types/sort-order";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSortOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSortOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSortOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FeedbackClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    create(dto: CreateFeedbackDto): Observable<number> {
        let url_ = this.baseUrl + "/api/feedback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMine(page: number | undefined, pageSize: number | undefined, status: FeedbackStatus | null | undefined, search: string | null | undefined, statuses: FeedbackStatus[] | null | undefined, types: FeedbackType[] | null | undefined, priorities: FeedbackPriority[] | null | undefined): Observable<FeedbackPageDtoOfFeedbackListItemDto> {
        let url_ = this.baseUrl + "/api/feedback?";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (statuses !== undefined && statuses !== null)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        if (types !== undefined && types !== null)
            types && types.forEach(item => { url_ += "types=" + encodeURIComponent("" + item) + "&"; });
        if (priorities !== undefined && priorities !== null)
            priorities && priorities.forEach(item => { url_ += "priorities=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMine(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMine(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FeedbackPageDtoOfFeedbackListItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FeedbackPageDtoOfFeedbackListItemDto>;
        }));
    }

    protected processGetMine(response: HttpResponseBase): Observable<FeedbackPageDtoOfFeedbackListItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FeedbackPageDtoOfFeedbackListItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMine2(page: number | undefined, pageSize: number | undefined, status: FeedbackStatus | null | undefined, search: string | null | undefined, statuses: FeedbackStatus[] | null | undefined, types: FeedbackType[] | null | undefined, priorities: FeedbackPriority[] | null | undefined): Observable<FeedbackPageDtoOfFeedbackListItemDto> {
        let url_ = this.baseUrl + "/api/feedback/mine?";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (statuses !== undefined && statuses !== null)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        if (types !== undefined && types !== null)
            types && types.forEach(item => { url_ += "types=" + encodeURIComponent("" + item) + "&"; });
        if (priorities !== undefined && priorities !== null)
            priorities && priorities.forEach(item => { url_ += "priorities=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMine2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMine2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FeedbackPageDtoOfFeedbackListItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FeedbackPageDtoOfFeedbackListItemDto>;
        }));
    }

    protected processGetMine2(response: HttpResponseBase): Observable<FeedbackPageDtoOfFeedbackListItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FeedbackPageDtoOfFeedbackListItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getManagement(page: number | undefined, pageSize: number | undefined, status: FeedbackStatus | null | undefined, search: string | null | undefined, statuses: FeedbackStatus[] | null | undefined, types: FeedbackType[] | null | undefined, priorities: FeedbackPriority[] | null | undefined): Observable<FeedbackPageDtoOfFeedbackListItemDto> {
        let url_ = this.baseUrl + "/api/feedback/management?";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (statuses !== undefined && statuses !== null)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        if (types !== undefined && types !== null)
            types && types.forEach(item => { url_ += "types=" + encodeURIComponent("" + item) + "&"; });
        if (priorities !== undefined && priorities !== null)
            priorities && priorities.forEach(item => { url_ += "priorities=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetManagement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetManagement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FeedbackPageDtoOfFeedbackListItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FeedbackPageDtoOfFeedbackListItemDto>;
        }));
    }

    protected processGetManagement(response: HttpResponseBase): Observable<FeedbackPageDtoOfFeedbackListItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FeedbackPageDtoOfFeedbackListItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAccess(): Observable<FeedbackAccessDto> {
        let url_ = this.baseUrl + "/api/feedback/access";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FeedbackAccessDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FeedbackAccessDto>;
        }));
    }

    protected processGetAccess(response: HttpResponseBase): Observable<FeedbackAccessDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FeedbackAccessDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSettings(): Observable<FeedbackSettingsDto> {
        let url_ = this.baseUrl + "/api/feedback/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FeedbackSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FeedbackSettingsDto>;
        }));
    }

    protected processGetSettings(response: HttpResponseBase): Observable<FeedbackSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FeedbackSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setSettings(dto: FeedbackSettingsDto): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/feedback/settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSetSettings(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTeam(): Observable<FeedbackTeamUserDto[]> {
        let url_ = this.baseUrl + "/api/feedback/team";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTeam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTeam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FeedbackTeamUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FeedbackTeamUserDto[]>;
        }));
    }

    protected processGetTeam(response: HttpResponseBase): Observable<FeedbackTeamUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FeedbackTeamUserDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchTeamCandidates(search: string | null | undefined): Observable<FeedbackTeamUserDto[]> {
        let url_ = this.baseUrl + "/api/feedback/team/candidates?";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchTeamCandidates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchTeamCandidates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FeedbackTeamUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FeedbackTeamUserDto[]>;
        }));
    }

    protected processSearchTeamCandidates(response: HttpResponseBase): Observable<FeedbackTeamUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FeedbackTeamUserDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setTeamMember(userId: string, dto: SetFeedbackTeamMemberDto): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/feedback/team/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetTeamMember(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetTeamMember(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSetTeamMember(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setPrioritizer(userId: string, dto: SetFeedbackPrioritizerDto): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/feedback/team/{userId}/prioritization";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetPrioritizer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetPrioritizer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSetPrioritizer(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(id: number, dto: UpdateFeedbackDto): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/feedback/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: number, revision: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/feedback/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (revision === null)
            throw new globalThis.Error("The parameter 'revision' cannot be null.");
        else if (revision !== undefined)
            url_ += "revision=" + encodeURIComponent("" + revision) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDetail(id: number): Observable<FeedbackDetailDto> {
        let url_ = this.baseUrl + "/api/feedback/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FeedbackDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FeedbackDetailDto>;
        }));
    }

    protected processGetDetail(response: HttpResponseBase): Observable<FeedbackDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FeedbackDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAssignees(): Observable<FeedbackAssigneeDto[]> {
        let url_ = this.baseUrl + "/api/feedback/assignees";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignees(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FeedbackAssigneeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FeedbackAssigneeDto[]>;
        }));
    }

    protected processGetAssignees(response: HttpResponseBase): Observable<FeedbackAssigneeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FeedbackAssigneeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    manage(id: number, dto: ManageFeedbackDto): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/feedback/{id}/management";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processManage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processManage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processManage(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAttachment(id: number, attachmentId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/feedback/{id}/attachments/{attachmentId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (attachmentId === undefined || attachmentId === null)
            throw new globalThis.Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetAttachment(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LegacyUsersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAllLegacyUsers(validOnly: boolean | undefined, searchText: string | null | undefined, libraryLevel: string | null | undefined, area: string | null | undefined, distrito: string | null | undefined, comunidad: string | null | undefined, page: number | undefined, pageSize: number | undefined): Observable<LegacyUserForMigrationDataDto> {
        let url_ = this.baseUrl + "/api/LegacyUsers?";
        if (validOnly === null)
            throw new globalThis.Error("The parameter 'validOnly' cannot be null.");
        else if (validOnly !== undefined)
            url_ += "ValidOnly=" + encodeURIComponent("" + validOnly) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (libraryLevel !== undefined && libraryLevel !== null)
            url_ += "LibraryLevel=" + encodeURIComponent("" + libraryLevel) + "&";
        if (area !== undefined && area !== null)
            url_ += "Area=" + encodeURIComponent("" + area) + "&";
        if (distrito !== undefined && distrito !== null)
            url_ += "Distrito=" + encodeURIComponent("" + distrito) + "&";
        if (comunidad !== undefined && comunidad !== null)
            url_ += "Comunidad=" + encodeURIComponent("" + comunidad) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLegacyUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLegacyUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LegacyUserForMigrationDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LegacyUserForMigrationDataDto>;
        }));
    }

    protected processGetAllLegacyUsers(response: HttpResponseBase): Observable<LegacyUserForMigrationDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LegacyUserForMigrationDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFilterData(): Observable<FilterDataDto> {
        let url_ = this.baseUrl + "/api/LegacyUsers/filter-data";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilterData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilterData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FilterDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FilterDataDto>;
        }));
    }

    protected processGetFilterData(response: HttpResponseBase): Observable<FilterDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FilterDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLegacyUserByEmail(email: string): Observable<LegacyUserDto> {
        let url_ = this.baseUrl + "/api/LegacyUsers/{email}";
        if (email === undefined || email === null)
            throw new globalThis.Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLegacyUserByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLegacyUserByEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LegacyUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LegacyUserDto>;
        }));
    }

    protected processGetLegacyUserByEmail(response: HttpResponseBase): Observable<LegacyUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LegacyUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    migrateUser(migrationRequest: MigrateLegacyUserRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/LegacyUsers/migrate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(migrationRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMigrateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMigrateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMigrateUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(): Observable<UserFullInfoDto> {
        let url_ = this.baseUrl + "/api/Me";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserFullInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserFullInfoDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserFullInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserFullInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserDetail(): Observable<UserBasicDto> {
        let url_ = this.baseUrl + "/api/Me/user-detail";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserBasicDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserBasicDto>;
        }));
    }

    protected processGetUserDetail(response: HttpResponseBase): Observable<UserBasicDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserBasicDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRoleAssignments(): Observable<UserRoleAssignmentDto[]> {
        let url_ = this.baseUrl + "/api/Me/role-assignments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleAssignments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleAssignments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserRoleAssignmentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserRoleAssignmentDto[]>;
        }));
    }

    protected processGetRoleAssignments(response: HttpResponseBase): Observable<UserRoleAssignmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserRoleAssignmentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateEmail(email: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Me/email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(email);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MinistryAppointmentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(): Observable<MinistryAppointmentDto[]> {
        let url_ = this.baseUrl + "/api/ministry-appointments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MinistryAppointmentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MinistryAppointmentDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MinistryAppointmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MinistryAppointmentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(dto: CreateMinistryAppointmentDto): Observable<MinistryAppointmentDto> {
        let url_ = this.baseUrl + "/api/ministry-appointments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MinistryAppointmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MinistryAppointmentDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MinistryAppointmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = MinistryAppointmentDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(id: number): Observable<MinistryAppointmentDto> {
        let url_ = this.baseUrl + "/api/ministry-appointments/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MinistryAppointmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MinistryAppointmentDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<MinistryAppointmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MinistryAppointmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(id: number, dto: UpdateMinistryAppointmentDto): Observable<void> {
        let url_ = this.baseUrl + "/api/ministry-appointments/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/ministry-appointments/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateSortOrder(id: number, dto: UpdateMinistryAppointmentSortOrderDto): Observable<void> {
        let url_ = this.baseUrl + "/api/ministry-appointments/{id}/sort-order";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSortOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSortOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSortOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MinistryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(): Observable<MinistryDto[]> {
        let url_ = this.baseUrl + "/api/ministries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MinistryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MinistryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MinistryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MinistryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(dto: CreateMinistryDto): Observable<MinistryDto> {
        let url_ = this.baseUrl + "/api/ministries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MinistryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MinistryDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MinistryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = MinistryDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(id: number): Observable<MinistryDto> {
        let url_ = this.baseUrl + "/api/ministries/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MinistryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MinistryDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<MinistryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MinistryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(id: number, dto: UpdateMinistryDto): Observable<void> {
        let url_ = this.baseUrl + "/api/ministries/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/ministries/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateSortOrder(id: number, dto: UpdateMinistrySortOrderDto): Observable<void> {
        let url_ = this.baseUrl + "/api/ministries/{id}/sort-order";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSortOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSortOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSortOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MinistryTransferRequestsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(status: TransferRequestStatus | null | undefined): Observable<MinistryTransferRequestDto[]> {
        let url_ = this.baseUrl + "/api/ministry-transfer-requests?";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MinistryTransferRequestDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MinistryTransferRequestDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MinistryTransferRequestDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MinistryTransferRequestDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    approve(id: string, dto: ResolveMinistryTransferRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ministry-transfer-requests/{id}/approve";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApprove(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reject(id: string, dto: ResolveMinistryTransferRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ministry-transfer-requests/{id}/reject";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReject(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cancel(id: string, dto: ResolveMinistryTransferRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ministry-transfer-requests/{id}/cancel";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OrganizationUnitClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAllWithoutPagination(): Observable<OrganizationUnitDto[]> {
        let url_ = this.baseUrl + "/api/OrganizationUnit/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWithoutPagination(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWithoutPagination(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto[]>;
        }));
    }

    protected processGetAllWithoutPagination(response: HttpResponseBase): Observable<OrganizationUnitDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationUnitDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCommunities(searchTerm: string | null | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined, page: number | undefined, pageSize: number | undefined, areaId: string | null | undefined, districtId: string | null | undefined, groupId: string | null | undefined): Observable<PaginatedResponseOfOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/OrganizationUnit/communities?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (areaId !== undefined && areaId !== null)
            url_ += "areaId=" + encodeURIComponent("" + areaId) + "&";
        if (districtId !== undefined && districtId !== null)
            url_ += "districtId=" + encodeURIComponent("" + districtId) + "&";
        if (groupId !== undefined && groupId !== null)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommunities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommunities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResponseOfOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResponseOfOrganizationUnitDto>;
        }));
    }

    protected processGetCommunities(response: HttpResponseBase): Observable<PaginatedResponseOfOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResponseOfOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(id: string): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/OrganizationUnit/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(id: string, request: UpdateUnitRequest): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/OrganizationUnit/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: string, reason: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OrganizationUnit/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (reason !== undefined && reason !== null)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(searchTerm: string | null | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined, page: number | undefined, pageSize: number | undefined): Observable<PaginatedResponseOfOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/OrganizationUnit?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResponseOfOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResponseOfOrganizationUnitDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PaginatedResponseOfOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResponseOfOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(request: CreateUnitRequest): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/OrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = OrganizationUnitDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    search(searchTerm: string | null | undefined, page: number | undefined, pageSize: number | undefined, levelId: number | null | undefined, maxLevelId: number | null | undefined): Observable<PaginatedResponseOfOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/OrganizationUnit/search?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (levelId !== undefined && levelId !== null)
            url_ += "levelId=" + encodeURIComponent("" + levelId) + "&";
        if (maxLevelId !== undefined && maxLevelId !== null)
            url_ += "maxLevelId=" + encodeURIComponent("" + maxLevelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResponseOfOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResponseOfOrganizationUnitDto>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PaginatedResponseOfOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResponseOfOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getHigherLevelUnits(minExcludedLevelId: number | null | undefined): Observable<OrganizationUnitByLevelDto[]> {
        let url_ = this.baseUrl + "/api/OrganizationUnit/higher-level-units?";
        if (minExcludedLevelId !== undefined && minExcludedLevelId !== null)
            url_ += "minExcludedLevelId=" + encodeURIComponent("" + minExcludedLevelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHigherLevelUnits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHigherLevelUnits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitByLevelDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitByLevelDto[]>;
        }));
    }

    protected processGetHigherLevelUnits(response: HttpResponseBase): Observable<OrganizationUnitByLevelDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationUnitByLevelDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMinistriesByUnit(id: string): Observable<MinistryPersonGroupDto[]> {
        let url_ = this.baseUrl + "/api/OrganizationUnit/{id}/ministries";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMinistriesByUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMinistriesByUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MinistryPersonGroupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MinistryPersonGroupDto[]>;
        }));
    }

    protected processGetMinistriesByUnit(response: HttpResponseBase): Observable<MinistryPersonGroupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MinistryPersonGroupDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMinistryTransferRequests(id: string, status: TransferRequestStatus | null | undefined): Observable<MinistryTransferRequestDto[]> {
        let url_ = this.baseUrl + "/api/OrganizationUnit/{id}/ministry-transfer-requests?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMinistryTransferRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMinistryTransferRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MinistryTransferRequestDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MinistryTransferRequestDto[]>;
        }));
    }

    protected processGetMinistryTransferRequests(response: HttpResponseBase): Observable<MinistryTransferRequestDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MinistryTransferRequestDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMembersByUnit(id: string, includeDeparted: boolean | undefined): Observable<PersonDto[]> {
        let url_ = this.baseUrl + "/api/OrganizationUnit/{id}/members?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (includeDeparted === null)
            throw new globalThis.Error("The parameter 'includeDeparted' cannot be null.");
        else if (includeDeparted !== undefined)
            url_ += "includeDeparted=" + encodeURIComponent("" + includeDeparted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMembersByUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMembersByUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonDto[]>;
        }));
    }

    protected processGetMembersByUnit(response: HttpResponseBase): Observable<PersonDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMembersPreviewByUnit(id: string, page: number | undefined, pageSize: number | undefined): Observable<PaginatedResponseOfPersonDto> {
        let url_ = this.baseUrl + "/api/OrganizationUnit/{id}/members/preview?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMembersPreviewByUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMembersPreviewByUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResponseOfPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResponseOfPersonDto>;
        }));
    }

    protected processGetMembersPreviewByUnit(response: HttpResponseBase): Observable<PaginatedResponseOfPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResponseOfPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMemberLastAttendanceByUnit(id: string, pageSize: number | undefined): Observable<MemberLastAttendanceDto[]> {
        let url_ = this.baseUrl + "/api/OrganizationUnit/{id}/members/last-attendance?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberLastAttendanceByUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberLastAttendanceByUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MemberLastAttendanceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MemberLastAttendanceDto[]>;
        }));
    }

    protected processGetMemberLastAttendanceByUnit(response: HttpResponseBase): Observable<MemberLastAttendanceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MemberLastAttendanceDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDescendantTree(id: string): Observable<OrganizationUnitTreeNodeDto> {
        let url_ = this.baseUrl + "/api/OrganizationUnit/{id}/tree";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDescendantTree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDescendantTree(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitTreeNodeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitTreeNodeDto>;
        }));
    }

    protected processGetDescendantTree(response: HttpResponseBase): Observable<OrganizationUnitTreeNodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitTreeNodeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changeParent(id: string, request: ChangeParentRequest): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/OrganizationUnit/{id}/parent";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeParent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeParent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto>;
        }));
    }

    protected processChangeParent(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSchedules(id: string): Observable<OrganizationUnitScheduleDto[]> {
        let url_ = this.baseUrl + "/api/OrganizationUnit/{id}/schedules";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSchedules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSchedules(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitScheduleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitScheduleDto[]>;
        }));
    }

    protected processGetSchedules(response: HttpResponseBase): Observable<OrganizationUnitScheduleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationUnitScheduleDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createSchedule(id: string, request: CreateScheduleRequest): Observable<OrganizationUnitScheduleDto> {
        let url_ = this.baseUrl + "/api/OrganizationUnit/{id}/schedules";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitScheduleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitScheduleDto>;
        }));
    }

    protected processCreateSchedule(response: HttpResponseBase): Observable<OrganizationUnitScheduleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = OrganizationUnitScheduleDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteSchedule(id: string, scheduleId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/OrganizationUnit/{id}/schedules/{scheduleId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (scheduleId === undefined || scheduleId === null)
            throw new globalThis.Error("The parameter 'scheduleId' must be defined.");
        url_ = url_.replace("{scheduleId}", encodeURIComponent("" + scheduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteSchedule(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEvents(id: string): Observable<OrganizationUnitEventDto[]> {
        let url_ = this.baseUrl + "/api/OrganizationUnit/{id}/events";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitEventDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitEventDto[]>;
        }));
    }

    protected processGetEvents(response: HttpResponseBase): Observable<OrganizationUnitEventDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationUnitEventDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createEvent(id: string, dto: CreateOrganizationUnitEventDto): Observable<number> {
        let url_ = this.baseUrl + "/api/OrganizationUnit/{id}/events";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateEvent(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return _observableOf(result201);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateEvent(id: string, eventId: number, dto: UpdateOrganizationUnitEventDto): Observable<void> {
        let url_ = this.baseUrl + "/api/OrganizationUnit/{id}/events/{eventId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (eventId === undefined || eventId === null)
            throw new globalThis.Error("The parameter 'eventId' must be defined.");
        url_ = url_.replace("{eventId}", encodeURIComponent("" + eventId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateEvent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteEvent(id: string, eventId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/OrganizationUnit/{id}/events/{eventId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (eventId === undefined || eventId === null)
            throw new globalThis.Error("The parameter 'eventId' must be defined.");
        url_ = url_.replace("{eventId}", encodeURIComponent("" + eventId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteEvent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getParentChangeHistory(id: string): Observable<OrganizationUnitParentChangeDto[]> {
        let url_ = this.baseUrl + "/api/OrganizationUnit/{id}/parent-history";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParentChangeHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParentChangeHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitParentChangeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitParentChangeDto[]>;
        }));
    }

    protected processGetParentChangeHistory(response: HttpResponseBase): Observable<OrganizationUnitParentChangeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationUnitParentChangeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OrganizationUnitEventTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(): Observable<OrganizationUnitEventTypeDto[]> {
        let url_ = this.baseUrl + "/api/organization-unit-event-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitEventTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitEventTypeDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<OrganizationUnitEventTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationUnitEventTypeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(dto: CreateOrganizationUnitEventTypeDto): Observable<OrganizationUnitEventTypeDto> {
        let url_ = this.baseUrl + "/api/organization-unit-event-types";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitEventTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitEventTypeDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<OrganizationUnitEventTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = OrganizationUnitEventTypeDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(id: number): Observable<OrganizationUnitEventTypeDto> {
        let url_ = this.baseUrl + "/api/organization-unit-event-types/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitEventTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitEventTypeDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<OrganizationUnitEventTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitEventTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(id: number, dto: UpdateOrganizationUnitEventTypeDto): Observable<void> {
        let url_ = this.baseUrl + "/api/organization-unit-event-types/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/organization-unit-event-types/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateSortOrder(dto: UpdateOrganizationUnitEventTypeSortOrderDto): Observable<void> {
        let url_ = this.baseUrl + "/api/organization-unit-event-types/sort-order";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSortOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSortOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSortOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PeopleClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(searchTerm: string | null | undefined, unitIds: string[] | null | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined, page: number | undefined, pageSize: number | undefined): Observable<PaginatedResponseOfPeopleListDto> {
        let url_ = this.baseUrl + "/api/people?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (unitIds !== undefined && unitIds !== null)
            unitIds && unitIds.forEach(item => { url_ += "UnitIds=" + encodeURIComponent("" + item) + "&"; });
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResponseOfPeopleListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResponseOfPeopleListDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PaginatedResponseOfPeopleListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResponseOfPeopleListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(request: CreatePersonRequest): Observable<PersonDto> {
        let url_ = this.baseUrl + "/api/people";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = PersonDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAdminList(page: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined, isDeleted: boolean | null | undefined, unitId: string | null | undefined): Observable<PaginatedResponseOfAdminPersonListDto> {
        let url_ = this.baseUrl + "/api/people/admin-list?";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (isDeleted !== undefined && isDeleted !== null)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&";
        if (unitId !== undefined && unitId !== null)
            url_ += "unitId=" + encodeURIComponent("" + unitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdminList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdminList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResponseOfAdminPersonListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResponseOfAdminPersonListDto>;
        }));
    }

    protected processGetAdminList(response: HttpResponseBase): Observable<PaginatedResponseOfAdminPersonListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResponseOfAdminPersonListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFollowUp(unitId: string | undefined, searchTerm: string | null | undefined, ageStatuses: PersonAgeStatus[] | null | undefined, noAgeStatusesSelected: boolean | undefined, includeUndeterminedAge: boolean | undefined, responsiblePriestIds: string[] | null | undefined, noResponsiblePriestsSelected: boolean | undefined, isHomeAttended: boolean | null | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined, page: number | undefined, pageSize: number | undefined): Observable<PaginatedResponseOfMemberFollowUpListItemDto> {
        let url_ = this.baseUrl + "/api/people/follow-up?";
        if (unitId === null)
            throw new globalThis.Error("The parameter 'unitId' cannot be null.");
        else if (unitId !== undefined)
            url_ += "UnitId=" + encodeURIComponent("" + unitId) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (ageStatuses !== undefined && ageStatuses !== null)
            ageStatuses && ageStatuses.forEach(item => { url_ += "AgeStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (noAgeStatusesSelected === null)
            throw new globalThis.Error("The parameter 'noAgeStatusesSelected' cannot be null.");
        else if (noAgeStatusesSelected !== undefined)
            url_ += "NoAgeStatusesSelected=" + encodeURIComponent("" + noAgeStatusesSelected) + "&";
        if (includeUndeterminedAge === null)
            throw new globalThis.Error("The parameter 'includeUndeterminedAge' cannot be null.");
        else if (includeUndeterminedAge !== undefined)
            url_ += "IncludeUndeterminedAge=" + encodeURIComponent("" + includeUndeterminedAge) + "&";
        if (responsiblePriestIds !== undefined && responsiblePriestIds !== null)
            responsiblePriestIds && responsiblePriestIds.forEach(item => { url_ += "ResponsiblePriestIds=" + encodeURIComponent("" + item) + "&"; });
        if (noResponsiblePriestsSelected === null)
            throw new globalThis.Error("The parameter 'noResponsiblePriestsSelected' cannot be null.");
        else if (noResponsiblePriestsSelected !== undefined)
            url_ += "NoResponsiblePriestsSelected=" + encodeURIComponent("" + noResponsiblePriestsSelected) + "&";
        if (isHomeAttended !== undefined && isHomeAttended !== null)
            url_ += "IsHomeAttended=" + encodeURIComponent("" + isHomeAttended) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFollowUp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFollowUp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResponseOfMemberFollowUpListItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResponseOfMemberFollowUpListItemDto>;
        }));
    }

    protected processGetFollowUp(response: HttpResponseBase): Observable<PaginatedResponseOfMemberFollowUpListItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResponseOfMemberFollowUpListItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFollowUpResponsiblePriests(unitId: string | undefined, searchTerm: string | null | undefined, page: number | undefined, pageSize: number | undefined): Observable<PaginatedResponseOfMemberFollowUpResponsiblePriestDto> {
        let url_ = this.baseUrl + "/api/people/follow-up/responsible-priests?";
        if (unitId === null)
            throw new globalThis.Error("The parameter 'unitId' cannot be null.");
        else if (unitId !== undefined)
            url_ += "unitId=" + encodeURIComponent("" + unitId) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFollowUpResponsiblePriests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFollowUpResponsiblePriests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResponseOfMemberFollowUpResponsiblePriestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResponseOfMemberFollowUpResponsiblePriestDto>;
        }));
    }

    protected processGetFollowUpResponsiblePriests(response: HttpResponseBase): Observable<PaginatedResponseOfMemberFollowUpResponsiblePriestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResponseOfMemberFollowUpResponsiblePriestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateHomeAttendance(id: string, request: UpdatePersonHomeAttendanceDto): Observable<void> {
        let url_ = this.baseUrl + "/api/people/{id}/home-attendance";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateHomeAttendance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateHomeAttendance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateHomeAttendance(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(id: string): Observable<PersonDto> {
        let url_ = this.baseUrl + "/api/people/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<PersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(id: string, request: UpdatePersonRequest): Observable<PersonDto> {
        let url_ = this.baseUrl + "/api/people/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: string, deleteDto: DeletePersonDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/people/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deleteDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDeleted(searchTerm: string | null | undefined): Observable<DeletedPersonDto[]> {
        let url_ = this.baseUrl + "/api/people/deleted?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeleted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeleted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeletedPersonDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeletedPersonDto[]>;
        }));
    }

    protected processGetDeleted(response: HttpResponseBase): Observable<DeletedPersonDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeletedPersonDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFamilyRelationships(id: string): Observable<PersonFamilyRelationshipsDto> {
        let url_ = this.baseUrl + "/api/people/{id}/family-relationships";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFamilyRelationships(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFamilyRelationships(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonFamilyRelationshipsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonFamilyRelationshipsDto>;
        }));
    }

    protected processGetFamilyRelationships(response: HttpResponseBase): Observable<PersonFamilyRelationshipsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonFamilyRelationshipsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveFamilyRelationships(id: string, dto: SavePersonFamilyRelationshipsDto): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/people/{id}/family-relationships";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveFamilyRelationships(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveFamilyRelationships(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSaveFamilyRelationships(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getResponsiblePriestCandidates(id: string): Observable<ResponsiblePriestCandidateDto[]> {
        let url_ = this.baseUrl + "/api/people/{id}/responsible-priest-candidates";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetResponsiblePriestCandidates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetResponsiblePriestCandidates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponsiblePriestCandidateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponsiblePriestCandidateDto[]>;
        }));
    }

    protected processGetResponsiblePriestCandidates(response: HttpResponseBase): Observable<ResponsiblePriestCandidateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResponsiblePriestCandidateDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getResponsiblePriestCandidatesByUnit(unitId: string | undefined): Observable<ResponsiblePriestCandidateDto[]> {
        let url_ = this.baseUrl + "/api/people/responsible-priest-candidates?";
        if (unitId === null)
            throw new globalThis.Error("The parameter 'unitId' cannot be null.");
        else if (unitId !== undefined)
            url_ += "unitId=" + encodeURIComponent("" + unitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetResponsiblePriestCandidatesByUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetResponsiblePriestCandidatesByUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponsiblePriestCandidateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponsiblePriestCandidateDto[]>;
        }));
    }

    protected processGetResponsiblePriestCandidatesByUnit(response: HttpResponseBase): Observable<ResponsiblePriestCandidateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResponsiblePriestCandidateDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTrustedMembers(id: string): Observable<ResponsiblePriestMemberDto[]> {
        let url_ = this.baseUrl + "/api/people/{id}/trusted-members";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrustedMembers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrustedMembers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponsiblePriestMemberDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponsiblePriestMemberDto[]>;
        }));
    }

    protected processGetTrustedMembers(response: HttpResponseBase): Observable<ResponsiblePriestMemberDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResponsiblePriestMemberDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateResponsiblePriest(id: string, dto: UpdateResponsiblePriestDto): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/people/{id}/responsible-priest";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateResponsiblePriest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateResponsiblePriest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processUpdateResponsiblePriest(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkUpdateResponsiblePriest(dto: BulkUpdateResponsiblePriestDto): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/people/responsible-priest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkUpdateResponsiblePriest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkUpdateResponsiblePriest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processBulkUpdateResponsiblePriest(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEvents(id: string, kind: string | null | undefined): Observable<PersonEventDto[]> {
        let url_ = this.baseUrl + "/api/people/{id}/events?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (kind !== undefined && kind !== null)
            url_ += "kind=" + encodeURIComponent("" + kind) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonEventDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonEventDto[]>;
        }));
    }

    protected processGetEvents(response: HttpResponseBase): Observable<PersonEventDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonEventDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createEvent(id: string, dto: CreatePersonEventDto): Observable<number> {
        let url_ = this.baseUrl + "/api/people/{id}/events";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateEvent(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMinisterialActivityEffectiveState(id: string, effectiveDate: string | undefined, excludeEventId: number | null | undefined): Observable<MinisterialActivityEffectiveStateDto> {
        let url_ = this.baseUrl + "/api/people/{id}/ministerial-activity/effective-state?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (effectiveDate === null)
            throw new globalThis.Error("The parameter 'effectiveDate' cannot be null.");
        else if (effectiveDate !== undefined)
            url_ += "effectiveDate=" + encodeURIComponent("" + effectiveDate) + "&";
        if (excludeEventId !== undefined && excludeEventId !== null)
            url_ += "excludeEventId=" + encodeURIComponent("" + excludeEventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMinisterialActivityEffectiveState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMinisterialActivityEffectiveState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MinisterialActivityEffectiveStateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MinisterialActivityEffectiveStateDto>;
        }));
    }

    protected processGetMinisterialActivityEffectiveState(response: HttpResponseBase): Observable<MinisterialActivityEffectiveStateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MinisterialActivityEffectiveStateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMinisterialActivityActions(): Observable<MinisterialActivityActionDefinitionDto[]> {
        let url_ = this.baseUrl + "/api/people/ministerial-activity/actions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMinisterialActivityActions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMinisterialActivityActions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MinisterialActivityActionDefinitionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MinisterialActivityActionDefinitionDto[]>;
        }));
    }

    protected processGetMinisterialActivityActions(response: HttpResponseBase): Observable<MinisterialActivityActionDefinitionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MinisterialActivityActionDefinitionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCommunityHistory(id: string): Observable<PersonCommunityHistoryDto[]> {
        let url_ = this.baseUrl + "/api/people/{id}/community-history";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommunityHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommunityHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonCommunityHistoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonCommunityHistoryDto[]>;
        }));
    }

    protected processGetCommunityHistory(response: HttpResponseBase): Observable<PersonCommunityHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonCommunityHistoryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createCommunityHistory(id: string, dto: CreatePersonCommunityHistoryDto): Observable<void> {
        let url_ = this.baseUrl + "/api/people/{id}/community-history";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCommunityHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCommunityHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateCommunityHistory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    validateCommunityTransferDate(id: string, dto: ValidateCommunityTransferDateDto): Observable<void> {
        let url_ = this.baseUrl + "/api/people/{id}/community-transfer/validate-date";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateCommunityTransferDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateCommunityTransferDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValidateCommunityTransferDate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDivineServiceAttendance(id: string, take: number | undefined): Observable<PersonDivineServiceAttendanceDto[]> {
        let url_ = this.baseUrl + "/api/people/{id}/divine-service-attendance?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDivineServiceAttendance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDivineServiceAttendance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonDivineServiceAttendanceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonDivineServiceAttendanceDto[]>;
        }));
    }

    protected processGetDivineServiceAttendance(response: HttpResponseBase): Observable<PersonDivineServiceAttendanceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonDivineServiceAttendanceDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateCommunityHistory(id: string, historyId: number, dto: UpdatePersonCommunityHistoryDto): Observable<void> {
        let url_ = this.baseUrl + "/api/people/{id}/community-history/{historyId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (historyId === undefined || historyId === null)
            throw new globalThis.Error("The parameter 'historyId' must be defined.");
        url_ = url_.replace("{historyId}", encodeURIComponent("" + historyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCommunityHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCommunityHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCommunityHistory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteCommunityHistory(id: string, historyId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/people/{id}/community-history/{historyId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (historyId === undefined || historyId === null)
            throw new globalThis.Error("The parameter 'historyId' must be defined.");
        url_ = url_.replace("{historyId}", encodeURIComponent("" + historyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCommunityHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCommunityHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCommunityHistory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEventEditorContext(id: string, kind: string): Observable<PersonEventEditorContextDto> {
        let url_ = this.baseUrl + "/api/people/{id}/events/editor-context/{kind}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (kind === undefined || kind === null)
            throw new globalThis.Error("The parameter 'kind' must be defined.");
        url_ = url_.replace("{kind}", encodeURIComponent("" + kind));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEventEditorContext(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventEditorContext(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonEventEditorContextDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonEventEditorContextDto>;
        }));
    }

    protected processGetEventEditorContext(response: HttpResponseBase): Observable<PersonEventEditorContextDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonEventEditorContextDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateEvent(id: string, category: PersonEventCategory, eventId: number, dto: UpdatePersonEventDto): Observable<void> {
        let url_ = this.baseUrl + "/api/people/{id}/events/{category}/{eventId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (category === undefined || category === null)
            throw new globalThis.Error("The parameter 'category' must be defined.");
        url_ = url_.replace("{category}", encodeURIComponent("" + category));
        if (eventId === undefined || eventId === null)
            throw new globalThis.Error("The parameter 'eventId' must be defined.");
        url_ = url_.replace("{eventId}", encodeURIComponent("" + eventId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateEvent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteEvent(id: string, category: PersonEventCategory, eventId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/people/{id}/events/{category}/{eventId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (category === undefined || category === null)
            throw new globalThis.Error("The parameter 'category' must be defined.");
        url_ = url_.replace("{category}", encodeURIComponent("" + category));
        if (eventId === undefined || eventId === null)
            throw new globalThis.Error("The parameter 'eventId' must be defined.");
        url_ = url_.replace("{eventId}", encodeURIComponent("" + eventId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteEvent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createMinisterialActivityEvent(id: string, dto: CreateMinisterialActivityEventDto): Observable<number> {
        let url_ = this.baseUrl + "/api/people/{id}/ministerial-activity/events";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMinisterialActivityEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMinisterialActivityEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateMinisterialActivityEvent(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createOfficiantCollaboration(id: string, dto: CreateOfficiantCollaborationDto): Observable<number> {
        let url_ = this.baseUrl + "/api/people/{id}/ministerial-activity/officiant-collaboration";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOfficiantCollaboration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOfficiantCollaboration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateOfficiantCollaboration(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateOfficiantCollaboration(id: string, activityId: number, dto: CreateOfficiantCollaborationDto): Observable<void> {
        let url_ = this.baseUrl + "/api/people/{id}/ministerial-activity/officiant-collaboration/{activityId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOfficiantCollaboration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOfficiantCollaboration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOfficiantCollaboration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteOfficiantCollaboration(id: string, activityId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/people/{id}/ministerial-activity/officiant-collaboration/{activityId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOfficiantCollaboration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOfficiantCollaboration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteOfficiantCollaboration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    previewMinisterialActivityTransition(id: string, excludeEventId: number | null | undefined, dto: CreateMinisterialActivityEventDto): Observable<MinisterialActivityTransitionPreviewDto> {
        let url_ = this.baseUrl + "/api/people/{id}/ministerial-activity/preview?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (excludeEventId !== undefined && excludeEventId !== null)
            url_ += "excludeEventId=" + encodeURIComponent("" + excludeEventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreviewMinisterialActivityTransition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreviewMinisterialActivityTransition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MinisterialActivityTransitionPreviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MinisterialActivityTransitionPreviewDto>;
        }));
    }

    protected processPreviewMinisterialActivityTransition(response: HttpResponseBase): Observable<MinisterialActivityTransitionPreviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MinisterialActivityTransitionPreviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateMinisterialActivityEvent(id: string, eventId: number, dto: CreateMinisterialActivityEventDto): Observable<void> {
        let url_ = this.baseUrl + "/api/people/{id}/ministerial-activity/events/{eventId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (eventId === undefined || eventId === null)
            throw new globalThis.Error("The parameter 'eventId' must be defined.");
        url_ = url_.replace("{eventId}", encodeURIComponent("" + eventId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMinisterialActivityEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMinisterialActivityEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateMinisterialActivityEvent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createMinistryActivity(id: string, dto: CreatePersonMinistryActivityDto): Observable<number> {
        let url_ = this.baseUrl + "/api/people/{id}/ministry-activities";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMinistryActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMinistryActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateMinistryActivity(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    endMinistryActivity(id: string, activityId: number, dto: EndPersonMinistryActivityDto): Observable<void> {
        let url_ = this.baseUrl + "/api/people/{id}/ministry-activities/{activityId}/end";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEndMinistryActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEndMinistryActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEndMinistryActivity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createAppointment(id: string, dto: CreatePersonMinistryAppointmentDto): Observable<number> {
        let url_ = this.baseUrl + "/api/people/{id}/appointments";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAppointment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAppointment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateAppointment(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAppointment(id: string, appointmentEventId: number, dto: UpdatePersonMinistryAppointmentDto): Observable<void> {
        let url_ = this.baseUrl + "/api/people/{id}/appointments/{appointmentEventId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (appointmentEventId === undefined || appointmentEventId === null)
            throw new globalThis.Error("The parameter 'appointmentEventId' must be defined.");
        url_ = url_.replace("{appointmentEventId}", encodeURIComponent("" + appointmentEventId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAppointment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAppointment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAppointment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteAppointment(id: string, appointmentEventId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/people/{id}/appointments/{appointmentEventId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (appointmentEventId === undefined || appointmentEventId === null)
            throw new globalThis.Error("The parameter 'appointmentEventId' must be defined.");
        url_ = url_.replace("{appointmentEventId}", encodeURIComponent("" + appointmentEventId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAppointment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAppointment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAppointment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createAssignment(id: string, dto: CreatePersonAssignmentDto): Observable<number> {
        let url_ = this.baseUrl + "/api/people/{id}/assignments";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAssignment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateAssignment(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transferCommunity(id: string, dto: TransferPersonCommunityDto): Observable<void> {
        let url_ = this.baseUrl + "/api/people/{id}/community-transfer";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransferCommunity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransferCommunity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTransferCommunity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAssignment(id: string, assignmentEventId: number, dto: UpdatePersonAssignmentDto): Observable<void> {
        let url_ = this.baseUrl + "/api/people/{id}/assignments/{assignmentEventId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (assignmentEventId === undefined || assignmentEventId === null)
            throw new globalThis.Error("The parameter 'assignmentEventId' must be defined.");
        url_ = url_.replace("{assignmentEventId}", encodeURIComponent("" + assignmentEventId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAssignment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAssignment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteAssignment(id: string, assignmentEventId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/people/{id}/assignments/{assignmentEventId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (assignmentEventId === undefined || assignmentEventId === null)
            throw new globalThis.Error("The parameter 'assignmentEventId' must be defined.");
        url_ = url_.replace("{assignmentEventId}", encodeURIComponent("" + assignmentEventId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAssignment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAssignment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateStatus(id: string, request: UpdatePersonStatusDto): Observable<PersonDto> {
        let url_ = this.baseUrl + "/api/people/{id}/status";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonDto>;
        }));
    }

    protected processUpdateStatus(response: HttpResponseBase): Observable<PersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    restore(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/people/{id}/restore";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRestore(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    permanentlyDelete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/people/{id}/permanent";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPermanentlyDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPermanentlyDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPermanentlyDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    permanentlyDeleteBulk(ids: string[]): Observable<void> {
        let url_ = this.baseUrl + "/api/people/permanent/bulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPermanentlyDeleteBulk(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPermanentlyDeleteBulk(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPermanentlyDeleteBulk(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    calculateAgeStatus(birthDate: string | undefined): Observable<PersonAgeStatus> {
        let url_ = this.baseUrl + "/api/people/calculate-age-status?";
        if (birthDate === null)
            throw new globalThis.Error("The parameter 'birthDate' cannot be null.");
        else if (birthDate !== undefined)
            url_ += "birthDate=" + encodeURIComponent("" + birthDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateAgeStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateAgeStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonAgeStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonAgeStatus>;
        }));
    }

    protected processCalculateAgeStatus(response: HttpResponseBase): Observable<PersonAgeStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAuthorizedUnits(): Observable<OrganizationUnitDto[]> {
        let url_ = this.baseUrl + "/api/people/authorized-units";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthorizedUnits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthorizedUnits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto[]>;
        }));
    }

    protected processGetAuthorizedUnits(response: HttpResponseBase): Observable<OrganizationUnitDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationUnitDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCommunityTransferTargets(personId: string): Observable<OrganizationUnitDto[]> {
        let url_ = this.baseUrl + "/api/people/{personId}/community-transfer-targets";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommunityTransferTargets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommunityTransferTargets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto[]>;
        }));
    }

    protected processGetCommunityTransferTargets(response: HttpResponseBase): Observable<OrganizationUnitDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationUnitDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PhotosClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    personInfo(id: string): Observable<PhotoState> {
        let url_ = this.baseUrl + "/api/people/{id}/photo/info";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPersonInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPersonInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhotoState>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhotoState>;
        }));
    }

    protected processPersonInfo(response: HttpResponseBase): Observable<PhotoState> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhotoState.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    gallery(id: string): Observable<PhotoState> {
        let url_ = this.baseUrl + "/api/OrganizationUnit/{id}/photos";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGallery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGallery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhotoState>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhotoState>;
        }));
    }

    protected processGallery(response: HttpResponseBase): Observable<PhotoState> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhotoState.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    unitUpload(id: string, file: FileParameter | null | undefined, revision: string | undefined, cropX: number | null | undefined, cropY: number | null | undefined, cropSize: number | null | undefined): Observable<PhotoState> {
        let url_ = this.baseUrl + "/api/OrganizationUnit/{id}/photos";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (revision === null || revision === undefined)
            throw new globalThis.Error("The parameter 'revision' cannot be null.");
        else
            content_.append("Revision", revision.toString());
        if (cropX !== null && cropX !== undefined)
            content_.append("CropX", cropX.toString());
        if (cropY !== null && cropY !== undefined)
            content_.append("CropY", cropY.toString());
        if (cropSize !== null && cropSize !== undefined)
            content_.append("CropSize", cropSize.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnitUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnitUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhotoState>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhotoState>;
        }));
    }

    protected processUnitUpload(response: HttpResponseBase): Observable<PhotoState> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhotoState.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changeGallery(id: string, change: PhotoGalleryChange): Observable<PhotoState> {
        let url_ = this.baseUrl + "/api/OrganizationUnit/{id}/photos";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(change);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeGallery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeGallery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhotoState>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhotoState>;
        }));
    }

    protected processChangeGallery(response: HttpResponseBase): Observable<PhotoState> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhotoState.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    personContent(id: string, variant: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/people/{id}/photo?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (variant === null)
            throw new globalThis.Error("The parameter 'variant' cannot be null.");
        else if (variant !== undefined)
            url_ += "variant=" + encodeURIComponent("" + variant) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPersonContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPersonContent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPersonContent(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    personUpload(id: string, file: FileParameter | null | undefined, revision: string | undefined, cropX: number | null | undefined, cropY: number | null | undefined, cropSize: number | null | undefined): Observable<PhotoState> {
        let url_ = this.baseUrl + "/api/people/{id}/photo";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (revision === null || revision === undefined)
            throw new globalThis.Error("The parameter 'revision' cannot be null.");
        else
            content_.append("Revision", revision.toString());
        if (cropX !== null && cropX !== undefined)
            content_.append("CropX", cropX.toString());
        if (cropY !== null && cropY !== undefined)
            content_.append("CropY", cropY.toString());
        if (cropSize !== null && cropSize !== undefined)
            content_.append("CropSize", cropSize.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPersonUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPersonUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhotoState>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhotoState>;
        }));
    }

    protected processPersonUpload(response: HttpResponseBase): Observable<PhotoState> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhotoState.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    personDelete(id: string, revision: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/people/{id}/photo";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "X-Photo-Revision": revision !== undefined && revision !== null ? "" + revision : "",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPersonDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPersonDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPersonDelete(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    unitContent(id: string, photoId: string, variant: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/OrganizationUnit/{id}/photos/{photoId}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (photoId === undefined || photoId === null)
            throw new globalThis.Error("The parameter 'photoId' must be defined.");
        url_ = url_.replace("{photoId}", encodeURIComponent("" + photoId));
        if (variant === null)
            throw new globalThis.Error("The parameter 'variant' cannot be null.");
        else if (variant !== undefined)
            url_ += "variant=" + encodeURIComponent("" + variant) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnitContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnitContent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processUnitContent(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    unitReplace(id: string, photoId: string, file: FileParameter | null | undefined, revision: string | undefined, cropX: number | null | undefined, cropY: number | null | undefined, cropSize: number | null | undefined): Observable<PhotoState> {
        let url_ = this.baseUrl + "/api/OrganizationUnit/{id}/photos/{photoId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (photoId === undefined || photoId === null)
            throw new globalThis.Error("The parameter 'photoId' must be defined.");
        url_ = url_.replace("{photoId}", encodeURIComponent("" + photoId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (revision === null || revision === undefined)
            throw new globalThis.Error("The parameter 'revision' cannot be null.");
        else
            content_.append("Revision", revision.toString());
        if (cropX !== null && cropX !== undefined)
            content_.append("CropX", cropX.toString());
        if (cropY !== null && cropY !== undefined)
            content_.append("CropY", cropY.toString());
        if (cropSize !== null && cropSize !== undefined)
            content_.append("CropSize", cropSize.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnitReplace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnitReplace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhotoState>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhotoState>;
        }));
    }

    protected processUnitReplace(response: HttpResponseBase): Observable<PhotoState> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhotoState.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    unitDelete(id: string, photoId: string, revision: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/OrganizationUnit/{id}/photos/{photoId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (photoId === undefined || photoId === null)
            throw new globalThis.Error("The parameter 'photoId' must be defined.");
        url_ = url_.replace("{photoId}", encodeURIComponent("" + photoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "X-Photo-Revision": revision !== undefined && revision !== null ? "" + revision : "",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnitDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnitDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processUnitDelete(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importPreview(batchId: string): Observable<PortalPhotoPreview[]> {
        let url_ = this.baseUrl + "/api/portal-member-imports/{batchId}/photos";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PortalPhotoPreview[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PortalPhotoPreview[]>;
        }));
    }

    protected processImportPreview(response: HttpResponseBase): Observable<PortalPhotoPreview[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PortalPhotoPreview.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importContent(assetId: string, variant: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/portal-member-imports/photos/{assetId}?";
        if (assetId === undefined || assetId === null)
            throw new globalThis.Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        if (variant === null)
            throw new globalThis.Error("The parameter 'variant' cannot be null.");
        else if (variant !== undefined)
            url_ += "variant=" + encodeURIComponent("" + variant) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportContent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processImportContent(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PortalMemberImportsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getEquivalences(): Observable<PortalImportEquivalenceDto[]> {
        let url_ = this.baseUrl + "/api/portal-member-imports/equivalences";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEquivalences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEquivalences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PortalImportEquivalenceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PortalImportEquivalenceDto[]>;
        }));
    }

    protected processGetEquivalences(response: HttpResponseBase): Observable<PortalImportEquivalenceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PortalImportEquivalenceDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveEquivalence(request: SavePortalImportEquivalenceRequest): Observable<PortalImportEquivalenceDto> {
        let url_ = this.baseUrl + "/api/portal-member-imports/equivalences";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveEquivalence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveEquivalence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PortalImportEquivalenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PortalImportEquivalenceDto>;
        }));
    }

    protected processSaveEquivalence(response: HttpResponseBase): Observable<PortalImportEquivalenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PortalImportEquivalenceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateEquivalence(id: number, request: SavePortalImportEquivalenceRequest): Observable<PortalImportEquivalenceDto> {
        let url_ = this.baseUrl + "/api/portal-member-imports/equivalences/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEquivalence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEquivalence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PortalImportEquivalenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PortalImportEquivalenceDto>;
        }));
    }

    protected processUpdateEquivalence(response: HttpResponseBase): Observable<PortalImportEquivalenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PortalImportEquivalenceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteEquivalence(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/portal-member-imports/equivalences/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEquivalence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEquivalence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeleteEquivalence(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getHistory(): Observable<PortalImportHistoryItemDto[]> {
        let url_ = this.baseUrl + "/api/portal-member-imports/history";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PortalImportHistoryItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PortalImportHistoryItemDto[]>;
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<PortalImportHistoryItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PortalImportHistoryItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getHistoryDetail(batchId: string): Observable<PortalImportHistoryDetailDto> {
        let url_ = this.baseUrl + "/api/portal-member-imports/history/{batchId}";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistoryDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistoryDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PortalImportHistoryDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PortalImportHistoryDetailDto>;
        }));
    }

    protected processGetHistoryDetail(response: HttpResponseBase): Observable<PortalImportHistoryDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PortalImportHistoryDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSourceJson(batchId: string): Observable<PortalImportSourceJsonDto> {
        let url_ = this.baseUrl + "/api/portal-member-imports/history/{batchId}/source-json";
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSourceJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSourceJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PortalImportSourceJsonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PortalImportSourceJsonDto>;
        }));
    }

    protected processGetSourceJson(response: HttpResponseBase): Observable<PortalImportSourceJsonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PortalImportSourceJsonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    previewCommunityJson(file: FileParameter | null | undefined): Observable<PortalMemberImportPreviewDto> {
        let url_ = this.baseUrl + "/api/portal-member-imports/json/preview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreviewCommunityJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreviewCommunityJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PortalMemberImportPreviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PortalMemberImportPreviewDto>;
        }));
    }

    protected processPreviewCommunityJson(response: HttpResponseBase): Observable<PortalMemberImportPreviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PortalMemberImportPreviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importCommunityJson(request: PortalMemberImportRequest): Observable<PortalMemberImportResultDto> {
        let url_ = this.baseUrl + "/api/portal-member-imports/json";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportCommunityJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportCommunityJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PortalMemberImportResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PortalMemberImportResultDto>;
        }));
    }

    protected processImportCommunityJson(response: HttpResponseBase): Observable<PortalMemberImportResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PortalMemberImportResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importCommunityJsonWithProgress(request: PortalMemberImportRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/portal-member-imports/json/stream";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportCommunityJsonWithProgress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportCommunityJsonWithProgress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportCommunityJsonWithProgress(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    preview(file: FileParameter | null | undefined): Observable<PortalMemberImportPreviewDto> {
        let url_ = this.baseUrl + "/api/portal-member-imports/preview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PortalMemberImportPreviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PortalMemberImportPreviewDto>;
        }));
    }

    protected processPreview(response: HttpResponseBase): Observable<PortalMemberImportPreviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PortalMemberImportPreviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    import(request: PortalMemberImportRequest): Observable<PortalMemberImportResultDto> {
        let url_ = this.baseUrl + "/api/portal-member-imports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PortalMemberImportResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PortalMemberImportResultDto>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<PortalMemberImportResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PortalMemberImportResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importWithProgress(request: PortalMemberImportRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/portal-member-imports/stream";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportWithProgress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportWithProgress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportWithProgress(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SearchClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    search(term: string | null | undefined, types: string[] | null | undefined, limitPerType: number | undefined, includeInitialResults: boolean | undefined, eligibilityDate: string | null | undefined): Observable<GlobalSearchResponseDto> {
        let url_ = this.baseUrl + "/api/search?";
        if (term !== undefined && term !== null)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        if (types !== undefined && types !== null)
            types && types.forEach(item => { url_ += "types=" + encodeURIComponent("" + item) + "&"; });
        if (limitPerType === null)
            throw new globalThis.Error("The parameter 'limitPerType' cannot be null.");
        else if (limitPerType !== undefined)
            url_ += "limitPerType=" + encodeURIComponent("" + limitPerType) + "&";
        if (includeInitialResults === null)
            throw new globalThis.Error("The parameter 'includeInitialResults' cannot be null.");
        else if (includeInitialResults !== undefined)
            url_ += "includeInitialResults=" + encodeURIComponent("" + includeInitialResults) + "&";
        if (eligibilityDate !== undefined && eligibilityDate !== null)
            url_ += "eligibilityDate=" + encodeURIComponent("" + eligibilityDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GlobalSearchResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GlobalSearchResponseDto>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<GlobalSearchResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GlobalSearchResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SpiritualAssistanceVisitsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    preview(request: CreateSpiritualAssistanceVisitRequest): Observable<SpiritualAssistanceVisitGroupDto[]> {
        let url_ = this.baseUrl + "/api/spiritual-assistance-visits/preview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpiritualAssistanceVisitGroupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpiritualAssistanceVisitGroupDto[]>;
        }));
    }

    protected processPreview(response: HttpResponseBase): Observable<SpiritualAssistanceVisitGroupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SpiritualAssistanceVisitGroupDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(request: CreateSpiritualAssistanceVisitRequest): Observable<SpiritualAssistanceVisitCreatedDto> {
        let url_ = this.baseUrl + "/api/spiritual-assistance-visits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpiritualAssistanceVisitCreatedDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpiritualAssistanceVisitCreatedDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<SpiritualAssistanceVisitCreatedDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = SpiritualAssistanceVisitCreatedDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getList(organizationUnitId: string | null | undefined, from: string | null | undefined, to: string | null | undefined, recipientId: string | null | undefined, visitorId: string | null | undefined, holyCommunionDelivered: boolean | null | undefined): Observable<SpiritualAssistanceVisitListItemDto[]> {
        let url_ = this.baseUrl + "/api/spiritual-assistance-visits?";
        if (organizationUnitId !== undefined && organizationUnitId !== null)
            url_ += "organizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        if (recipientId !== undefined && recipientId !== null)
            url_ += "recipientId=" + encodeURIComponent("" + recipientId) + "&";
        if (visitorId !== undefined && visitorId !== null)
            url_ += "visitorId=" + encodeURIComponent("" + visitorId) + "&";
        if (holyCommunionDelivered !== undefined && holyCommunionDelivered !== null)
            url_ += "holyCommunionDelivered=" + encodeURIComponent("" + holyCommunionDelivered) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpiritualAssistanceVisitListItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpiritualAssistanceVisitListItemDto[]>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<SpiritualAssistanceVisitListItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SpiritualAssistanceVisitListItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(id: string, request: CreateSpiritualAssistanceVisitRequest): Observable<SpiritualAssistanceVisitDetailDto> {
        let url_ = this.baseUrl + "/api/spiritual-assistance-visits/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpiritualAssistanceVisitDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpiritualAssistanceVisitDetailDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<SpiritualAssistanceVisitDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SpiritualAssistanceVisitDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/spiritual-assistance-visits/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(id: string): Observable<SpiritualAssistanceVisitDetailDto> {
        let url_ = this.baseUrl + "/api/spiritual-assistance-visits/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpiritualAssistanceVisitDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpiritualAssistanceVisitDetailDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<SpiritualAssistanceVisitDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SpiritualAssistanceVisitDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAvailableVisitors(searchTerm: string | null | undefined, page: number | undefined, pageSize: number | undefined): Observable<PaginatedResponseOfSpiritualAssistanceVisitVisitorOptionDto> {
        let url_ = this.baseUrl + "/api/spiritual-assistance-visits/available-visitors?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableVisitors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableVisitors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResponseOfSpiritualAssistanceVisitVisitorOptionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResponseOfSpiritualAssistanceVisitVisitorOptionDto>;
        }));
    }

    protected processGetAvailableVisitors(response: HttpResponseBase): Observable<PaginatedResponseOfSpiritualAssistanceVisitVisitorOptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResponseOfSpiritualAssistanceVisitVisitorOptionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMemberSummary(personId: string): Observable<PersonSpiritualAssistanceVisitSummaryDto> {
        let url_ = this.baseUrl + "/api/spiritual-assistance-visits/members/{personId}/summary";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonSpiritualAssistanceVisitSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonSpiritualAssistanceVisitSummaryDto>;
        }));
    }

    protected processGetMemberSummary(response: HttpResponseBase): Observable<PersonSpiritualAssistanceVisitSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonSpiritualAssistanceVisitSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UsersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getIdentityReconciliationReport(): Observable<UserIdentityReconciliationReportDto> {
        let url_ = this.baseUrl + "/api/Users/identity-reconciliation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIdentityReconciliationReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIdentityReconciliationReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserIdentityReconciliationReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserIdentityReconciliationReportDto>;
        }));
    }

    protected processGetIdentityReconciliationReport(response: HttpResponseBase): Observable<UserIdentityReconciliationReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserIdentityReconciliationReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    applyIdentityReconciliation(): Observable<UserIdentityReconciliationReportDto> {
        let url_ = this.baseUrl + "/api/Users/identity-reconciliation/apply";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplyIdentityReconciliation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplyIdentityReconciliation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserIdentityReconciliationReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserIdentityReconciliationReportDto>;
        }));
    }

    protected processApplyIdentityReconciliation(response: HttpResponseBase): Observable<UserIdentityReconciliationReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserIdentityReconciliationReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(searchTerm: string | null | undefined, isActive: boolean | null | undefined, sortBy: string | null | undefined, sortDirection: string | undefined, hasLocalUser: boolean | null | undefined, ministryId: number | null | undefined, ministryUnitId: string | null | undefined, membershipUnitId: string | null | undefined, role: UserRole | null | undefined, roleUnitId: string | null | undefined, page: number | undefined, pageSize: number | undefined): Observable<PaginatedResponseOfIdentityUserDto> {
        let url_ = this.baseUrl + "/api/Users?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (hasLocalUser !== undefined && hasLocalUser !== null)
            url_ += "HasLocalUser=" + encodeURIComponent("" + hasLocalUser) + "&";
        if (ministryId !== undefined && ministryId !== null)
            url_ += "MinistryId=" + encodeURIComponent("" + ministryId) + "&";
        if (ministryUnitId !== undefined && ministryUnitId !== null)
            url_ += "MinistryUnitId=" + encodeURIComponent("" + ministryUnitId) + "&";
        if (membershipUnitId !== undefined && membershipUnitId !== null)
            url_ += "MembershipUnitId=" + encodeURIComponent("" + membershipUnitId) + "&";
        if (role !== undefined && role !== null)
            url_ += "Role=" + encodeURIComponent("" + role) + "&";
        if (roleUnitId !== undefined && roleUnitId !== null)
            url_ += "RoleUnitId=" + encodeURIComponent("" + roleUnitId) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResponseOfIdentityUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResponseOfIdentityUserDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PaginatedResponseOfIdentityUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResponseOfIdentityUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createUser(request: CreateUserRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/Users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    associateMember(id: string, personId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Users/{id}/member";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(personId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssociateMember(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssociateMember(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssociateMember(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createMember(id: string, request: CreatePersonRequest): Observable<string> {
        let url_ = this.baseUrl + "/api/Users/{id}/member";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMember(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMember(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateMember(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return _observableOf(result201);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEligiblePeople(page: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined): Observable<PaginatedResponseOfPeopleListDto> {
        let url_ = this.baseUrl + "/api/Users/eligible-people?";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEligiblePeople(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEligiblePeople(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResponseOfPeopleListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResponseOfPeopleListDto>;
        }));
    }

    protected processGetEligiblePeople(response: HttpResponseBase): Observable<PaginatedResponseOfPeopleListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResponseOfPeopleListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUser(id: string): Observable<UserBasicDto> {
        let url_ = this.baseUrl + "/api/Users/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserBasicDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserBasicDto>;
        }));
    }

    protected processGetUser(response: HttpResponseBase): Observable<UserBasicDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserBasicDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateUserEmail(id: string, email: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Users/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(email);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUserEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteUser(id: string, deleteUserDto: DeleteUserDto): Observable<void> {
        let url_ = this.baseUrl + "/api/Users/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deleteUserDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getActivitySummary(id: string): Observable<UserActivitySummaryDto> {
        let url_ = this.baseUrl + "/api/Users/{id}/activity-summary";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivitySummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivitySummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserActivitySummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserActivitySummaryDto>;
        }));
    }

    protected processGetActivitySummary(response: HttpResponseBase): Observable<UserActivitySummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserActivitySummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getActivity(id: string, actionType: string | null | undefined, from: string | null | undefined, to: string | null | undefined, page: number | undefined, pageSize: number | undefined): Observable<PaginatedResponseOfUserActivityItemDto> {
        let url_ = this.baseUrl + "/api/Users/{id}/activity?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (actionType !== undefined && actionType !== null)
            url_ += "ActionType=" + encodeURIComponent("" + actionType) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent("" + to) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResponseOfUserActivityItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResponseOfUserActivityItemDto>;
        }));
    }

    protected processGetActivity(response: HttpResponseBase): Observable<PaginatedResponseOfUserActivityItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResponseOfUserActivityItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRoleAssignments(id: string): Observable<UserRoleAssignmentDto[]> {
        let url_ = this.baseUrl + "/api/Users/{id}/role-assignments";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleAssignments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleAssignments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserRoleAssignmentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserRoleAssignmentDto[]>;
        }));
    }

    protected processGetRoleAssignments(response: HttpResponseBase): Observable<UserRoleAssignmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserRoleAssignmentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateRoleAssignments(id: string, assignments: UpsertUserRoleAssignmentDto[]): Observable<UserRoleAssignmentDto[]> {
        let url_ = this.baseUrl + "/api/Users/{id}/role-assignments";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assignments);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRoleAssignments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRoleAssignments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserRoleAssignmentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserRoleAssignmentDto[]>;
        }));
    }

    protected processUpdateRoleAssignments(response: HttpResponseBase): Observable<UserRoleAssignmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserRoleAssignmentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateStatus(id: string, status: boolean): Observable<void> {
        let url_ = this.baseUrl + "/api/Users/{id}/status";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(status);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class VersionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(): Observable<VersionResponse> {
        let url_ = this.baseUrl + "/api/version";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VersionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VersionResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<VersionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VersionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class ActivityConfigurationDto implements IActivityConfigurationDto {
    id?: number;
    name?: string;
    description?: string | undefined;
    areaId?: number;
    areaCode?: string;
    areaName?: string;
    allowedOrganizationLevelIds?: number[];
    allowedOrganizationLevelNames?: string[];
    isActive?: boolean;
    roles?: ActivityRoleConfigurationDto[];

    constructor(data?: IActivityConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.areaId = _data["areaId"];
            this.areaCode = _data["areaCode"];
            this.areaName = _data["areaName"];
            if (Array.isArray(_data["allowedOrganizationLevelIds"])) {
                this.allowedOrganizationLevelIds = [] as any;
                for (let item of _data["allowedOrganizationLevelIds"])
                    this.allowedOrganizationLevelIds!.push(item);
            }
            if (Array.isArray(_data["allowedOrganizationLevelNames"])) {
                this.allowedOrganizationLevelNames = [] as any;
                for (let item of _data["allowedOrganizationLevelNames"])
                    this.allowedOrganizationLevelNames!.push(item);
            }
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(ActivityRoleConfigurationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActivityConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["areaId"] = this.areaId;
        data["areaCode"] = this.areaCode;
        data["areaName"] = this.areaName;
        if (Array.isArray(this.allowedOrganizationLevelIds)) {
            data["allowedOrganizationLevelIds"] = [];
            for (let item of this.allowedOrganizationLevelIds)
                data["allowedOrganizationLevelIds"].push(item);
        }
        if (Array.isArray(this.allowedOrganizationLevelNames)) {
            data["allowedOrganizationLevelNames"] = [];
            for (let item of this.allowedOrganizationLevelNames)
                data["allowedOrganizationLevelNames"].push(item);
        }
        data["isActive"] = this.isActive;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IActivityConfigurationDto {
    id?: number;
    name?: string;
    description?: string | undefined;
    areaId?: number;
    areaCode?: string;
    areaName?: string;
    allowedOrganizationLevelIds?: number[];
    allowedOrganizationLevelNames?: string[];
    isActive?: boolean;
    roles?: ActivityRoleConfigurationDto[];
}

export class ActivityRoleConfigurationDto implements IActivityRoleConfigurationDto {
    id?: number;
    name?: string;
    shortName?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    isDefault?: boolean;

    constructor(data?: IActivityRoleConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): ActivityRoleConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityRoleConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface IActivityRoleConfigurationDto {
    id?: number;
    name?: string;
    shortName?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    isDefault?: boolean;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class UpsertActivityConfigurationDto implements IUpsertActivityConfigurationDto {
    name?: string;
    description?: string | undefined;
    areaId?: number;
    allowedOrganizationLevelIds?: number[];
    isActive?: boolean;
    roles?: UpsertActivityRoleConfigurationDto[];

    constructor(data?: IUpsertActivityConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.areaId = _data["areaId"];
            if (Array.isArray(_data["allowedOrganizationLevelIds"])) {
                this.allowedOrganizationLevelIds = [] as any;
                for (let item of _data["allowedOrganizationLevelIds"])
                    this.allowedOrganizationLevelIds!.push(item);
            }
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UpsertActivityRoleConfigurationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpsertActivityConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertActivityConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["areaId"] = this.areaId;
        if (Array.isArray(this.allowedOrganizationLevelIds)) {
            data["allowedOrganizationLevelIds"] = [];
            for (let item of this.allowedOrganizationLevelIds)
                data["allowedOrganizationLevelIds"].push(item);
        }
        data["isActive"] = this.isActive;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpsertActivityConfigurationDto {
    name?: string;
    description?: string | undefined;
    areaId?: number;
    allowedOrganizationLevelIds?: number[];
    isActive?: boolean;
    roles?: UpsertActivityRoleConfigurationDto[];
}

export class UpsertActivityRoleConfigurationDto implements IUpsertActivityRoleConfigurationDto {
    id?: number | undefined;
    name?: string;
    shortName?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    isDefault?: boolean;

    constructor(data?: IUpsertActivityRoleConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): UpsertActivityRoleConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertActivityRoleConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface IUpsertActivityRoleConfigurationDto {
    id?: number | undefined;
    name?: string;
    shortName?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    isDefault?: boolean;
}

export class AreaDto implements IAreaDto {
    id?: number;
    code?: string;
    name?: string;
    sortOrder?: number;
    isActive?: boolean;

    constructor(data?: IAreaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): AreaDto {
        data = typeof data === 'object' ? data : {};
        let result = new AreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IAreaDto {
    id?: number;
    code?: string;
    name?: string;
    sortOrder?: number;
    isActive?: boolean;
}

export class CreateAreaDto implements ICreateAreaDto {
    name?: string;
    isActive?: boolean;

    constructor(data?: ICreateAreaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateAreaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICreateAreaDto {
    name?: string;
    isActive?: boolean;
}

export class UpdateAreaDto implements IUpdateAreaDto {
    name?: string;
    sortOrder?: number;
    isActive?: boolean;

    constructor(data?: IUpdateAreaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateAreaDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUpdateAreaDto {
    name?: string;
    sortOrder?: number;
    isActive?: boolean;
}

export class UpdateAreaSortOrderDto implements IUpdateAreaSortOrderDto {
    ids?: number[];

    constructor(data?: IUpdateAreaSortOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateAreaSortOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAreaSortOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface IUpdateAreaSortOrderDto {
    ids?: number[];
}

export class AssignmentDto implements IAssignmentDto {
    id?: number;
    name?: string;
    areaId?: number;
    areaCode?: string;
    areaName?: string;
    sortOrder?: number;
    isActive?: boolean;
    requiresActiveMinistry?: boolean;
    allowedOrganizationLevelIds?: number[];
    allowedOrganizationLevelNames?: string[];

    constructor(data?: IAssignmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.areaId = _data["areaId"];
            this.areaCode = _data["areaCode"];
            this.areaName = _data["areaName"];
            this.sortOrder = _data["sortOrder"];
            this.isActive = _data["isActive"];
            this.requiresActiveMinistry = _data["requiresActiveMinistry"];
            if (Array.isArray(_data["allowedOrganizationLevelIds"])) {
                this.allowedOrganizationLevelIds = [] as any;
                for (let item of _data["allowedOrganizationLevelIds"])
                    this.allowedOrganizationLevelIds!.push(item);
            }
            if (Array.isArray(_data["allowedOrganizationLevelNames"])) {
                this.allowedOrganizationLevelNames = [] as any;
                for (let item of _data["allowedOrganizationLevelNames"])
                    this.allowedOrganizationLevelNames!.push(item);
            }
        }
    }

    static fromJS(data: any): AssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["areaId"] = this.areaId;
        data["areaCode"] = this.areaCode;
        data["areaName"] = this.areaName;
        data["sortOrder"] = this.sortOrder;
        data["isActive"] = this.isActive;
        data["requiresActiveMinistry"] = this.requiresActiveMinistry;
        if (Array.isArray(this.allowedOrganizationLevelIds)) {
            data["allowedOrganizationLevelIds"] = [];
            for (let item of this.allowedOrganizationLevelIds)
                data["allowedOrganizationLevelIds"].push(item);
        }
        if (Array.isArray(this.allowedOrganizationLevelNames)) {
            data["allowedOrganizationLevelNames"] = [];
            for (let item of this.allowedOrganizationLevelNames)
                data["allowedOrganizationLevelNames"].push(item);
        }
        return data;
    }
}

export interface IAssignmentDto {
    id?: number;
    name?: string;
    areaId?: number;
    areaCode?: string;
    areaName?: string;
    sortOrder?: number;
    isActive?: boolean;
    requiresActiveMinistry?: boolean;
    allowedOrganizationLevelIds?: number[];
    allowedOrganizationLevelNames?: string[];
}

export class CreateAssignmentDto implements ICreateAssignmentDto {
    name?: string;
    areaId?: number;
    sortOrder?: number | undefined;
    requiresActiveMinistry?: boolean;
    allowedOrganizationLevelIds?: number[];

    constructor(data?: ICreateAssignmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.areaId = _data["areaId"];
            this.sortOrder = _data["sortOrder"];
            this.requiresActiveMinistry = _data["requiresActiveMinistry"];
            if (Array.isArray(_data["allowedOrganizationLevelIds"])) {
                this.allowedOrganizationLevelIds = [] as any;
                for (let item of _data["allowedOrganizationLevelIds"])
                    this.allowedOrganizationLevelIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["areaId"] = this.areaId;
        data["sortOrder"] = this.sortOrder;
        data["requiresActiveMinistry"] = this.requiresActiveMinistry;
        if (Array.isArray(this.allowedOrganizationLevelIds)) {
            data["allowedOrganizationLevelIds"] = [];
            for (let item of this.allowedOrganizationLevelIds)
                data["allowedOrganizationLevelIds"].push(item);
        }
        return data;
    }
}

export interface ICreateAssignmentDto {
    name?: string;
    areaId?: number;
    sortOrder?: number | undefined;
    requiresActiveMinistry?: boolean;
    allowedOrganizationLevelIds?: number[];
}

export class UpdateAssignmentDto implements IUpdateAssignmentDto {
    name?: string;
    areaId?: number;
    sortOrder?: number;
    isActive?: boolean;
    requiresActiveMinistry?: boolean;
    allowedOrganizationLevelIds?: number[];

    constructor(data?: IUpdateAssignmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.areaId = _data["areaId"];
            this.sortOrder = _data["sortOrder"];
            this.isActive = _data["isActive"];
            this.requiresActiveMinistry = _data["requiresActiveMinistry"];
            if (Array.isArray(_data["allowedOrganizationLevelIds"])) {
                this.allowedOrganizationLevelIds = [] as any;
                for (let item of _data["allowedOrganizationLevelIds"])
                    this.allowedOrganizationLevelIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["areaId"] = this.areaId;
        data["sortOrder"] = this.sortOrder;
        data["isActive"] = this.isActive;
        data["requiresActiveMinistry"] = this.requiresActiveMinistry;
        if (Array.isArray(this.allowedOrganizationLevelIds)) {
            data["allowedOrganizationLevelIds"] = [];
            for (let item of this.allowedOrganizationLevelIds)
                data["allowedOrganizationLevelIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateAssignmentDto {
    name?: string;
    areaId?: number;
    sortOrder?: number;
    isActive?: boolean;
    requiresActiveMinistry?: boolean;
    allowedOrganizationLevelIds?: number[];
}

export class UpdateAssignmentSortOrderDto implements IUpdateAssignmentSortOrderDto {
    sortOrder?: number;

    constructor(data?: IUpdateAssignmentSortOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): UpdateAssignmentSortOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAssignmentSortOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IUpdateAssignmentSortOrderDto {
    sortOrder?: number;
}

export class PersonDetailCatalogDto implements IPersonDetailCatalogDto {
    assignments?: AssignmentCatalogDto[];
    ministries?: any[];
    mistryAppointments?: any[];
    units?: any[];
    documentTypes?: any[];

    constructor(data?: IPersonDetailCatalogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assignments"])) {
                this.assignments = [] as any;
                for (let item of _data["assignments"])
                    this.assignments!.push(AssignmentCatalogDto.fromJS(item));
            }
            if (Array.isArray(_data["ministries"])) {
                this.ministries = [] as any;
                for (let item of _data["ministries"])
                    this.ministries!.push(item);
            }
            if (Array.isArray(_data["mistryAppointments"])) {
                this.mistryAppointments = [] as any;
                for (let item of _data["mistryAppointments"])
                    this.mistryAppointments!.push(item);
            }
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units!.push(item);
            }
            if (Array.isArray(_data["documentTypes"])) {
                this.documentTypes = [] as any;
                for (let item of _data["documentTypes"])
                    this.documentTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): PersonDetailCatalogDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonDetailCatalogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assignments)) {
            data["assignments"] = [];
            for (let item of this.assignments)
                data["assignments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.ministries)) {
            data["ministries"] = [];
            for (let item of this.ministries)
                data["ministries"].push(item);
        }
        if (Array.isArray(this.mistryAppointments)) {
            data["mistryAppointments"] = [];
            for (let item of this.mistryAppointments)
                data["mistryAppointments"].push(item);
        }
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item);
        }
        if (Array.isArray(this.documentTypes)) {
            data["documentTypes"] = [];
            for (let item of this.documentTypes)
                data["documentTypes"].push(item);
        }
        return data;
    }
}

export interface IPersonDetailCatalogDto {
    assignments?: AssignmentCatalogDto[];
    ministries?: any[];
    mistryAppointments?: any[];
    units?: any[];
    documentTypes?: any[];
}

export class AssignmentCatalogDto implements IAssignmentCatalogDto {
    id?: number;
    name?: string;
    areaId?: number;
    areaCode?: string;
    areaName?: string;

    constructor(data?: IAssignmentCatalogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.areaId = _data["areaId"];
            this.areaCode = _data["areaCode"];
            this.areaName = _data["areaName"];
        }
    }

    static fromJS(data: any): AssignmentCatalogDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignmentCatalogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["areaId"] = this.areaId;
        data["areaCode"] = this.areaCode;
        data["areaName"] = this.areaName;
        return data;
    }
}

export interface IAssignmentCatalogDto {
    id?: number;
    name?: string;
    areaId?: number;
    areaCode?: string;
    areaName?: string;
}

export class DivineServiceTypeDto implements IDivineServiceTypeDto {
    value?: number;
    name?: string;
    displayName?: string;
    offeringRequired?: boolean;

    constructor(data?: IDivineServiceTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.offeringRequired = _data["offeringRequired"];
        }
    }

    static fromJS(data: any): DivineServiceTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DivineServiceTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["offeringRequired"] = this.offeringRequired;
        return data;
    }
}

export interface IDivineServiceTypeDto {
    value?: number;
    name?: string;
    displayName?: string;
    offeringRequired?: boolean;
}

export class CountryDto implements ICountryDto {
    id?: number;
    name?: string;
    iso2Code?: string;
    iso3Code?: string;

    constructor(data?: ICountryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.iso2Code = _data["iso2Code"];
            this.iso3Code = _data["iso3Code"];
        }
    }

    static fromJS(data: any): CountryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["iso2Code"] = this.iso2Code;
        data["iso3Code"] = this.iso3Code;
        return data;
    }
}

export interface ICountryDto {
    id?: number;
    name?: string;
    iso2Code?: string;
    iso3Code?: string;
}

export class PaginatedResponseOfDivineServiceListDto implements IPaginatedResponseOfDivineServiceListDto {
    items?: DivineServiceListDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResponseOfDivineServiceListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DivineServiceListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfDivineServiceListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfDivineServiceListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedResponseOfDivineServiceListDto {
    items?: DivineServiceListDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class DivineServiceListDto implements IDivineServiceListDto {
    id?: string;
    startAt?: string;
    endAt?: string | undefined;
    notes?: string | undefined;
    bibleText?: string | undefined;
    divineServiceTypeId?: number;
    divineServiceTypeName?: string;
    organizationUnitId?: string;
    organizationUnitName?: string;
    totalAdults?: number;
    totalMinors?: number;
    isClosed?: boolean;
    closedAtUtc?: string | undefined;

    constructor(data?: IDivineServiceListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startAt = _data["startAt"];
            this.endAt = _data["endAt"];
            this.notes = _data["notes"];
            this.bibleText = _data["bibleText"];
            this.divineServiceTypeId = _data["divineServiceTypeId"];
            this.divineServiceTypeName = _data["divineServiceTypeName"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.organizationUnitName = _data["organizationUnitName"];
            this.totalAdults = _data["totalAdults"];
            this.totalMinors = _data["totalMinors"];
            this.isClosed = _data["isClosed"];
            this.closedAtUtc = _data["closedAtUtc"];
        }
    }

    static fromJS(data: any): DivineServiceListDto {
        data = typeof data === 'object' ? data : {};
        let result = new DivineServiceListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startAt"] = this.startAt;
        data["endAt"] = this.endAt;
        data["notes"] = this.notes;
        data["bibleText"] = this.bibleText;
        data["divineServiceTypeId"] = this.divineServiceTypeId;
        data["divineServiceTypeName"] = this.divineServiceTypeName;
        data["organizationUnitId"] = this.organizationUnitId;
        data["organizationUnitName"] = this.organizationUnitName;
        data["totalAdults"] = this.totalAdults;
        data["totalMinors"] = this.totalMinors;
        data["isClosed"] = this.isClosed;
        data["closedAtUtc"] = this.closedAtUtc;
        return data;
    }
}

export interface IDivineServiceListDto {
    id?: string;
    startAt?: string;
    endAt?: string | undefined;
    notes?: string | undefined;
    bibleText?: string | undefined;
    divineServiceTypeId?: number;
    divineServiceTypeName?: string;
    organizationUnitId?: string;
    organizationUnitName?: string;
    totalAdults?: number;
    totalMinors?: number;
    isClosed?: boolean;
    closedAtUtc?: string | undefined;
}

export class DivineServiceDetailDto implements IDivineServiceDetailDto {
    id?: string;
    startAt?: string;
    endAt?: string;
    divineServiceTypeId?: number;
    typeName?: string | undefined;
    bibleText?: string;
    memberInCharge?: string | undefined;
    location?: string | undefined;
    organizationUnitId?: string;
    organizationUnitName?: string | undefined;
    attendeeCount?: number;
    totalMinors?: number;
    totalAdults?: number;
    notes?: string | undefined;
    offeringsARS?: number;
    offeringsUSD?: number;
    visitsMinors?: number;
    visitsAdults?: number;
    newMinors?: number;
    newAdults?: number;
    isClosed?: boolean;
    closedAtUtc?: string | undefined;

    constructor(data?: IDivineServiceDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startAt = _data["startAt"];
            this.endAt = _data["endAt"];
            this.divineServiceTypeId = _data["divineServiceTypeId"];
            this.typeName = _data["typeName"];
            this.bibleText = _data["bibleText"];
            this.memberInCharge = _data["memberInCharge"];
            this.location = _data["location"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.organizationUnitName = _data["organizationUnitName"];
            this.attendeeCount = _data["attendeeCount"];
            this.totalMinors = _data["totalMinors"];
            this.totalAdults = _data["totalAdults"];
            this.notes = _data["notes"];
            this.offeringsARS = _data["offeringsARS"];
            this.offeringsUSD = _data["offeringsUSD"];
            this.visitsMinors = _data["visitsMinors"];
            this.visitsAdults = _data["visitsAdults"];
            this.newMinors = _data["newMinors"];
            this.newAdults = _data["newAdults"];
            this.isClosed = _data["isClosed"];
            this.closedAtUtc = _data["closedAtUtc"];
        }
    }

    static fromJS(data: any): DivineServiceDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new DivineServiceDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startAt"] = this.startAt;
        data["endAt"] = this.endAt;
        data["divineServiceTypeId"] = this.divineServiceTypeId;
        data["typeName"] = this.typeName;
        data["bibleText"] = this.bibleText;
        data["memberInCharge"] = this.memberInCharge;
        data["location"] = this.location;
        data["organizationUnitId"] = this.organizationUnitId;
        data["organizationUnitName"] = this.organizationUnitName;
        data["attendeeCount"] = this.attendeeCount;
        data["totalMinors"] = this.totalMinors;
        data["totalAdults"] = this.totalAdults;
        data["notes"] = this.notes;
        data["offeringsARS"] = this.offeringsARS;
        data["offeringsUSD"] = this.offeringsUSD;
        data["visitsMinors"] = this.visitsMinors;
        data["visitsAdults"] = this.visitsAdults;
        data["newMinors"] = this.newMinors;
        data["newAdults"] = this.newAdults;
        data["isClosed"] = this.isClosed;
        data["closedAtUtc"] = this.closedAtUtc;
        return data;
    }
}

export interface IDivineServiceDetailDto {
    id?: string;
    startAt?: string;
    endAt?: string;
    divineServiceTypeId?: number;
    typeName?: string | undefined;
    bibleText?: string;
    memberInCharge?: string | undefined;
    location?: string | undefined;
    organizationUnitId?: string;
    organizationUnitName?: string | undefined;
    attendeeCount?: number;
    totalMinors?: number;
    totalAdults?: number;
    notes?: string | undefined;
    offeringsARS?: number;
    offeringsUSD?: number;
    visitsMinors?: number;
    visitsAdults?: number;
    newMinors?: number;
    newAdults?: number;
    isClosed?: boolean;
    closedAtUtc?: string | undefined;
}

export class CreateDivineServiceRequest implements ICreateDivineServiceRequest {
    startAt!: string;
    endAt!: string;
    divineServiceTypeId!: number;
    bibleText!: string;
    memberInCharge?: string | undefined;
    location?: string | undefined;
    organizationUnitId!: string;
    totalMinors?: number;
    totalAdults?: number;
    notes?: string | undefined;
    offeringsARS?: number;
    offeringsUSD?: number;
    visitsMinors?: number;
    visitsAdults?: number;
    newMinors?: number;
    newAdults?: number;

    constructor(data?: ICreateDivineServiceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startAt = _data["startAt"];
            this.endAt = _data["endAt"];
            this.divineServiceTypeId = _data["divineServiceTypeId"];
            this.bibleText = _data["bibleText"];
            this.memberInCharge = _data["memberInCharge"];
            this.location = _data["location"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.totalMinors = _data["totalMinors"];
            this.totalAdults = _data["totalAdults"];
            this.notes = _data["notes"];
            this.offeringsARS = _data["offeringsARS"];
            this.offeringsUSD = _data["offeringsUSD"];
            this.visitsMinors = _data["visitsMinors"];
            this.visitsAdults = _data["visitsAdults"];
            this.newMinors = _data["newMinors"];
            this.newAdults = _data["newAdults"];
        }
    }

    static fromJS(data: any): CreateDivineServiceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDivineServiceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startAt"] = this.startAt;
        data["endAt"] = this.endAt;
        data["divineServiceTypeId"] = this.divineServiceTypeId;
        data["bibleText"] = this.bibleText;
        data["memberInCharge"] = this.memberInCharge;
        data["location"] = this.location;
        data["organizationUnitId"] = this.organizationUnitId;
        data["totalMinors"] = this.totalMinors;
        data["totalAdults"] = this.totalAdults;
        data["notes"] = this.notes;
        data["offeringsARS"] = this.offeringsARS;
        data["offeringsUSD"] = this.offeringsUSD;
        data["visitsMinors"] = this.visitsMinors;
        data["visitsAdults"] = this.visitsAdults;
        data["newMinors"] = this.newMinors;
        data["newAdults"] = this.newAdults;
        return data;
    }
}

export interface ICreateDivineServiceRequest {
    startAt: string;
    endAt: string;
    divineServiceTypeId: number;
    bibleText: string;
    memberInCharge?: string | undefined;
    location?: string | undefined;
    organizationUnitId: string;
    totalMinors?: number;
    totalAdults?: number;
    notes?: string | undefined;
    offeringsARS?: number;
    offeringsUSD?: number;
    visitsMinors?: number;
    visitsAdults?: number;
    newMinors?: number;
    newAdults?: number;
}

export class UpdateDivineServiceRequest implements IUpdateDivineServiceRequest {
    startAt!: string;
    endAt!: string;
    divineServiceTypeId!: number;
    bibleText!: string;
    memberInCharge?: string | undefined;
    location?: string | undefined;
    organizationUnitId!: string;
    totalMinors?: number;
    totalAdults?: number;
    notes?: string | undefined;
    offeringsARS?: number;
    offeringsUSD?: number;
    visitsMinors?: number;
    visitsAdults?: number;
    newMinors?: number;
    newAdults?: number;

    constructor(data?: IUpdateDivineServiceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startAt = _data["startAt"];
            this.endAt = _data["endAt"];
            this.divineServiceTypeId = _data["divineServiceTypeId"];
            this.bibleText = _data["bibleText"];
            this.memberInCharge = _data["memberInCharge"];
            this.location = _data["location"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.totalMinors = _data["totalMinors"];
            this.totalAdults = _data["totalAdults"];
            this.notes = _data["notes"];
            this.offeringsARS = _data["offeringsARS"];
            this.offeringsUSD = _data["offeringsUSD"];
            this.visitsMinors = _data["visitsMinors"];
            this.visitsAdults = _data["visitsAdults"];
            this.newMinors = _data["newMinors"];
            this.newAdults = _data["newAdults"];
        }
    }

    static fromJS(data: any): UpdateDivineServiceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDivineServiceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startAt"] = this.startAt;
        data["endAt"] = this.endAt;
        data["divineServiceTypeId"] = this.divineServiceTypeId;
        data["bibleText"] = this.bibleText;
        data["memberInCharge"] = this.memberInCharge;
        data["location"] = this.location;
        data["organizationUnitId"] = this.organizationUnitId;
        data["totalMinors"] = this.totalMinors;
        data["totalAdults"] = this.totalAdults;
        data["notes"] = this.notes;
        data["offeringsARS"] = this.offeringsARS;
        data["offeringsUSD"] = this.offeringsUSD;
        data["visitsMinors"] = this.visitsMinors;
        data["visitsAdults"] = this.visitsAdults;
        data["newMinors"] = this.newMinors;
        data["newAdults"] = this.newAdults;
        return data;
    }
}

export interface IUpdateDivineServiceRequest {
    startAt: string;
    endAt: string;
    divineServiceTypeId: number;
    bibleText: string;
    memberInCharge?: string | undefined;
    location?: string | undefined;
    organizationUnitId: string;
    totalMinors?: number;
    totalAdults?: number;
    notes?: string | undefined;
    offeringsARS?: number;
    offeringsUSD?: number;
    visitsMinors?: number;
    visitsAdults?: number;
    newMinors?: number;
    newAdults?: number;
}

export class OrganizationUnitDto implements IOrganizationUnitDto {
    id?: string;
    photoUrl?: string | undefined;
    name?: string;
    shortName?: string;
    costCentre?: string | undefined;
    description?: string;
    regionalChurchId?: string | undefined;
    regionalChurchName?: string | undefined;
    areaId?: string | undefined;
    areaName?: string | undefined;
    districtId?: string | undefined;
    districtName?: string | undefined;
    organizationLevelId?: number;
    levelName?: string;
    parentUnitId?: string | undefined;
    leaderId?: string | undefined;
    leader?: string;
    leaderMinistryName?: string;
    leaderAppointmentName?: string;
    leaderPhone?: string | undefined;
    detail?: OrganizationUnitDetailDto | undefined;
    ancestorNames?: string[];

    constructor(data?: IOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.photoUrl = _data["photoUrl"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.costCentre = _data["costCentre"];
            this.description = _data["description"];
            this.regionalChurchId = _data["regionalChurchId"];
            this.regionalChurchName = _data["regionalChurchName"];
            this.areaId = _data["areaId"];
            this.areaName = _data["areaName"];
            this.districtId = _data["districtId"];
            this.districtName = _data["districtName"];
            this.organizationLevelId = _data["organizationLevelId"];
            this.levelName = _data["levelName"];
            this.parentUnitId = _data["parentUnitId"];
            this.leaderId = _data["leaderId"];
            this.leader = _data["leader"];
            this.leaderMinistryName = _data["leaderMinistryName"];
            this.leaderAppointmentName = _data["leaderAppointmentName"];
            this.leaderPhone = _data["leaderPhone"];
            this.detail = _data["detail"] ? OrganizationUnitDetailDto.fromJS(_data["detail"]) : undefined as any;
            if (Array.isArray(_data["ancestorNames"])) {
                this.ancestorNames = [] as any;
                for (let item of _data["ancestorNames"])
                    this.ancestorNames!.push(item);
            }
        }
    }

    static fromJS(data: any): OrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["photoUrl"] = this.photoUrl;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["costCentre"] = this.costCentre;
        data["description"] = this.description;
        data["regionalChurchId"] = this.regionalChurchId;
        data["regionalChurchName"] = this.regionalChurchName;
        data["areaId"] = this.areaId;
        data["areaName"] = this.areaName;
        data["districtId"] = this.districtId;
        data["districtName"] = this.districtName;
        data["organizationLevelId"] = this.organizationLevelId;
        data["levelName"] = this.levelName;
        data["parentUnitId"] = this.parentUnitId;
        data["leaderId"] = this.leaderId;
        data["leader"] = this.leader;
        data["leaderMinistryName"] = this.leaderMinistryName;
        data["leaderAppointmentName"] = this.leaderAppointmentName;
        data["leaderPhone"] = this.leaderPhone;
        data["detail"] = this.detail ? this.detail.toJSON() : undefined as any;
        if (Array.isArray(this.ancestorNames)) {
            data["ancestorNames"] = [];
            for (let item of this.ancestorNames)
                data["ancestorNames"].push(item);
        }
        return data;
    }
}

export interface IOrganizationUnitDto {
    id?: string;
    photoUrl?: string | undefined;
    name?: string;
    shortName?: string;
    costCentre?: string | undefined;
    description?: string;
    regionalChurchId?: string | undefined;
    regionalChurchName?: string | undefined;
    areaId?: string | undefined;
    areaName?: string | undefined;
    districtId?: string | undefined;
    districtName?: string | undefined;
    organizationLevelId?: number;
    levelName?: string;
    parentUnitId?: string | undefined;
    leaderId?: string | undefined;
    leader?: string;
    leaderMinistryName?: string;
    leaderAppointmentName?: string;
    leaderPhone?: string | undefined;
    detail?: OrganizationUnitDetailDto | undefined;
    ancestorNames?: string[];
}

export class OrganizationUnitDetailDto implements IOrganizationUnitDetailDto {
    organizationUnitId?: string;
    addressLine?: string | undefined;
    city?: string | undefined;
    department?: string | undefined;
    province?: string | undefined;
    countryId?: number | undefined;
    countryName?: string | undefined;
    postalCode?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    additionalInfo?: string | undefined;

    constructor(data?: IOrganizationUnitDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationUnitId = _data["organizationUnitId"];
            this.addressLine = _data["addressLine"];
            this.city = _data["city"];
            this.department = _data["department"];
            this.province = _data["province"];
            this.countryId = _data["countryId"];
            this.countryName = _data["countryName"];
            this.postalCode = _data["postalCode"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.additionalInfo = _data["additionalInfo"];
        }
    }

    static fromJS(data: any): OrganizationUnitDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitId"] = this.organizationUnitId;
        data["addressLine"] = this.addressLine;
        data["city"] = this.city;
        data["department"] = this.department;
        data["province"] = this.province;
        data["countryId"] = this.countryId;
        data["countryName"] = this.countryName;
        data["postalCode"] = this.postalCode;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["additionalInfo"] = this.additionalInfo;
        return data;
    }
}

export interface IOrganizationUnitDetailDto {
    organizationUnitId?: string;
    addressLine?: string | undefined;
    city?: string | undefined;
    department?: string | undefined;
    province?: string | undefined;
    countryId?: number | undefined;
    countryName?: string | undefined;
    postalCode?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    additionalInfo?: string | undefined;
}

export class PaginatedResponseOfMemberAttendanceDto implements IPaginatedResponseOfMemberAttendanceDto {
    items?: MemberAttendanceDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResponseOfMemberAttendanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MemberAttendanceDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfMemberAttendanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfMemberAttendanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedResponseOfMemberAttendanceDto {
    items?: MemberAttendanceDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class MemberAttendanceDto implements IMemberAttendanceDto {
    personId?: string;
    firstName?: string;
    lastName?: string;
    email?: string | undefined;
    documentNumber?: string | undefined;
    ageStatus?: PersonAgeStatus | undefined;
    isSealed?: boolean;
    attended?: boolean;
    attendanceCategory?: AttendanceCategory;
    isVisitor?: boolean;
    notes?: string | undefined;

    constructor(data?: IMemberAttendanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.documentNumber = _data["documentNumber"];
            this.ageStatus = _data["ageStatus"];
            this.isSealed = _data["isSealed"];
            this.attended = _data["attended"];
            this.attendanceCategory = _data["attendanceCategory"];
            this.isVisitor = _data["isVisitor"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): MemberAttendanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new MemberAttendanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["documentNumber"] = this.documentNumber;
        data["ageStatus"] = this.ageStatus;
        data["isSealed"] = this.isSealed;
        data["attended"] = this.attended;
        data["attendanceCategory"] = this.attendanceCategory;
        data["isVisitor"] = this.isVisitor;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IMemberAttendanceDto {
    personId?: string;
    firstName?: string;
    lastName?: string;
    email?: string | undefined;
    documentNumber?: string | undefined;
    ageStatus?: PersonAgeStatus | undefined;
    isSealed?: boolean;
    attended?: boolean;
    attendanceCategory?: AttendanceCategory;
    isVisitor?: boolean;
    notes?: string | undefined;
}

export type PersonAgeStatus = "Baby" | "PED1" | "PED2" | "ED1" | "ED2" | "ED3" | "ED4" | "ER1" | "ER2" | "ER3" | "AC" | "Youth" | "Adult" | "Senior";

export type AttendanceCategory = "Member" | "Visitor";

export class AttendanceDto implements IAttendanceDto {
    divineServiceId?: string;
    attendees?: PaginatedResponseOfAttendeeDto;

    constructor(data?: IAttendanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.divineServiceId = _data["divineServiceId"];
            this.attendees = _data["attendees"] ? PaginatedResponseOfAttendeeDto.fromJS(_data["attendees"]) : undefined as any;
        }
    }

    static fromJS(data: any): AttendanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["divineServiceId"] = this.divineServiceId;
        data["attendees"] = this.attendees ? this.attendees.toJSON() : undefined as any;
        return data;
    }
}

export interface IAttendanceDto {
    divineServiceId?: string;
    attendees?: PaginatedResponseOfAttendeeDto;
}

export class PaginatedResponseOfAttendeeDto implements IPaginatedResponseOfAttendeeDto {
    items?: AttendeeDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResponseOfAttendeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AttendeeDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfAttendeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfAttendeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedResponseOfAttendeeDto {
    items?: AttendeeDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class AttendeeDto implements IAttendeeDto {
    personId?: string;
    firstName?: string;
    lastName?: string;
    ageStatus?: PersonAgeStatus | undefined;
    attendanceCategory?: AttendanceCategory;
    notes?: string | undefined;

    constructor(data?: IAttendeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.ageStatus = _data["ageStatus"];
            this.attendanceCategory = _data["attendanceCategory"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): AttendeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttendeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["ageStatus"] = this.ageStatus;
        data["attendanceCategory"] = this.attendanceCategory;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IAttendeeDto {
    personId?: string;
    firstName?: string;
    lastName?: string;
    ageStatus?: PersonAgeStatus | undefined;
    attendanceCategory?: AttendanceCategory;
    notes?: string | undefined;
}

export class BulkAttendanceDto implements IBulkAttendanceDto {
    personIds?: string[];
    notes?: string | undefined;

    constructor(data?: IBulkAttendanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["personIds"])) {
                this.personIds = [] as any;
                for (let item of _data["personIds"])
                    this.personIds!.push(item);
            }
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): BulkAttendanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new BulkAttendanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.personIds)) {
            data["personIds"] = [];
            for (let item of this.personIds)
                data["personIds"].push(item);
        }
        data["notes"] = this.notes;
        return data;
    }
}

export interface IBulkAttendanceDto {
    personIds?: string[];
    notes?: string | undefined;
}

export class CreateDivineServiceTypeDto implements ICreateDivineServiceTypeDto {
    name?: string;
    displayName?: string;
    sortOrder?: number | undefined;
    offeringRequired?: boolean;

    constructor(data?: ICreateDivineServiceTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.sortOrder = _data["sortOrder"];
            this.offeringRequired = _data["offeringRequired"];
        }
    }

    static fromJS(data: any): CreateDivineServiceTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDivineServiceTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["sortOrder"] = this.sortOrder;
        data["offeringRequired"] = this.offeringRequired;
        return data;
    }
}

export interface ICreateDivineServiceTypeDto {
    name?: string;
    displayName?: string;
    sortOrder?: number | undefined;
    offeringRequired?: boolean;
}

export class UpdateDivineServiceTypeDto implements IUpdateDivineServiceTypeDto {
    name?: string;
    displayName?: string;
    sortOrder?: number | undefined;
    offeringRequired?: boolean;

    constructor(data?: IUpdateDivineServiceTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.sortOrder = _data["sortOrder"];
            this.offeringRequired = _data["offeringRequired"];
        }
    }

    static fromJS(data: any): UpdateDivineServiceTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDivineServiceTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["sortOrder"] = this.sortOrder;
        data["offeringRequired"] = this.offeringRequired;
        return data;
    }
}

export interface IUpdateDivineServiceTypeDto {
    name?: string;
    displayName?: string;
    sortOrder?: number | undefined;
    offeringRequired?: boolean;
}

export class UpdateDivineServiceTypeSortOrderDto implements IUpdateDivineServiceTypeSortOrderDto {
    ids?: number[];

    constructor(data?: IUpdateDivineServiceTypeSortOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateDivineServiceTypeSortOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDivineServiceTypeSortOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface IUpdateDivineServiceTypeSortOrderDto {
    ids?: number[];
}

export class CreateFeedbackDto implements ICreateFeedbackDto {
    title?: string;
    description?: string;
    type?: FeedbackType;
    priority?: FeedbackPriority;
    sourceModule?: string | undefined;
    appVersion?: string | undefined;
    screenshot?: FeedbackImageDto | undefined;
    attachments?: FeedbackImageDto[];

    constructor(data?: ICreateFeedbackDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.type = _data["type"];
            this.priority = _data["priority"];
            this.sourceModule = _data["sourceModule"];
            this.appVersion = _data["appVersion"];
            this.screenshot = _data["screenshot"] ? FeedbackImageDto.fromJS(_data["screenshot"]) : undefined as any;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(FeedbackImageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateFeedbackDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFeedbackDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["type"] = this.type;
        data["priority"] = this.priority;
        data["sourceModule"] = this.sourceModule;
        data["appVersion"] = this.appVersion;
        data["screenshot"] = this.screenshot ? this.screenshot.toJSON() : undefined as any;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateFeedbackDto {
    title?: string;
    description?: string;
    type?: FeedbackType;
    priority?: FeedbackPriority;
    sourceModule?: string | undefined;
    appVersion?: string | undefined;
    screenshot?: FeedbackImageDto | undefined;
    attachments?: FeedbackImageDto[];
}

export type FeedbackType = "Error" | "Improvement";

export type FeedbackPriority = "Low" | "Medium" | "High" | "VeryLow" | "VeryHigh";

export class FeedbackImageDto implements IFeedbackImageDto {
    fileName?: string;
    contentType?: string;
    data?: string;

    constructor(data?: IFeedbackImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): FeedbackImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["data"] = this.data;
        return data;
    }
}

export interface IFeedbackImageDto {
    fileName?: string;
    contentType?: string;
    data?: string;
}

export class FeedbackPageDtoOfFeedbackListItemDto implements IFeedbackPageDtoOfFeedbackListItemDto {
    items?: FeedbackListItemDto[];
    totalCount?: number;
    page?: number;
    pageSize?: number;

    constructor(data?: IFeedbackPageDtoOfFeedbackListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FeedbackListItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): FeedbackPageDtoOfFeedbackListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackPageDtoOfFeedbackListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IFeedbackPageDtoOfFeedbackListItemDto {
    items?: FeedbackListItemDto[];
    totalCount?: number;
    page?: number;
    pageSize?: number;
}

export class FeedbackListItemDto implements IFeedbackListItemDto {
    id?: number;
    code?: string;
    title?: string;
    type?: FeedbackType;
    status?: FeedbackStatus;
    priority?: FeedbackPriority | undefined;
    createdAtUtc?: string;
    assigneeName?: string | undefined;

    constructor(data?: IFeedbackListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.title = _data["title"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.priority = _data["priority"];
            this.createdAtUtc = _data["createdAtUtc"];
            this.assigneeName = _data["assigneeName"];
        }
    }

    static fromJS(data: any): FeedbackListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["title"] = this.title;
        data["type"] = this.type;
        data["status"] = this.status;
        data["priority"] = this.priority;
        data["createdAtUtc"] = this.createdAtUtc;
        data["assigneeName"] = this.assigneeName;
        return data;
    }
}

export interface IFeedbackListItemDto {
    id?: number;
    code?: string;
    title?: string;
    type?: FeedbackType;
    status?: FeedbackStatus;
    priority?: FeedbackPriority | undefined;
    createdAtUtc?: string;
    assigneeName?: string | undefined;
}

export type FeedbackStatus = "Received" | "Reviewing" | "Planned" | "InProgress" | "Resolved" | "Closed";

export class FeedbackAccessDto implements IFeedbackAccessDto {
    canAccess?: boolean;
    isAdmin?: boolean;
    canPrioritize?: boolean;

    constructor(data?: IFeedbackAccessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canAccess = _data["canAccess"];
            this.isAdmin = _data["isAdmin"];
            this.canPrioritize = _data["canPrioritize"];
        }
    }

    static fromJS(data: any): FeedbackAccessDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackAccessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canAccess"] = this.canAccess;
        data["isAdmin"] = this.isAdmin;
        data["canPrioritize"] = this.canPrioritize;
        return data;
    }
}

export interface IFeedbackAccessDto {
    canAccess?: boolean;
    isAdmin?: boolean;
    canPrioritize?: boolean;
}

export class FeedbackSettingsDto implements IFeedbackSettingsDto {
    isEnabled?: boolean;

    constructor(data?: IFeedbackSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): FeedbackSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IFeedbackSettingsDto {
    isEnabled?: boolean;
}

export class FeedbackTeamUserDto implements IFeedbackTeamUserDto {
    id?: string;
    name?: string;
    canPrioritize?: boolean;

    constructor(data?: IFeedbackTeamUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.canPrioritize = _data["canPrioritize"];
        }
    }

    static fromJS(data: any): FeedbackTeamUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackTeamUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["canPrioritize"] = this.canPrioritize;
        return data;
    }
}

export interface IFeedbackTeamUserDto {
    id?: string;
    name?: string;
    canPrioritize?: boolean;
}

export class SetFeedbackTeamMemberDto implements ISetFeedbackTeamMemberDto {
    isMember?: boolean;

    constructor(data?: ISetFeedbackTeamMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isMember = _data["isMember"];
        }
    }

    static fromJS(data: any): SetFeedbackTeamMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetFeedbackTeamMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isMember"] = this.isMember;
        return data;
    }
}

export interface ISetFeedbackTeamMemberDto {
    isMember?: boolean;
}

export class SetFeedbackPrioritizerDto implements ISetFeedbackPrioritizerDto {
    canPrioritize?: boolean;

    constructor(data?: ISetFeedbackPrioritizerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canPrioritize = _data["canPrioritize"];
        }
    }

    static fromJS(data: any): SetFeedbackPrioritizerDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetFeedbackPrioritizerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canPrioritize"] = this.canPrioritize;
        return data;
    }
}

export interface ISetFeedbackPrioritizerDto {
    canPrioritize?: boolean;
}

export class UpdateFeedbackDto extends CreateFeedbackDto implements IUpdateFeedbackDto {
    status?: FeedbackStatus | undefined;
    resolution?: string | undefined;
    revision?: string;
    removedAttachmentIds?: number[];

    constructor(data?: IUpdateFeedbackDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
            this.resolution = _data["resolution"];
            this.revision = _data["revision"];
            if (Array.isArray(_data["removedAttachmentIds"])) {
                this.removedAttachmentIds = [] as any;
                for (let item of _data["removedAttachmentIds"])
                    this.removedAttachmentIds!.push(item);
            }
        }
    }

    static override fromJS(data: any): UpdateFeedbackDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFeedbackDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["resolution"] = this.resolution;
        data["revision"] = this.revision;
        if (Array.isArray(this.removedAttachmentIds)) {
            data["removedAttachmentIds"] = [];
            for (let item of this.removedAttachmentIds)
                data["removedAttachmentIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateFeedbackDto extends ICreateFeedbackDto {
    status?: FeedbackStatus | undefined;
    resolution?: string | undefined;
    revision?: string;
    removedAttachmentIds?: number[];
}

export class FeedbackAssigneeDto implements IFeedbackAssigneeDto {
    id?: string;
    name?: string;

    constructor(data?: IFeedbackAssigneeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): FeedbackAssigneeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackAssigneeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IFeedbackAssigneeDto {
    id?: string;
    name?: string;
}

export class FeedbackDetailDto extends FeedbackListItemDto implements IFeedbackDetailDto {
    description?: string;
    reporterName?: string | undefined;
    sourceModule?: string | undefined;
    appVersion?: string | undefined;
    assigneeUserId?: string | undefined;
    isPublished?: boolean;
    publishedTitle?: string | undefined;
    publishedSummary?: string | undefined;
    revision?: string;
    entries?: FeedbackEntryDto[];
    attachments?: FeedbackAttachmentDto[];

    constructor(data?: IFeedbackDetailDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.description = _data["description"];
            this.reporterName = _data["reporterName"];
            this.sourceModule = _data["sourceModule"];
            this.appVersion = _data["appVersion"];
            this.assigneeUserId = _data["assigneeUserId"];
            this.isPublished = _data["isPublished"];
            this.publishedTitle = _data["publishedTitle"];
            this.publishedSummary = _data["publishedSummary"];
            this.revision = _data["revision"];
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(FeedbackEntryDto.fromJS(item));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(FeedbackAttachmentDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): FeedbackDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackDetailDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["reporterName"] = this.reporterName;
        data["sourceModule"] = this.sourceModule;
        data["appVersion"] = this.appVersion;
        data["assigneeUserId"] = this.assigneeUserId;
        data["isPublished"] = this.isPublished;
        data["publishedTitle"] = this.publishedTitle;
        data["publishedSummary"] = this.publishedSummary;
        data["revision"] = this.revision;
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IFeedbackDetailDto extends IFeedbackListItemDto {
    description?: string;
    reporterName?: string | undefined;
    sourceModule?: string | undefined;
    appVersion?: string | undefined;
    assigneeUserId?: string | undefined;
    isPublished?: boolean;
    publishedTitle?: string | undefined;
    publishedSummary?: string | undefined;
    revision?: string;
    entries?: FeedbackEntryDto[];
    attachments?: FeedbackAttachmentDto[];
}

export class FeedbackEntryDto implements IFeedbackEntryDto {
    id?: number;
    text?: string;
    isInternal?: boolean;
    isSystem?: boolean;
    createdAtUtc?: string;
    authorLabel?: string;

    constructor(data?: IFeedbackEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            this.isInternal = _data["isInternal"];
            this.isSystem = _data["isSystem"];
            this.createdAtUtc = _data["createdAtUtc"];
            this.authorLabel = _data["authorLabel"];
        }
    }

    static fromJS(data: any): FeedbackEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        data["isInternal"] = this.isInternal;
        data["isSystem"] = this.isSystem;
        data["createdAtUtc"] = this.createdAtUtc;
        data["authorLabel"] = this.authorLabel;
        return data;
    }
}

export interface IFeedbackEntryDto {
    id?: number;
    text?: string;
    isInternal?: boolean;
    isSystem?: boolean;
    createdAtUtc?: string;
    authorLabel?: string;
}

export class FeedbackAttachmentDto implements IFeedbackAttachmentDto {
    id?: number;
    fileName?: string;
    contentType?: string;
    isInternal?: boolean;
    createdAtUtc?: string;

    constructor(data?: IFeedbackAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
            this.isInternal = _data["isInternal"];
            this.createdAtUtc = _data["createdAtUtc"];
        }
    }

    static fromJS(data: any): FeedbackAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["isInternal"] = this.isInternal;
        data["createdAtUtc"] = this.createdAtUtc;
        return data;
    }
}

export interface IFeedbackAttachmentDto {
    id?: number;
    fileName?: string;
    contentType?: string;
    isInternal?: boolean;
    createdAtUtc?: string;
}

export class ManageFeedbackDto implements IManageFeedbackDto {
    status?: FeedbackStatus;
    priority?: FeedbackPriority;
    assigneeUserId?: string | undefined;
    isPublished?: boolean;
    publishedTitle?: string | undefined;
    publishedSummary?: string | undefined;
    resolution?: string | undefined;
    revision?: string;

    constructor(data?: IManageFeedbackDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.priority = _data["priority"];
            this.assigneeUserId = _data["assigneeUserId"];
            this.isPublished = _data["isPublished"];
            this.publishedTitle = _data["publishedTitle"];
            this.publishedSummary = _data["publishedSummary"];
            this.resolution = _data["resolution"];
            this.revision = _data["revision"];
        }
    }

    static fromJS(data: any): ManageFeedbackDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManageFeedbackDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["priority"] = this.priority;
        data["assigneeUserId"] = this.assigneeUserId;
        data["isPublished"] = this.isPublished;
        data["publishedTitle"] = this.publishedTitle;
        data["publishedSummary"] = this.publishedSummary;
        data["resolution"] = this.resolution;
        data["revision"] = this.revision;
        return data;
    }
}

export interface IManageFeedbackDto {
    status?: FeedbackStatus;
    priority?: FeedbackPriority;
    assigneeUserId?: string | undefined;
    isPublished?: boolean;
    publishedTitle?: string | undefined;
    publishedSummary?: string | undefined;
    resolution?: string | undefined;
    revision?: string;
}

export class LegacyUserForMigrationDataDto implements ILegacyUserForMigrationDataDto {
    users?: PaginatedResponseOfLegacyUserForMigrationDto;
    filterOptions?: LegacyFilterOptionsDto;

    constructor(data?: ILegacyUserForMigrationDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.users = _data["users"] ? PaginatedResponseOfLegacyUserForMigrationDto.fromJS(_data["users"]) : undefined as any;
            this.filterOptions = _data["filterOptions"] ? LegacyFilterOptionsDto.fromJS(_data["filterOptions"]) : undefined as any;
        }
    }

    static fromJS(data: any): LegacyUserForMigrationDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new LegacyUserForMigrationDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["users"] = this.users ? this.users.toJSON() : undefined as any;
        data["filterOptions"] = this.filterOptions ? this.filterOptions.toJSON() : undefined as any;
        return data;
    }
}

export interface ILegacyUserForMigrationDataDto {
    users?: PaginatedResponseOfLegacyUserForMigrationDto;
    filterOptions?: LegacyFilterOptionsDto;
}

export class PaginatedResponseOfLegacyUserForMigrationDto implements IPaginatedResponseOfLegacyUserForMigrationDto {
    items?: LegacyUserForMigrationDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResponseOfLegacyUserForMigrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LegacyUserForMigrationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfLegacyUserForMigrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfLegacyUserForMigrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedResponseOfLegacyUserForMigrationDto {
    items?: LegacyUserForMigrationDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class LegacyUserForMigrationDto implements ILegacyUserForMigrationDto {
    email?: string;
    fullName?: string;
    document?: string;
    accesses?: string[];
    isEditor?: boolean;
    isValidator?: boolean;
    unitHierarchyInfo?: UnitHierarchyInfoDto | undefined;
    migrationStatus?: MigrationStatus;
    memberId?: string | undefined;
    userId?: string | undefined;

    constructor(data?: ILegacyUserForMigrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.fullName = _data["fullName"];
            this.document = _data["document"];
            if (Array.isArray(_data["accesses"])) {
                this.accesses = [] as any;
                for (let item of _data["accesses"])
                    this.accesses!.push(item);
            }
            this.isEditor = _data["isEditor"];
            this.isValidator = _data["isValidator"];
            this.unitHierarchyInfo = _data["unitHierarchyInfo"] ? UnitHierarchyInfoDto.fromJS(_data["unitHierarchyInfo"]) : undefined as any;
            this.migrationStatus = _data["migrationStatus"];
            this.memberId = _data["memberId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): LegacyUserForMigrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new LegacyUserForMigrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["fullName"] = this.fullName;
        data["document"] = this.document;
        if (Array.isArray(this.accesses)) {
            data["accesses"] = [];
            for (let item of this.accesses)
                data["accesses"].push(item);
        }
        data["isEditor"] = this.isEditor;
        data["isValidator"] = this.isValidator;
        data["unitHierarchyInfo"] = this.unitHierarchyInfo ? this.unitHierarchyInfo.toJSON() : undefined as any;
        data["migrationStatus"] = this.migrationStatus;
        data["memberId"] = this.memberId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface ILegacyUserForMigrationDto {
    email?: string;
    fullName?: string;
    document?: string;
    accesses?: string[];
    isEditor?: boolean;
    isValidator?: boolean;
    unitHierarchyInfo?: UnitHierarchyInfoDto | undefined;
    migrationStatus?: MigrationStatus;
    memberId?: string | undefined;
    userId?: string | undefined;
}

export class UnitHierarchyInfoDto implements IUnitHierarchyInfoDto {
    mainUnit?: string;
    district?: string | undefined;
    area?: string | undefined;

    constructor(data?: IUnitHierarchyInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mainUnit = _data["mainUnit"];
            this.district = _data["district"];
            this.area = _data["area"];
        }
    }

    static fromJS(data: any): UnitHierarchyInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitHierarchyInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mainUnit"] = this.mainUnit;
        data["district"] = this.district;
        data["area"] = this.area;
        return data;
    }
}

export interface IUnitHierarchyInfoDto {
    mainUnit?: string;
    district?: string | undefined;
    area?: string | undefined;
}

export type MigrationStatus = "PersonPending" | "UserPending" | "Migrated" | "IdpUserMissing" | "Error";

export class LegacyFilterOptionsDto implements ILegacyFilterOptionsDto {
    accesos?: string[];
    areas?: string[];
    distritos?: string[];
    comunidades?: string[];

    constructor(data?: ILegacyFilterOptionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accesos"])) {
                this.accesos = [] as any;
                for (let item of _data["accesos"])
                    this.accesos!.push(item);
            }
            if (Array.isArray(_data["areas"])) {
                this.areas = [] as any;
                for (let item of _data["areas"])
                    this.areas!.push(item);
            }
            if (Array.isArray(_data["distritos"])) {
                this.distritos = [] as any;
                for (let item of _data["distritos"])
                    this.distritos!.push(item);
            }
            if (Array.isArray(_data["comunidades"])) {
                this.comunidades = [] as any;
                for (let item of _data["comunidades"])
                    this.comunidades!.push(item);
            }
        }
    }

    static fromJS(data: any): LegacyFilterOptionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new LegacyFilterOptionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accesos)) {
            data["accesos"] = [];
            for (let item of this.accesos)
                data["accesos"].push(item);
        }
        if (Array.isArray(this.areas)) {
            data["areas"] = [];
            for (let item of this.areas)
                data["areas"].push(item);
        }
        if (Array.isArray(this.distritos)) {
            data["distritos"] = [];
            for (let item of this.distritos)
                data["distritos"].push(item);
        }
        if (Array.isArray(this.comunidades)) {
            data["comunidades"] = [];
            for (let item of this.comunidades)
                data["comunidades"].push(item);
        }
        return data;
    }
}

export interface ILegacyFilterOptionsDto {
    accesos?: string[];
    areas?: string[];
    distritos?: string[];
    comunidades?: string[];
}

export class FilterDataDto implements IFilterDataDto {
    documentTypes?: DocumentTypeItemDto[];
    units?: OrganizationUnitItemDto[];
    ministries?: ReferenceItemDto[];
    assignments?: ReferenceItemDto[];
    appointments?: ReferenceItemDto[];
    areas?: AreaItemDto[];
    modules?: ModuleItemDto[];

    constructor(data?: IFilterDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["documentTypes"])) {
                this.documentTypes = [] as any;
                for (let item of _data["documentTypes"])
                    this.documentTypes!.push(DocumentTypeItemDto.fromJS(item));
            }
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units!.push(OrganizationUnitItemDto.fromJS(item));
            }
            if (Array.isArray(_data["ministries"])) {
                this.ministries = [] as any;
                for (let item of _data["ministries"])
                    this.ministries!.push(ReferenceItemDto.fromJS(item));
            }
            if (Array.isArray(_data["assignments"])) {
                this.assignments = [] as any;
                for (let item of _data["assignments"])
                    this.assignments!.push(ReferenceItemDto.fromJS(item));
            }
            if (Array.isArray(_data["appointments"])) {
                this.appointments = [] as any;
                for (let item of _data["appointments"])
                    this.appointments!.push(ReferenceItemDto.fromJS(item));
            }
            if (Array.isArray(_data["areas"])) {
                this.areas = [] as any;
                for (let item of _data["areas"])
                    this.areas!.push(AreaItemDto.fromJS(item));
            }
            if (Array.isArray(_data["modules"])) {
                this.modules = [] as any;
                for (let item of _data["modules"])
                    this.modules!.push(ModuleItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.documentTypes)) {
            data["documentTypes"] = [];
            for (let item of this.documentTypes)
                data["documentTypes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.ministries)) {
            data["ministries"] = [];
            for (let item of this.ministries)
                data["ministries"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.assignments)) {
            data["assignments"] = [];
            for (let item of this.assignments)
                data["assignments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.appointments)) {
            data["appointments"] = [];
            for (let item of this.appointments)
                data["appointments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.areas)) {
            data["areas"] = [];
            for (let item of this.areas)
                data["areas"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.modules)) {
            data["modules"] = [];
            for (let item of this.modules)
                data["modules"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterDataDto {
    documentTypes?: DocumentTypeItemDto[];
    units?: OrganizationUnitItemDto[];
    ministries?: ReferenceItemDto[];
    assignments?: ReferenceItemDto[];
    appointments?: ReferenceItemDto[];
    areas?: AreaItemDto[];
    modules?: ModuleItemDto[];
}

export class DocumentTypeItemDto implements IDocumentTypeItemDto {
    id?: number;
    name?: string;

    constructor(data?: IDocumentTypeItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): DocumentTypeItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTypeItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IDocumentTypeItemDto {
    id?: number;
    name?: string;
}

export class OrganizationUnitItemDto implements IOrganizationUnitItemDto {
    id?: string;
    name?: string;
    levelId?: number;
    levelName?: string;
    parentId?: string | undefined;

    constructor(data?: IOrganizationUnitItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.levelId = _data["levelId"];
            this.levelName = _data["levelName"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): OrganizationUnitItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["levelId"] = this.levelId;
        data["levelName"] = this.levelName;
        data["parentId"] = this.parentId;
        return data;
    }
}

export interface IOrganizationUnitItemDto {
    id?: string;
    name?: string;
    levelId?: number;
    levelName?: string;
    parentId?: string | undefined;
}

export class ReferenceItemDto implements IReferenceItemDto {
    id?: number;
    name?: string;
    requiresActiveMinistry?: boolean | undefined;
    allowedOrganizationLevelIds?: number[];
    allowedOrganizationLevelNames?: string[];

    constructor(data?: IReferenceItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.requiresActiveMinistry = _data["requiresActiveMinistry"];
            if (Array.isArray(_data["allowedOrganizationLevelIds"])) {
                this.allowedOrganizationLevelIds = [] as any;
                for (let item of _data["allowedOrganizationLevelIds"])
                    this.allowedOrganizationLevelIds!.push(item);
            }
            if (Array.isArray(_data["allowedOrganizationLevelNames"])) {
                this.allowedOrganizationLevelNames = [] as any;
                for (let item of _data["allowedOrganizationLevelNames"])
                    this.allowedOrganizationLevelNames!.push(item);
            }
        }
    }

    static fromJS(data: any): ReferenceItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReferenceItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["requiresActiveMinistry"] = this.requiresActiveMinistry;
        if (Array.isArray(this.allowedOrganizationLevelIds)) {
            data["allowedOrganizationLevelIds"] = [];
            for (let item of this.allowedOrganizationLevelIds)
                data["allowedOrganizationLevelIds"].push(item);
        }
        if (Array.isArray(this.allowedOrganizationLevelNames)) {
            data["allowedOrganizationLevelNames"] = [];
            for (let item of this.allowedOrganizationLevelNames)
                data["allowedOrganizationLevelNames"].push(item);
        }
        return data;
    }
}

export interface IReferenceItemDto {
    id?: number;
    name?: string;
    requiresActiveMinistry?: boolean | undefined;
    allowedOrganizationLevelIds?: number[];
    allowedOrganizationLevelNames?: string[];
}

export class AreaItemDto implements IAreaItemDto {
    id?: number;
    name?: string;

    constructor(data?: IAreaItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AreaItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AreaItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IAreaItemDto {
    id?: number;
    name?: string;
}

export class ModuleItemDto implements IModuleItemDto {
    id?: number;
    name?: string;

    constructor(data?: IModuleItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ModuleItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IModuleItemDto {
    id?: number;
    name?: string;
}

export class LegacyUserDto implements ILegacyUserDto {
    email?: string;
    firstName?: string;
    lastName?: string;
    documentNumber?: string;
    isEnabled?: boolean;
    libraryAccesses?: LibraryAccessDto[];
    unitTypeId?: number | undefined;
    unitId?: string | undefined;
    unitHierarchy?: string;
    unitHierarchyInfo?: UnitHierarchyInfoDto | undefined;
    isEditor?: boolean;
    isValidator?: boolean;

    constructor(data?: ILegacyUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.documentNumber = _data["documentNumber"];
            this.isEnabled = _data["isEnabled"];
            if (Array.isArray(_data["libraryAccesses"])) {
                this.libraryAccesses = [] as any;
                for (let item of _data["libraryAccesses"])
                    this.libraryAccesses!.push(LibraryAccessDto.fromJS(item));
            }
            this.unitTypeId = _data["unitTypeId"];
            this.unitId = _data["unitId"];
            this.unitHierarchy = _data["unitHierarchy"];
            this.unitHierarchyInfo = _data["unitHierarchyInfo"] ? UnitHierarchyInfoDto.fromJS(_data["unitHierarchyInfo"]) : undefined as any;
            this.isEditor = _data["isEditor"];
            this.isValidator = _data["isValidator"];
        }
    }

    static fromJS(data: any): LegacyUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new LegacyUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["documentNumber"] = this.documentNumber;
        data["isEnabled"] = this.isEnabled;
        if (Array.isArray(this.libraryAccesses)) {
            data["libraryAccesses"] = [];
            for (let item of this.libraryAccesses)
                data["libraryAccesses"].push(item ? item.toJSON() : undefined as any);
        }
        data["unitTypeId"] = this.unitTypeId;
        data["unitId"] = this.unitId;
        data["unitHierarchy"] = this.unitHierarchy;
        data["unitHierarchyInfo"] = this.unitHierarchyInfo ? this.unitHierarchyInfo.toJSON() : undefined as any;
        data["isEditor"] = this.isEditor;
        data["isValidator"] = this.isValidator;
        return data;
    }
}

export interface ILegacyUserDto {
    email?: string;
    firstName?: string;
    lastName?: string;
    documentNumber?: string;
    isEnabled?: boolean;
    libraryAccesses?: LibraryAccessDto[];
    unitTypeId?: number | undefined;
    unitId?: string | undefined;
    unitHierarchy?: string;
    unitHierarchyInfo?: UnitHierarchyInfoDto | undefined;
    isEditor?: boolean;
    isValidator?: boolean;
}

export class LibraryAccessDto implements ILibraryAccessDto {
    id?: number;
    name?: string;

    constructor(data?: ILibraryAccessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): LibraryAccessDto {
        data = typeof data === 'object' ? data : {};
        let result = new LibraryAccessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ILibraryAccessDto {
    id?: number;
    name?: string;
}

export class MigrateLegacyUserRequest implements IMigrateLegacyUserRequest {
    firstName?: string;
    lastName?: string;
    email?: string;
    documentType?: DocumentType;
    documentNumber?: string;
    unitId?: string;
    ministry?: PersonMinistryRequest | undefined;
    ministryAppointments?: PersonMinistryAppointmentRequest[];
    assignments?: PersonAssignmentRequest[];

    constructor(data?: IMigrateLegacyUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.documentType = _data["documentType"];
            this.documentNumber = _data["documentNumber"];
            this.unitId = _data["unitId"];
            this.ministry = _data["ministry"] ? PersonMinistryRequest.fromJS(_data["ministry"]) : undefined as any;
            if (Array.isArray(_data["ministryAppointments"])) {
                this.ministryAppointments = [] as any;
                for (let item of _data["ministryAppointments"])
                    this.ministryAppointments!.push(PersonMinistryAppointmentRequest.fromJS(item));
            }
            if (Array.isArray(_data["assignments"])) {
                this.assignments = [] as any;
                for (let item of _data["assignments"])
                    this.assignments!.push(PersonAssignmentRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MigrateLegacyUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MigrateLegacyUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["documentType"] = this.documentType;
        data["documentNumber"] = this.documentNumber;
        data["unitId"] = this.unitId;
        data["ministry"] = this.ministry ? this.ministry.toJSON() : undefined as any;
        if (Array.isArray(this.ministryAppointments)) {
            data["ministryAppointments"] = [];
            for (let item of this.ministryAppointments)
                data["ministryAppointments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.assignments)) {
            data["assignments"] = [];
            for (let item of this.assignments)
                data["assignments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMigrateLegacyUserRequest {
    firstName?: string;
    lastName?: string;
    email?: string;
    documentType?: DocumentType;
    documentNumber?: string;
    unitId?: string;
    ministry?: PersonMinistryRequest | undefined;
    ministryAppointments?: PersonMinistryAppointmentRequest[];
    assignments?: PersonAssignmentRequest[];
}

export type DocumentType = "Dni" | "Passport" | "Other";

export class PersonMinistryRequest implements IPersonMinistryRequest {
    ministryId?: number;
    unitId?: string | undefined;

    constructor(data?: IPersonMinistryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ministryId = _data["ministryId"];
            this.unitId = _data["unitId"];
        }
    }

    static fromJS(data: any): PersonMinistryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PersonMinistryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ministryId"] = this.ministryId;
        data["unitId"] = this.unitId;
        return data;
    }
}

export interface IPersonMinistryRequest {
    ministryId?: number;
    unitId?: string | undefined;
}

export class PersonMinistryAppointmentRequest implements IPersonMinistryAppointmentRequest {
    appointmentId?: number;
    unitId?: string | undefined;

    constructor(data?: IPersonMinistryAppointmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentId = _data["appointmentId"];
            this.unitId = _data["unitId"];
        }
    }

    static fromJS(data: any): PersonMinistryAppointmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PersonMinistryAppointmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointmentId"] = this.appointmentId;
        data["unitId"] = this.unitId;
        return data;
    }
}

export interface IPersonMinistryAppointmentRequest {
    appointmentId?: number;
    unitId?: string | undefined;
}

export class PersonAssignmentRequest implements IPersonAssignmentRequest {
    assignmentId?: number;
    unitId?: string | undefined;

    constructor(data?: IPersonAssignmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignmentId = _data["assignmentId"];
            this.unitId = _data["unitId"];
        }
    }

    static fromJS(data: any): PersonAssignmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PersonAssignmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignmentId"] = this.assignmentId;
        data["unitId"] = this.unitId;
        return data;
    }
}

export interface IPersonAssignmentRequest {
    assignmentId?: number;
    unitId?: string | undefined;
}

export class UserFullInfoDto implements IUserFullInfoDto {
    isAdmin?: boolean;
    roles?: UserRole[];
    permissions?: UserPermission[];
    readableUnitIds?: string[];
    manageableUnitIds?: string[];
    canManage?: boolean;
    canViewRestrictedData?: boolean;
    isPublicOnly?: boolean;
    personId?: string;
    firstName?: string;
    lastName?: string;
    fullName?: string;
    photoUrl?: string | undefined;
    community?: OrganizationUnitDto | undefined;
    activeMinistry?: ActiveMinistryDto | undefined;
    activeAssignments?: ActiveAssignmentDto[];
    activeAppointments?: ActiveAppointmentDto[];
    activeActivities?: ActiveActivityDto[];

    constructor(data?: IUserFullInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAdmin = _data["isAdmin"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            if (Array.isArray(_data["readableUnitIds"])) {
                this.readableUnitIds = [] as any;
                for (let item of _data["readableUnitIds"])
                    this.readableUnitIds!.push(item);
            }
            if (Array.isArray(_data["manageableUnitIds"])) {
                this.manageableUnitIds = [] as any;
                for (let item of _data["manageableUnitIds"])
                    this.manageableUnitIds!.push(item);
            }
            this.canManage = _data["canManage"];
            this.canViewRestrictedData = _data["canViewRestrictedData"];
            this.isPublicOnly = _data["isPublicOnly"];
            this.personId = _data["personId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.photoUrl = _data["photoUrl"];
            this.community = _data["community"] ? OrganizationUnitDto.fromJS(_data["community"]) : undefined as any;
            this.activeMinistry = _data["activeMinistry"] ? ActiveMinistryDto.fromJS(_data["activeMinistry"]) : undefined as any;
            if (Array.isArray(_data["activeAssignments"])) {
                this.activeAssignments = [] as any;
                for (let item of _data["activeAssignments"])
                    this.activeAssignments!.push(ActiveAssignmentDto.fromJS(item));
            }
            if (Array.isArray(_data["activeAppointments"])) {
                this.activeAppointments = [] as any;
                for (let item of _data["activeAppointments"])
                    this.activeAppointments!.push(ActiveAppointmentDto.fromJS(item));
            }
            if (Array.isArray(_data["activeActivities"])) {
                this.activeActivities = [] as any;
                for (let item of _data["activeActivities"])
                    this.activeActivities!.push(ActiveActivityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserFullInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserFullInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAdmin"] = this.isAdmin;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        if (Array.isArray(this.readableUnitIds)) {
            data["readableUnitIds"] = [];
            for (let item of this.readableUnitIds)
                data["readableUnitIds"].push(item);
        }
        if (Array.isArray(this.manageableUnitIds)) {
            data["manageableUnitIds"] = [];
            for (let item of this.manageableUnitIds)
                data["manageableUnitIds"].push(item);
        }
        data["canManage"] = this.canManage;
        data["canViewRestrictedData"] = this.canViewRestrictedData;
        data["isPublicOnly"] = this.isPublicOnly;
        data["personId"] = this.personId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["photoUrl"] = this.photoUrl;
        data["community"] = this.community ? this.community.toJSON() : undefined as any;
        data["activeMinistry"] = this.activeMinistry ? this.activeMinistry.toJSON() : undefined as any;
        if (Array.isArray(this.activeAssignments)) {
            data["activeAssignments"] = [];
            for (let item of this.activeAssignments)
                data["activeAssignments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.activeAppointments)) {
            data["activeAppointments"] = [];
            for (let item of this.activeAppointments)
                data["activeAppointments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.activeActivities)) {
            data["activeActivities"] = [];
            for (let item of this.activeActivities)
                data["activeActivities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserFullInfoDto {
    isAdmin?: boolean;
    roles?: UserRole[];
    permissions?: UserPermission[];
    readableUnitIds?: string[];
    manageableUnitIds?: string[];
    canManage?: boolean;
    canViewRestrictedData?: boolean;
    isPublicOnly?: boolean;
    personId?: string;
    firstName?: string;
    lastName?: string;
    fullName?: string;
    photoUrl?: string | undefined;
    community?: OrganizationUnitDto | undefined;
    activeMinistry?: ActiveMinistryDto | undefined;
    activeAssignments?: ActiveAssignmentDto[];
    activeAppointments?: ActiveAppointmentDto[];
    activeActivities?: ActiveActivityDto[];
}

export type UserRole = "Member" | "Servant" | "UnitManager" | "MinisterialManager";

export type UserPermission = "ViewBasicUnits" | "ViewUnitDetail" | "ViewPeople" | "ViewMinisterialActivity" | "ManageDivineServices" | "ManageAttendance" | "ManageSpiritualAssistanceVisits" | "ManageUnits" | "ManagePeopleGeneral" | "ManageMinisterialActivity" | "ManageUsers";

export class ActiveMinistryDto implements IActiveMinistryDto {
    name?: string;
    unitId?: string;
    unitName?: string;

    constructor(data?: IActiveMinistryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.unitId = _data["unitId"];
            this.unitName = _data["unitName"];
        }
    }

    static fromJS(data: any): ActiveMinistryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveMinistryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["unitId"] = this.unitId;
        data["unitName"] = this.unitName;
        return data;
    }
}

export interface IActiveMinistryDto {
    name?: string;
    unitId?: string;
    unitName?: string;
}

export class ActiveAssignmentDto implements IActiveAssignmentDto {
    name?: string;
    unitId?: string;
    unitName?: string;

    constructor(data?: IActiveAssignmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.unitId = _data["unitId"];
            this.unitName = _data["unitName"];
        }
    }

    static fromJS(data: any): ActiveAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveAssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["unitId"] = this.unitId;
        data["unitName"] = this.unitName;
        return data;
    }
}

export interface IActiveAssignmentDto {
    name?: string;
    unitId?: string;
    unitName?: string;
}

export class ActiveAppointmentDto implements IActiveAppointmentDto {
    name?: string;
    unitId?: string;
    unitName?: string;

    constructor(data?: IActiveAppointmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.unitId = _data["unitId"];
            this.unitName = _data["unitName"];
        }
    }

    static fromJS(data: any): ActiveAppointmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveAppointmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["unitId"] = this.unitId;
        data["unitName"] = this.unitName;
        return data;
    }
}

export interface IActiveAppointmentDto {
    name?: string;
    unitId?: string;
    unitName?: string;
}

export class ActiveActivityDto implements IActiveActivityDto {
    name?: string;
    role?: string | undefined;
    unitId?: string;
    unitName?: string;

    constructor(data?: IActiveActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.role = _data["role"];
            this.unitId = _data["unitId"];
            this.unitName = _data["unitName"];
        }
    }

    static fromJS(data: any): ActiveActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["role"] = this.role;
        data["unitId"] = this.unitId;
        data["unitName"] = this.unitName;
        return data;
    }
}

export interface IActiveActivityDto {
    name?: string;
    role?: string | undefined;
    unitId?: string;
    unitName?: string;
}

export class UserBasicDto implements IUserBasicDto {
    id?: string;
    email?: string;
    username?: string;
    fullName?: string | undefined;
    documentNumber?: string | undefined;
    membershipUnitName?: string | undefined;
    hasLocalUser?: boolean;
    lastActivityAtUtc?: string | undefined;

    constructor(data?: IUserBasicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.username = _data["username"];
            this.fullName = _data["fullName"];
            this.documentNumber = _data["documentNumber"];
            this.membershipUnitName = _data["membershipUnitName"];
            this.hasLocalUser = _data["hasLocalUser"];
            this.lastActivityAtUtc = _data["lastActivityAtUtc"];
        }
    }

    static fromJS(data: any): UserBasicDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserBasicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["username"] = this.username;
        data["fullName"] = this.fullName;
        data["documentNumber"] = this.documentNumber;
        data["membershipUnitName"] = this.membershipUnitName;
        data["hasLocalUser"] = this.hasLocalUser;
        data["lastActivityAtUtc"] = this.lastActivityAtUtc;
        return data;
    }
}

export interface IUserBasicDto {
    id?: string;
    email?: string;
    username?: string;
    fullName?: string | undefined;
    documentNumber?: string | undefined;
    membershipUnitName?: string | undefined;
    hasLocalUser?: boolean;
    lastActivityAtUtc?: string | undefined;
}

export class UserRoleAssignmentDto implements IUserRoleAssignmentDto {
    id?: number;
    role?: UserRole;
    organizationUnitId?: string | undefined;
    organizationUnitName?: string | undefined;
    organizationUnitLevelId?: number | undefined;
    includeDescendants?: boolean;
    validFrom?: string | undefined;
    validTo?: string | undefined;

    constructor(data?: IUserRoleAssignmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.role = _data["role"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.organizationUnitName = _data["organizationUnitName"];
            this.organizationUnitLevelId = _data["organizationUnitLevelId"];
            this.includeDescendants = _data["includeDescendants"];
            this.validFrom = _data["validFrom"];
            this.validTo = _data["validTo"];
        }
    }

    static fromJS(data: any): UserRoleAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleAssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["role"] = this.role;
        data["organizationUnitId"] = this.organizationUnitId;
        data["organizationUnitName"] = this.organizationUnitName;
        data["organizationUnitLevelId"] = this.organizationUnitLevelId;
        data["includeDescendants"] = this.includeDescendants;
        data["validFrom"] = this.validFrom;
        data["validTo"] = this.validTo;
        return data;
    }
}

export interface IUserRoleAssignmentDto {
    id?: number;
    role?: UserRole;
    organizationUnitId?: string | undefined;
    organizationUnitName?: string | undefined;
    organizationUnitLevelId?: number | undefined;
    includeDescendants?: boolean;
    validFrom?: string | undefined;
    validTo?: string | undefined;
}

export class MinistryAppointmentDto implements IMinistryAppointmentDto {
    id?: number;
    name?: string;
    sortOrder?: number;
    isActive?: boolean;

    constructor(data?: IMinistryAppointmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): MinistryAppointmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new MinistryAppointmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IMinistryAppointmentDto {
    id?: number;
    name?: string;
    sortOrder?: number;
    isActive?: boolean;
}

export class CreateMinistryAppointmentDto implements ICreateMinistryAppointmentDto {
    name?: string;
    sortOrder?: number | undefined;

    constructor(data?: ICreateMinistryAppointmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): CreateMinistryAppointmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMinistryAppointmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface ICreateMinistryAppointmentDto {
    name?: string;
    sortOrder?: number | undefined;
}

export class UpdateMinistryAppointmentDto implements IUpdateMinistryAppointmentDto {
    name?: string;
    sortOrder?: number;
    isActive?: boolean;

    constructor(data?: IUpdateMinistryAppointmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateMinistryAppointmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMinistryAppointmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUpdateMinistryAppointmentDto {
    name?: string;
    sortOrder?: number;
    isActive?: boolean;
}

export class UpdateMinistryAppointmentSortOrderDto implements IUpdateMinistryAppointmentSortOrderDto {
    sortOrder?: number;

    constructor(data?: IUpdateMinistryAppointmentSortOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): UpdateMinistryAppointmentSortOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMinistryAppointmentSortOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IUpdateMinistryAppointmentSortOrderDto {
    sortOrder?: number;
}

export class MinistryDto implements IMinistryDto {
    id?: number;
    name?: string;
    sortOrder?: number;
    isActive?: boolean;

    constructor(data?: IMinistryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): MinistryDto {
        data = typeof data === 'object' ? data : {};
        let result = new MinistryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IMinistryDto {
    id?: number;
    name?: string;
    sortOrder?: number;
    isActive?: boolean;
}

export class CreateMinistryDto implements ICreateMinistryDto {
    name?: string;
    sortOrder?: number | undefined;

    constructor(data?: ICreateMinistryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): CreateMinistryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMinistryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface ICreateMinistryDto {
    name?: string;
    sortOrder?: number | undefined;
}

export class UpdateMinistryDto implements IUpdateMinistryDto {
    name?: string;
    sortOrder?: number;
    isActive?: boolean;

    constructor(data?: IUpdateMinistryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateMinistryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMinistryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUpdateMinistryDto {
    name?: string;
    sortOrder?: number;
    isActive?: boolean;
}

export class UpdateMinistrySortOrderDto implements IUpdateMinistrySortOrderDto {
    sortOrder?: number;

    constructor(data?: IUpdateMinistrySortOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): UpdateMinistrySortOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMinistrySortOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IUpdateMinistrySortOrderDto {
    sortOrder?: number;
}

export class MinistryTransferRequestDto implements IMinistryTransferRequestDto {
    id?: string;
    personMinistryId?: string;
    personId?: string;
    personFirstName?: string;
    personLastName?: string;
    ministryId?: number;
    ministryName?: string;
    fromOrganizationUnitId?: string;
    fromOrganizationUnitName?: string;
    toOrganizationUnitId?: string;
    toOrganizationUnitName?: string;
    requestedDate?: string;
    status?: TransferRequestStatus;
    resolvedDate?: string | undefined;
    resolvedByUserId?: string | undefined;
    resolutionNotes?: string | undefined;

    constructor(data?: IMinistryTransferRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.personMinistryId = _data["personMinistryId"];
            this.personId = _data["personId"];
            this.personFirstName = _data["personFirstName"];
            this.personLastName = _data["personLastName"];
            this.ministryId = _data["ministryId"];
            this.ministryName = _data["ministryName"];
            this.fromOrganizationUnitId = _data["fromOrganizationUnitId"];
            this.fromOrganizationUnitName = _data["fromOrganizationUnitName"];
            this.toOrganizationUnitId = _data["toOrganizationUnitId"];
            this.toOrganizationUnitName = _data["toOrganizationUnitName"];
            this.requestedDate = _data["requestedDate"];
            this.status = _data["status"];
            this.resolvedDate = _data["resolvedDate"];
            this.resolvedByUserId = _data["resolvedByUserId"];
            this.resolutionNotes = _data["resolutionNotes"];
        }
    }

    static fromJS(data: any): MinistryTransferRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new MinistryTransferRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["personMinistryId"] = this.personMinistryId;
        data["personId"] = this.personId;
        data["personFirstName"] = this.personFirstName;
        data["personLastName"] = this.personLastName;
        data["ministryId"] = this.ministryId;
        data["ministryName"] = this.ministryName;
        data["fromOrganizationUnitId"] = this.fromOrganizationUnitId;
        data["fromOrganizationUnitName"] = this.fromOrganizationUnitName;
        data["toOrganizationUnitId"] = this.toOrganizationUnitId;
        data["toOrganizationUnitName"] = this.toOrganizationUnitName;
        data["requestedDate"] = this.requestedDate;
        data["status"] = this.status;
        data["resolvedDate"] = this.resolvedDate;
        data["resolvedByUserId"] = this.resolvedByUserId;
        data["resolutionNotes"] = this.resolutionNotes;
        return data;
    }
}

export interface IMinistryTransferRequestDto {
    id?: string;
    personMinistryId?: string;
    personId?: string;
    personFirstName?: string;
    personLastName?: string;
    ministryId?: number;
    ministryName?: string;
    fromOrganizationUnitId?: string;
    fromOrganizationUnitName?: string;
    toOrganizationUnitId?: string;
    toOrganizationUnitName?: string;
    requestedDate?: string;
    status?: TransferRequestStatus;
    resolvedDate?: string | undefined;
    resolvedByUserId?: string | undefined;
    resolutionNotes?: string | undefined;
}

export type TransferRequestStatus = "Pending" | "Approved" | "Rejected" | "Cancelled";

export class ResolveMinistryTransferRequestDto implements IResolveMinistryTransferRequestDto {
    resolutionNotes?: string | undefined;

    constructor(data?: IResolveMinistryTransferRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resolutionNotes = _data["resolutionNotes"];
        }
    }

    static fromJS(data: any): ResolveMinistryTransferRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResolveMinistryTransferRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resolutionNotes"] = this.resolutionNotes;
        return data;
    }
}

export interface IResolveMinistryTransferRequestDto {
    resolutionNotes?: string | undefined;
}

export class PaginatedResponseOfOrganizationUnitDto implements IPaginatedResponseOfOrganizationUnitDto {
    items?: OrganizationUnitDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResponseOfOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationUnitDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfOrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfOrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedResponseOfOrganizationUnitDto {
    items?: OrganizationUnitDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class OrganizationUnitByLevelDto implements IOrganizationUnitByLevelDto {
    organizationLevelId?: number;
    levelName?: string;
    units?: OrganizationUnitDto[];

    constructor(data?: IOrganizationUnitByLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationLevelId = _data["organizationLevelId"];
            this.levelName = _data["levelName"];
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units!.push(OrganizationUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrganizationUnitByLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitByLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationLevelId"] = this.organizationLevelId;
        data["levelName"] = this.levelName;
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOrganizationUnitByLevelDto {
    organizationLevelId?: number;
    levelName?: string;
    units?: OrganizationUnitDto[];
}

export class MinistryPersonGroupDto implements IMinistryPersonGroupDto {
    ministryId?: number;
    ministryName?: string;
    sortOrder?: number;
    people?: PersonMinistryDto[];

    constructor(data?: IMinistryPersonGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ministryId = _data["ministryId"];
            this.ministryName = _data["ministryName"];
            this.sortOrder = _data["sortOrder"];
            if (Array.isArray(_data["people"])) {
                this.people = [] as any;
                for (let item of _data["people"])
                    this.people!.push(PersonMinistryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MinistryPersonGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new MinistryPersonGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ministryId"] = this.ministryId;
        data["ministryName"] = this.ministryName;
        data["sortOrder"] = this.sortOrder;
        if (Array.isArray(this.people)) {
            data["people"] = [];
            for (let item of this.people)
                data["people"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMinistryPersonGroupDto {
    ministryId?: number;
    ministryName?: string;
    sortOrder?: number;
    people?: PersonMinistryDto[];
}

export class PersonMinistryDto implements IPersonMinistryDto {
    personId?: string;
    firstName?: string;
    lastName?: string;
    ministryId?: number;
    ministryName?: string;
    sortOrder?: number;
    status?: MinistryStatus;
    unitId?: string;
    unitName?: string;
    activities?: PersonMinistryActivityDto[];

    constructor(data?: IPersonMinistryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.ministryId = _data["ministryId"];
            this.ministryName = _data["ministryName"];
            this.sortOrder = _data["sortOrder"];
            this.status = _data["status"];
            this.unitId = _data["unitId"];
            this.unitName = _data["unitName"];
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities!.push(PersonMinistryActivityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PersonMinistryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonMinistryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["ministryId"] = this.ministryId;
        data["ministryName"] = this.ministryName;
        data["sortOrder"] = this.sortOrder;
        data["status"] = this.status;
        data["unitId"] = this.unitId;
        data["unitName"] = this.unitName;
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPersonMinistryDto {
    personId?: string;
    firstName?: string;
    lastName?: string;
    ministryId?: number;
    ministryName?: string;
    sortOrder?: number;
    status?: MinistryStatus;
    unitId?: string;
    unitName?: string;
    activities?: PersonMinistryActivityDto[];
}

export type MinistryStatus = "Active" | "Licensed" | "Retired" | "Terminated";

export class PersonMinistryActivityDto implements IPersonMinistryActivityDto {
    id?: number;
    unitId?: string;
    unitName?: string;
    validFrom?: string;
    validTo?: string | undefined;

    constructor(data?: IPersonMinistryActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.unitId = _data["unitId"];
            this.unitName = _data["unitName"];
            this.validFrom = _data["validFrom"];
            this.validTo = _data["validTo"];
        }
    }

    static fromJS(data: any): PersonMinistryActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonMinistryActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["unitId"] = this.unitId;
        data["unitName"] = this.unitName;
        data["validFrom"] = this.validFrom;
        data["validTo"] = this.validTo;
        return data;
    }
}

export interface IPersonMinistryActivityDto {
    id?: number;
    unitId?: string;
    unitName?: string;
    validFrom?: string;
    validTo?: string | undefined;
}

export class PersonDto implements IPersonDto {
    id?: string;
    photoUrl?: string | undefined;
    portalMemberId?: string | undefined;
    firstName?: string;
    lastName?: string;
    fullName?: string | undefined;
    email?: string | undefined;
    documentType?: DocumentType | undefined;
    documentNumber?: string | undefined;
    birthDate?: string | undefined;
    age?: number | undefined;
    ageStatus?: PersonAgeStatus | undefined;
    ageStatusOverride?: PersonAgeStatus | undefined;
    gender?: Gender;
    relationshipSituation?: RelationshipSituation;
    relationshipPersonId?: string | undefined;
    relationshipPersonName?: string | undefined;
    placeOfBirth?: string | undefined;
    countryOfBirthId?: number | undefined;
    countryOfBirthName?: string | undefined;
    nationalityId?: number | undefined;
    nationalityName?: string | undefined;
    languages?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    occupation?: string | undefined;
    previousReligion?: string | undefined;
    membershipUnitId?: string | undefined;
    membershipUnitName?: string | undefined;
    responsiblePriestId?: string | undefined;
    responsiblePriestName?: string | undefined;
    spiritualStage?: SpiritualStage;
    status?: MembershipStatus;
    isHomeAttended?: boolean;
    ministry?: PersonMinistryDto | undefined;
    ministryAppointments?: PersonMinistryAppointmentDto[];
    assignments?: PersonAssignmentDto[];
    hasActiveUser?: boolean;
    hasLinkedUser?: boolean;
    userId?: string | undefined;

    constructor(data?: IPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.photoUrl = _data["photoUrl"];
            this.portalMemberId = _data["portalMemberId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.documentType = _data["documentType"];
            this.documentNumber = _data["documentNumber"];
            this.birthDate = _data["birthDate"];
            this.age = _data["age"];
            this.ageStatus = _data["ageStatus"];
            this.ageStatusOverride = _data["ageStatusOverride"];
            this.gender = _data["gender"];
            this.relationshipSituation = _data["relationshipSituation"];
            this.relationshipPersonId = _data["relationshipPersonId"];
            this.relationshipPersonName = _data["relationshipPersonName"];
            this.placeOfBirth = _data["placeOfBirth"];
            this.countryOfBirthId = _data["countryOfBirthId"];
            this.countryOfBirthName = _data["countryOfBirthName"];
            this.nationalityId = _data["nationalityId"];
            this.nationalityName = _data["nationalityName"];
            this.languages = _data["languages"];
            this.phone = _data["phone"];
            this.address = _data["address"];
            this.occupation = _data["occupation"];
            this.previousReligion = _data["previousReligion"];
            this.membershipUnitId = _data["membershipUnitId"];
            this.membershipUnitName = _data["membershipUnitName"];
            this.responsiblePriestId = _data["responsiblePriestId"];
            this.responsiblePriestName = _data["responsiblePriestName"];
            this.spiritualStage = _data["spiritualStage"];
            this.status = _data["status"];
            this.isHomeAttended = _data["isHomeAttended"];
            this.ministry = _data["ministry"] ? PersonMinistryDto.fromJS(_data["ministry"]) : undefined as any;
            if (Array.isArray(_data["ministryAppointments"])) {
                this.ministryAppointments = [] as any;
                for (let item of _data["ministryAppointments"])
                    this.ministryAppointments!.push(PersonMinistryAppointmentDto.fromJS(item));
            }
            if (Array.isArray(_data["assignments"])) {
                this.assignments = [] as any;
                for (let item of _data["assignments"])
                    this.assignments!.push(PersonAssignmentDto.fromJS(item));
            }
            this.hasActiveUser = _data["hasActiveUser"];
            this.hasLinkedUser = _data["hasLinkedUser"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): PersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["photoUrl"] = this.photoUrl;
        data["portalMemberId"] = this.portalMemberId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["documentType"] = this.documentType;
        data["documentNumber"] = this.documentNumber;
        data["birthDate"] = this.birthDate;
        data["age"] = this.age;
        data["ageStatus"] = this.ageStatus;
        data["ageStatusOverride"] = this.ageStatusOverride;
        data["gender"] = this.gender;
        data["relationshipSituation"] = this.relationshipSituation;
        data["relationshipPersonId"] = this.relationshipPersonId;
        data["relationshipPersonName"] = this.relationshipPersonName;
        data["placeOfBirth"] = this.placeOfBirth;
        data["countryOfBirthId"] = this.countryOfBirthId;
        data["countryOfBirthName"] = this.countryOfBirthName;
        data["nationalityId"] = this.nationalityId;
        data["nationalityName"] = this.nationalityName;
        data["languages"] = this.languages;
        data["phone"] = this.phone;
        data["address"] = this.address;
        data["occupation"] = this.occupation;
        data["previousReligion"] = this.previousReligion;
        data["membershipUnitId"] = this.membershipUnitId;
        data["membershipUnitName"] = this.membershipUnitName;
        data["responsiblePriestId"] = this.responsiblePriestId;
        data["responsiblePriestName"] = this.responsiblePriestName;
        data["spiritualStage"] = this.spiritualStage;
        data["status"] = this.status;
        data["isHomeAttended"] = this.isHomeAttended;
        data["ministry"] = this.ministry ? this.ministry.toJSON() : undefined as any;
        if (Array.isArray(this.ministryAppointments)) {
            data["ministryAppointments"] = [];
            for (let item of this.ministryAppointments)
                data["ministryAppointments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.assignments)) {
            data["assignments"] = [];
            for (let item of this.assignments)
                data["assignments"].push(item ? item.toJSON() : undefined as any);
        }
        data["hasActiveUser"] = this.hasActiveUser;
        data["hasLinkedUser"] = this.hasLinkedUser;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IPersonDto {
    id?: string;
    photoUrl?: string | undefined;
    portalMemberId?: string | undefined;
    firstName?: string;
    lastName?: string;
    fullName?: string | undefined;
    email?: string | undefined;
    documentType?: DocumentType | undefined;
    documentNumber?: string | undefined;
    birthDate?: string | undefined;
    age?: number | undefined;
    ageStatus?: PersonAgeStatus | undefined;
    ageStatusOverride?: PersonAgeStatus | undefined;
    gender?: Gender;
    relationshipSituation?: RelationshipSituation;
    relationshipPersonId?: string | undefined;
    relationshipPersonName?: string | undefined;
    placeOfBirth?: string | undefined;
    countryOfBirthId?: number | undefined;
    countryOfBirthName?: string | undefined;
    nationalityId?: number | undefined;
    nationalityName?: string | undefined;
    languages?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    occupation?: string | undefined;
    previousReligion?: string | undefined;
    membershipUnitId?: string | undefined;
    membershipUnitName?: string | undefined;
    responsiblePriestId?: string | undefined;
    responsiblePriestName?: string | undefined;
    spiritualStage?: SpiritualStage;
    status?: MembershipStatus;
    isHomeAttended?: boolean;
    ministry?: PersonMinistryDto | undefined;
    ministryAppointments?: PersonMinistryAppointmentDto[];
    assignments?: PersonAssignmentDto[];
    hasActiveUser?: boolean;
    hasLinkedUser?: boolean;
    userId?: string | undefined;
}

export type Gender = "Female" | "Male" | "Other";

export type RelationshipSituation = "Unspecified" | "Single" | "Married" | "CivilUnion" | "Concubinage" | "Separated" | "Divorced" | "Widowed";

export type SpiritualStage = "New" | "Baptised" | "Adopted" | "Sealed";

export type MembershipStatus = "Active" | "Inactive" | "Left" | "Departed" | "Excluded";

export class PersonMinistryAppointmentDto implements IPersonMinistryAppointmentDto {
    personId?: string;
    firstName?: string;
    lastName?: string;
    ministryAppointmentName?: string;
    unitId?: string;
    unitName?: string;

    constructor(data?: IPersonMinistryAppointmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.ministryAppointmentName = _data["ministryAppointmentName"];
            this.unitId = _data["unitId"];
            this.unitName = _data["unitName"];
        }
    }

    static fromJS(data: any): PersonMinistryAppointmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonMinistryAppointmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["ministryAppointmentName"] = this.ministryAppointmentName;
        data["unitId"] = this.unitId;
        data["unitName"] = this.unitName;
        return data;
    }
}

export interface IPersonMinistryAppointmentDto {
    personId?: string;
    firstName?: string;
    lastName?: string;
    ministryAppointmentName?: string;
    unitId?: string;
    unitName?: string;
}

export class PersonAssignmentDto implements IPersonAssignmentDto {
    personId?: string;
    firstName?: string;
    lastName?: string;
    assignmentName?: string;
    unitId?: string;
    unitName?: string;

    constructor(data?: IPersonAssignmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.assignmentName = _data["assignmentName"];
            this.unitId = _data["unitId"];
            this.unitName = _data["unitName"];
        }
    }

    static fromJS(data: any): PersonAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonAssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["assignmentName"] = this.assignmentName;
        data["unitId"] = this.unitId;
        data["unitName"] = this.unitName;
        return data;
    }
}

export interface IPersonAssignmentDto {
    personId?: string;
    firstName?: string;
    lastName?: string;
    assignmentName?: string;
    unitId?: string;
    unitName?: string;
}

export class PaginatedResponseOfPersonDto implements IPaginatedResponseOfPersonDto {
    items?: PersonDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResponseOfPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PersonDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedResponseOfPersonDto {
    items?: PersonDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class MemberLastAttendanceDto implements IMemberLastAttendanceDto {
    personId?: string;
    firstName?: string;
    lastName?: string;
    communityName?: string | undefined;
    lastAttendanceAt?: string | undefined;
    divineServiceId?: string | undefined;
    divineServiceTypeName?: string | undefined;
    hostUnitName?: string | undefined;

    constructor(data?: IMemberLastAttendanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.communityName = _data["communityName"];
            this.lastAttendanceAt = _data["lastAttendanceAt"];
            this.divineServiceId = _data["divineServiceId"];
            this.divineServiceTypeName = _data["divineServiceTypeName"];
            this.hostUnitName = _data["hostUnitName"];
        }
    }

    static fromJS(data: any): MemberLastAttendanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new MemberLastAttendanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["communityName"] = this.communityName;
        data["lastAttendanceAt"] = this.lastAttendanceAt;
        data["divineServiceId"] = this.divineServiceId;
        data["divineServiceTypeName"] = this.divineServiceTypeName;
        data["hostUnitName"] = this.hostUnitName;
        return data;
    }
}

export interface IMemberLastAttendanceDto {
    personId?: string;
    firstName?: string;
    lastName?: string;
    communityName?: string | undefined;
    lastAttendanceAt?: string | undefined;
    divineServiceId?: string | undefined;
    divineServiceTypeName?: string | undefined;
    hostUnitName?: string | undefined;
}

export class OrganizationUnitTreeNodeDto implements IOrganizationUnitTreeNodeDto {
    id?: string;
    name?: string;
    shortName?: string;
    costCentre?: string | undefined;
    organizationLevelId?: number;
    levelName?: string;
    parentUnitId?: string | undefined;
    leader?: string;
    leaderMinistryName?: string;
    children?: OrganizationUnitTreeNodeDto[];

    constructor(data?: IOrganizationUnitTreeNodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.costCentre = _data["costCentre"];
            this.organizationLevelId = _data["organizationLevelId"];
            this.levelName = _data["levelName"];
            this.parentUnitId = _data["parentUnitId"];
            this.leader = _data["leader"];
            this.leaderMinistryName = _data["leaderMinistryName"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(OrganizationUnitTreeNodeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrganizationUnitTreeNodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitTreeNodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["costCentre"] = this.costCentre;
        data["organizationLevelId"] = this.organizationLevelId;
        data["levelName"] = this.levelName;
        data["parentUnitId"] = this.parentUnitId;
        data["leader"] = this.leader;
        data["leaderMinistryName"] = this.leaderMinistryName;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOrganizationUnitTreeNodeDto {
    id?: string;
    name?: string;
    shortName?: string;
    costCentre?: string | undefined;
    organizationLevelId?: number;
    levelName?: string;
    parentUnitId?: string | undefined;
    leader?: string;
    leaderMinistryName?: string;
    children?: OrganizationUnitTreeNodeDto[];
}

export class CreateUnitRequest implements ICreateUnitRequest {
    name?: string;
    shortName?: string;
    costCentre?: string | undefined;
    description?: string | undefined;
    organizationLevelId?: number;
    parentUnitId?: string | undefined;

    constructor(data?: ICreateUnitRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.costCentre = _data["costCentre"];
            this.description = _data["description"];
            this.organizationLevelId = _data["organizationLevelId"];
            this.parentUnitId = _data["parentUnitId"];
        }
    }

    static fromJS(data: any): CreateUnitRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUnitRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["costCentre"] = this.costCentre;
        data["description"] = this.description;
        data["organizationLevelId"] = this.organizationLevelId;
        data["parentUnitId"] = this.parentUnitId;
        return data;
    }
}

export interface ICreateUnitRequest {
    name?: string;
    shortName?: string;
    costCentre?: string | undefined;
    description?: string | undefined;
    organizationLevelId?: number;
    parentUnitId?: string | undefined;
}

export class UpdateUnitRequest implements IUpdateUnitRequest {
    name?: string;
    shortName?: string;
    costCentre?: string | undefined;
    description?: string | undefined;
    addressLine?: string | undefined;
    city?: string | undefined;
    department?: string | undefined;
    province?: string | undefined;
    countryId?: number | undefined;
    postalCode?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    additionalInfo?: string | undefined;

    constructor(data?: IUpdateUnitRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.costCentre = _data["costCentre"];
            this.description = _data["description"];
            this.addressLine = _data["addressLine"];
            this.city = _data["city"];
            this.department = _data["department"];
            this.province = _data["province"];
            this.countryId = _data["countryId"];
            this.postalCode = _data["postalCode"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.additionalInfo = _data["additionalInfo"];
        }
    }

    static fromJS(data: any): UpdateUnitRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUnitRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["costCentre"] = this.costCentre;
        data["description"] = this.description;
        data["addressLine"] = this.addressLine;
        data["city"] = this.city;
        data["department"] = this.department;
        data["province"] = this.province;
        data["countryId"] = this.countryId;
        data["postalCode"] = this.postalCode;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["additionalInfo"] = this.additionalInfo;
        return data;
    }
}

export interface IUpdateUnitRequest {
    name?: string;
    shortName?: string;
    costCentre?: string | undefined;
    description?: string | undefined;
    addressLine?: string | undefined;
    city?: string | undefined;
    department?: string | undefined;
    province?: string | undefined;
    countryId?: number | undefined;
    postalCode?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    additionalInfo?: string | undefined;
}

export class ChangeParentRequest implements IChangeParentRequest {
    newParentUnitId?: string;
    isCorrection?: boolean;
    reason?: string | undefined;
    effectiveDate?: string | undefined;

    constructor(data?: IChangeParentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newParentUnitId = _data["newParentUnitId"];
            this.isCorrection = _data["isCorrection"];
            this.reason = _data["reason"];
            this.effectiveDate = _data["effectiveDate"];
        }
    }

    static fromJS(data: any): ChangeParentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeParentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newParentUnitId"] = this.newParentUnitId;
        data["isCorrection"] = this.isCorrection;
        data["reason"] = this.reason;
        data["effectiveDate"] = this.effectiveDate;
        return data;
    }
}

export interface IChangeParentRequest {
    newParentUnitId?: string;
    isCorrection?: boolean;
    reason?: string | undefined;
    effectiveDate?: string | undefined;
}

export class OrganizationUnitScheduleDto implements IOrganizationUnitScheduleDto {
    id?: number;
    organizationUnitId?: string;
    dayOfWeek?: number;
    startTime?: string;
    notes?: string | undefined;

    constructor(data?: IOrganizationUnitScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.dayOfWeek = _data["dayOfWeek"];
            this.startTime = _data["startTime"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): OrganizationUnitScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationUnitId"] = this.organizationUnitId;
        data["dayOfWeek"] = this.dayOfWeek;
        data["startTime"] = this.startTime;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IOrganizationUnitScheduleDto {
    id?: number;
    organizationUnitId?: string;
    dayOfWeek?: number;
    startTime?: string;
    notes?: string | undefined;
}

export class CreateScheduleRequest implements ICreateScheduleRequest {
    dayOfWeek?: number;
    startTime?: string;
    notes?: string | undefined;

    constructor(data?: ICreateScheduleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dayOfWeek = _data["dayOfWeek"];
            this.startTime = _data["startTime"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CreateScheduleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateScheduleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dayOfWeek"] = this.dayOfWeek;
        data["startTime"] = this.startTime;
        data["notes"] = this.notes;
        return data;
    }
}

export interface ICreateScheduleRequest {
    dayOfWeek?: number;
    startTime?: string;
    notes?: string | undefined;
}

export class OrganizationUnitEventDto implements IOrganizationUnitEventDto {
    id?: number;
    eventTypeId?: number;
    eventTypeName?: string;
    eventDate?: string;
    notes?: string | undefined;

    constructor(data?: IOrganizationUnitEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.eventTypeId = _data["eventTypeId"];
            this.eventTypeName = _data["eventTypeName"];
            this.eventDate = _data["eventDate"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): OrganizationUnitEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["eventTypeId"] = this.eventTypeId;
        data["eventTypeName"] = this.eventTypeName;
        data["eventDate"] = this.eventDate;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IOrganizationUnitEventDto {
    id?: number;
    eventTypeId?: number;
    eventTypeName?: string;
    eventDate?: string;
    notes?: string | undefined;
}

export class CreateOrganizationUnitEventDto implements ICreateOrganizationUnitEventDto {
    eventTypeId?: number;
    eventDate?: string;
    notes?: string | undefined;

    constructor(data?: ICreateOrganizationUnitEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventTypeId = _data["eventTypeId"];
            this.eventDate = _data["eventDate"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CreateOrganizationUnitEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrganizationUnitEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventTypeId"] = this.eventTypeId;
        data["eventDate"] = this.eventDate;
        data["notes"] = this.notes;
        return data;
    }
}

export interface ICreateOrganizationUnitEventDto {
    eventTypeId?: number;
    eventDate?: string;
    notes?: string | undefined;
}

export class UpdateOrganizationUnitEventDto implements IUpdateOrganizationUnitEventDto {
    eventTypeId?: number;
    eventDate?: string;
    notes?: string | undefined;

    constructor(data?: IUpdateOrganizationUnitEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventTypeId = _data["eventTypeId"];
            this.eventDate = _data["eventDate"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateOrganizationUnitEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrganizationUnitEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventTypeId"] = this.eventTypeId;
        data["eventDate"] = this.eventDate;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IUpdateOrganizationUnitEventDto {
    eventTypeId?: number;
    eventDate?: string;
    notes?: string | undefined;
}

export class OrganizationUnitParentChangeDto implements IOrganizationUnitParentChangeDto {
    id?: number;
    organizationUnitId?: string;
    fromParentUnitId?: string | undefined;
    fromParentUnitName?: string | undefined;
    toParentUnitId?: string | undefined;
    toParentUnitName?: string | undefined;
    effectiveDate?: string;
    reason?: string | undefined;
    createdAtUtc?: string;
    createdByUserName?: string | undefined;

    constructor(data?: IOrganizationUnitParentChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.fromParentUnitId = _data["fromParentUnitId"];
            this.fromParentUnitName = _data["fromParentUnitName"];
            this.toParentUnitId = _data["toParentUnitId"];
            this.toParentUnitName = _data["toParentUnitName"];
            this.effectiveDate = _data["effectiveDate"];
            this.reason = _data["reason"];
            this.createdAtUtc = _data["createdAtUtc"];
            this.createdByUserName = _data["createdByUserName"];
        }
    }

    static fromJS(data: any): OrganizationUnitParentChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitParentChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationUnitId"] = this.organizationUnitId;
        data["fromParentUnitId"] = this.fromParentUnitId;
        data["fromParentUnitName"] = this.fromParentUnitName;
        data["toParentUnitId"] = this.toParentUnitId;
        data["toParentUnitName"] = this.toParentUnitName;
        data["effectiveDate"] = this.effectiveDate;
        data["reason"] = this.reason;
        data["createdAtUtc"] = this.createdAtUtc;
        data["createdByUserName"] = this.createdByUserName;
        return data;
    }
}

export interface IOrganizationUnitParentChangeDto {
    id?: number;
    organizationUnitId?: string;
    fromParentUnitId?: string | undefined;
    fromParentUnitName?: string | undefined;
    toParentUnitId?: string | undefined;
    toParentUnitName?: string | undefined;
    effectiveDate?: string;
    reason?: string | undefined;
    createdAtUtc?: string;
    createdByUserName?: string | undefined;
}

export class OrganizationUnitEventTypeDto implements IOrganizationUnitEventTypeDto {
    value?: number;
    name?: string;
    description?: string;
    sortOrder?: number;

    constructor(data?: IOrganizationUnitEventTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): OrganizationUnitEventTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitEventTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["name"] = this.name;
        data["description"] = this.description;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IOrganizationUnitEventTypeDto {
    value?: number;
    name?: string;
    description?: string;
    sortOrder?: number;
}

export class CreateOrganizationUnitEventTypeDto implements ICreateOrganizationUnitEventTypeDto {
    name?: string;
    description?: string | undefined;
    sortOrder?: number | undefined;

    constructor(data?: ICreateOrganizationUnitEventTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): CreateOrganizationUnitEventTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrganizationUnitEventTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface ICreateOrganizationUnitEventTypeDto {
    name?: string;
    description?: string | undefined;
    sortOrder?: number | undefined;
}

export class UpdateOrganizationUnitEventTypeDto implements IUpdateOrganizationUnitEventTypeDto {
    name?: string;
    description?: string | undefined;
    sortOrder?: number | undefined;

    constructor(data?: IUpdateOrganizationUnitEventTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): UpdateOrganizationUnitEventTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrganizationUnitEventTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IUpdateOrganizationUnitEventTypeDto {
    name?: string;
    description?: string | undefined;
    sortOrder?: number | undefined;
}

export class UpdateOrganizationUnitEventTypeSortOrderDto implements IUpdateOrganizationUnitEventTypeSortOrderDto {
    ids?: number[];

    constructor(data?: IUpdateOrganizationUnitEventTypeSortOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateOrganizationUnitEventTypeSortOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrganizationUnitEventTypeSortOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface IUpdateOrganizationUnitEventTypeSortOrderDto {
    ids?: number[];
}

export class PaginatedResponseOfPeopleListDto implements IPaginatedResponseOfPeopleListDto {
    items?: PeopleListDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResponseOfPeopleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PeopleListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfPeopleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfPeopleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedResponseOfPeopleListDto {
    items?: PeopleListDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class PeopleListDto implements IPeopleListDto {
    id?: string;
    photoUrl?: string | undefined;
    firstName?: string;
    lastName?: string;
    email?: string | undefined;
    documentType?: DocumentType | undefined;
    documentNumber?: string | undefined;
    birthDate?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    membershipUnitId?: string | undefined;
    membershipUnitName?: string | undefined;
    responsiblePriestId?: string | undefined;
    responsiblePriestName?: string | undefined;
    ministryId?: number | undefined;
    ministryName?: string | undefined;
    isHomeAttended?: boolean;
    hasActiveUser?: boolean;
    ageStatus?: PersonAgeStatus | undefined;

    constructor(data?: IPeopleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.photoUrl = _data["photoUrl"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.documentType = _data["documentType"];
            this.documentNumber = _data["documentNumber"];
            this.birthDate = _data["birthDate"];
            this.phone = _data["phone"];
            this.address = _data["address"];
            this.membershipUnitId = _data["membershipUnitId"];
            this.membershipUnitName = _data["membershipUnitName"];
            this.responsiblePriestId = _data["responsiblePriestId"];
            this.responsiblePriestName = _data["responsiblePriestName"];
            this.ministryId = _data["ministryId"];
            this.ministryName = _data["ministryName"];
            this.isHomeAttended = _data["isHomeAttended"];
            this.hasActiveUser = _data["hasActiveUser"];
            this.ageStatus = _data["ageStatus"];
        }
    }

    static fromJS(data: any): PeopleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PeopleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["photoUrl"] = this.photoUrl;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["documentType"] = this.documentType;
        data["documentNumber"] = this.documentNumber;
        data["birthDate"] = this.birthDate;
        data["phone"] = this.phone;
        data["address"] = this.address;
        data["membershipUnitId"] = this.membershipUnitId;
        data["membershipUnitName"] = this.membershipUnitName;
        data["responsiblePriestId"] = this.responsiblePriestId;
        data["responsiblePriestName"] = this.responsiblePriestName;
        data["ministryId"] = this.ministryId;
        data["ministryName"] = this.ministryName;
        data["isHomeAttended"] = this.isHomeAttended;
        data["hasActiveUser"] = this.hasActiveUser;
        data["ageStatus"] = this.ageStatus;
        return data;
    }
}

export interface IPeopleListDto {
    id?: string;
    photoUrl?: string | undefined;
    firstName?: string;
    lastName?: string;
    email?: string | undefined;
    documentType?: DocumentType | undefined;
    documentNumber?: string | undefined;
    birthDate?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    membershipUnitId?: string | undefined;
    membershipUnitName?: string | undefined;
    responsiblePriestId?: string | undefined;
    responsiblePriestName?: string | undefined;
    ministryId?: number | undefined;
    ministryName?: string | undefined;
    isHomeAttended?: boolean;
    hasActiveUser?: boolean;
    ageStatus?: PersonAgeStatus | undefined;
}

export class PaginatedResponseOfAdminPersonListDto implements IPaginatedResponseOfAdminPersonListDto {
    items?: AdminPersonListDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResponseOfAdminPersonListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AdminPersonListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfAdminPersonListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfAdminPersonListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedResponseOfAdminPersonListDto {
    items?: AdminPersonListDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class AdminPersonListDto implements IAdminPersonListDto {
    id?: string;
    firstName?: string;
    lastName?: string;
    portalMemberId?: string | undefined;
    documentNumber?: string | undefined;
    membershipUnitName?: string | undefined;
    status?: MembershipStatus;
    isDeleted?: boolean;
    isMerged?: boolean;
    deletedAtUtc?: string | undefined;
    lastModifiedAtUtc?: string | undefined;

    constructor(data?: IAdminPersonListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.portalMemberId = _data["portalMemberId"];
            this.documentNumber = _data["documentNumber"];
            this.membershipUnitName = _data["membershipUnitName"];
            this.status = _data["status"];
            this.isDeleted = _data["isDeleted"];
            this.isMerged = _data["isMerged"];
            this.deletedAtUtc = _data["deletedAtUtc"];
            this.lastModifiedAtUtc = _data["lastModifiedAtUtc"];
        }
    }

    static fromJS(data: any): AdminPersonListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminPersonListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["portalMemberId"] = this.portalMemberId;
        data["documentNumber"] = this.documentNumber;
        data["membershipUnitName"] = this.membershipUnitName;
        data["status"] = this.status;
        data["isDeleted"] = this.isDeleted;
        data["isMerged"] = this.isMerged;
        data["deletedAtUtc"] = this.deletedAtUtc;
        data["lastModifiedAtUtc"] = this.lastModifiedAtUtc;
        return data;
    }
}

export interface IAdminPersonListDto {
    id?: string;
    firstName?: string;
    lastName?: string;
    portalMemberId?: string | undefined;
    documentNumber?: string | undefined;
    membershipUnitName?: string | undefined;
    status?: MembershipStatus;
    isDeleted?: boolean;
    isMerged?: boolean;
    deletedAtUtc?: string | undefined;
    lastModifiedAtUtc?: string | undefined;
}

export class PaginatedResponseOfMemberFollowUpListItemDto implements IPaginatedResponseOfMemberFollowUpListItemDto {
    items?: MemberFollowUpListItemDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResponseOfMemberFollowUpListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MemberFollowUpListItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfMemberFollowUpListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfMemberFollowUpListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedResponseOfMemberFollowUpListItemDto {
    items?: MemberFollowUpListItemDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class MemberFollowUpListItemDto implements IMemberFollowUpListItemDto {
    id?: string;
    fullName?: string;
    communityName?: string;
    status?: MembershipStatus;
    ageStatus?: PersonAgeStatus | undefined;
    age?: number | undefined;
    responsiblePriestId?: string | undefined;
    responsiblePriestName?: string | undefined;
    isHomeAttended?: boolean;
    lastAttendanceAt?: string | undefined;
    lastSpiritualAssistanceVisitDate?: string | undefined;
    lastHolyCommunionDate?: string | undefined;

    constructor(data?: IMemberFollowUpListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.communityName = _data["communityName"];
            this.status = _data["status"];
            this.ageStatus = _data["ageStatus"];
            this.age = _data["age"];
            this.responsiblePriestId = _data["responsiblePriestId"];
            this.responsiblePriestName = _data["responsiblePriestName"];
            this.isHomeAttended = _data["isHomeAttended"];
            this.lastAttendanceAt = _data["lastAttendanceAt"];
            this.lastSpiritualAssistanceVisitDate = _data["lastSpiritualAssistanceVisitDate"];
            this.lastHolyCommunionDate = _data["lastHolyCommunionDate"];
        }
    }

    static fromJS(data: any): MemberFollowUpListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MemberFollowUpListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["communityName"] = this.communityName;
        data["status"] = this.status;
        data["ageStatus"] = this.ageStatus;
        data["age"] = this.age;
        data["responsiblePriestId"] = this.responsiblePriestId;
        data["responsiblePriestName"] = this.responsiblePriestName;
        data["isHomeAttended"] = this.isHomeAttended;
        data["lastAttendanceAt"] = this.lastAttendanceAt;
        data["lastSpiritualAssistanceVisitDate"] = this.lastSpiritualAssistanceVisitDate;
        data["lastHolyCommunionDate"] = this.lastHolyCommunionDate;
        return data;
    }
}

export interface IMemberFollowUpListItemDto {
    id?: string;
    fullName?: string;
    communityName?: string;
    status?: MembershipStatus;
    ageStatus?: PersonAgeStatus | undefined;
    age?: number | undefined;
    responsiblePriestId?: string | undefined;
    responsiblePriestName?: string | undefined;
    isHomeAttended?: boolean;
    lastAttendanceAt?: string | undefined;
    lastSpiritualAssistanceVisitDate?: string | undefined;
    lastHolyCommunionDate?: string | undefined;
}

export class PaginatedResponseOfMemberFollowUpResponsiblePriestDto implements IPaginatedResponseOfMemberFollowUpResponsiblePriestDto {
    items?: MemberFollowUpResponsiblePriestDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResponseOfMemberFollowUpResponsiblePriestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MemberFollowUpResponsiblePriestDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfMemberFollowUpResponsiblePriestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfMemberFollowUpResponsiblePriestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedResponseOfMemberFollowUpResponsiblePriestDto {
    items?: MemberFollowUpResponsiblePriestDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class MemberFollowUpResponsiblePriestDto implements IMemberFollowUpResponsiblePriestDto {
    id?: string;
    fullName?: string;
    ministryName?: string;
    ministryActivityUnitNames?: string[];

    constructor(data?: IMemberFollowUpResponsiblePriestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.ministryName = _data["ministryName"];
            if (Array.isArray(_data["ministryActivityUnitNames"])) {
                this.ministryActivityUnitNames = [] as any;
                for (let item of _data["ministryActivityUnitNames"])
                    this.ministryActivityUnitNames!.push(item);
            }
        }
    }

    static fromJS(data: any): MemberFollowUpResponsiblePriestDto {
        data = typeof data === 'object' ? data : {};
        let result = new MemberFollowUpResponsiblePriestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["ministryName"] = this.ministryName;
        if (Array.isArray(this.ministryActivityUnitNames)) {
            data["ministryActivityUnitNames"] = [];
            for (let item of this.ministryActivityUnitNames)
                data["ministryActivityUnitNames"].push(item);
        }
        return data;
    }
}

export interface IMemberFollowUpResponsiblePriestDto {
    id?: string;
    fullName?: string;
    ministryName?: string;
    ministryActivityUnitNames?: string[];
}

export class UpdatePersonHomeAttendanceDto implements IUpdatePersonHomeAttendanceDto {
    isHomeAttended?: boolean;

    constructor(data?: IUpdatePersonHomeAttendanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isHomeAttended = _data["isHomeAttended"];
        }
    }

    static fromJS(data: any): UpdatePersonHomeAttendanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePersonHomeAttendanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isHomeAttended"] = this.isHomeAttended;
        return data;
    }
}

export interface IUpdatePersonHomeAttendanceDto {
    isHomeAttended?: boolean;
}

export class DeletedPersonDto implements IDeletedPersonDto {
    id?: string;
    fullName?: string;
    portalMemberId?: string | undefined;
    documentNumber?: string | undefined;
    membershipUnitName?: string | undefined;
    deletedAtUtc?: string | undefined;
    deletionReason?: string | undefined;

    constructor(data?: IDeletedPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.portalMemberId = _data["portalMemberId"];
            this.documentNumber = _data["documentNumber"];
            this.membershipUnitName = _data["membershipUnitName"];
            this.deletedAtUtc = _data["deletedAtUtc"];
            this.deletionReason = _data["deletionReason"];
        }
    }

    static fromJS(data: any): DeletedPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeletedPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["portalMemberId"] = this.portalMemberId;
        data["documentNumber"] = this.documentNumber;
        data["membershipUnitName"] = this.membershipUnitName;
        data["deletedAtUtc"] = this.deletedAtUtc;
        data["deletionReason"] = this.deletionReason;
        return data;
    }
}

export interface IDeletedPersonDto {
    id?: string;
    fullName?: string;
    portalMemberId?: string | undefined;
    documentNumber?: string | undefined;
    membershipUnitName?: string | undefined;
    deletedAtUtc?: string | undefined;
    deletionReason?: string | undefined;
}

export class PersonFamilyRelationshipsDto implements IPersonFamilyRelationshipsDto {
    parents?: PersonRelationshipDto[];
    children?: PersonRelationshipDto[];

    constructor(data?: IPersonFamilyRelationshipsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["parents"])) {
                this.parents = [] as any;
                for (let item of _data["parents"])
                    this.parents!.push(PersonRelationshipDto.fromJS(item));
            }
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(PersonRelationshipDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PersonFamilyRelationshipsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonFamilyRelationshipsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.parents)) {
            data["parents"] = [];
            for (let item of this.parents)
                data["parents"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPersonFamilyRelationshipsDto {
    parents?: PersonRelationshipDto[];
    children?: PersonRelationshipDto[];
}

export class PersonRelationshipDto implements IPersonRelationshipDto {
    id?: number;
    relationshipType?: RelationshipType;
    relatedPersonId?: string | undefined;
    relatedPersonName?: string;
    isRelatedPersonDeceased?: boolean;
    validFrom?: string | undefined;
    validTo?: string | undefined;
    notes?: string | undefined;

    constructor(data?: IPersonRelationshipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.relationshipType = _data["relationshipType"];
            this.relatedPersonId = _data["relatedPersonId"];
            this.relatedPersonName = _data["relatedPersonName"];
            this.isRelatedPersonDeceased = _data["isRelatedPersonDeceased"];
            this.validFrom = _data["validFrom"];
            this.validTo = _data["validTo"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): PersonRelationshipDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonRelationshipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["relationshipType"] = this.relationshipType;
        data["relatedPersonId"] = this.relatedPersonId;
        data["relatedPersonName"] = this.relatedPersonName;
        data["isRelatedPersonDeceased"] = this.isRelatedPersonDeceased;
        data["validFrom"] = this.validFrom;
        data["validTo"] = this.validTo;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IPersonRelationshipDto {
    id?: number;
    relationshipType?: RelationshipType;
    relatedPersonId?: string | undefined;
    relatedPersonName?: string;
    isRelatedPersonDeceased?: boolean;
    validFrom?: string | undefined;
    validTo?: string | undefined;
    notes?: string | undefined;
}

export type RelationshipType = "Parent" | "Child";

export class ResponsiblePriestCandidateDto implements IResponsiblePriestCandidateDto {
    id?: string;
    fullName?: string;
    ministryName?: string;

    constructor(data?: IResponsiblePriestCandidateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.ministryName = _data["ministryName"];
        }
    }

    static fromJS(data: any): ResponsiblePriestCandidateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponsiblePriestCandidateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["ministryName"] = this.ministryName;
        return data;
    }
}

export interface IResponsiblePriestCandidateDto {
    id?: string;
    fullName?: string;
    ministryName?: string;
}

export class ResponsiblePriestMemberDto implements IResponsiblePriestMemberDto {
    id?: string;
    firstName?: string;
    lastName?: string;
    phone?: string | undefined;
    membershipUnitName?: string | undefined;

    constructor(data?: IResponsiblePriestMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phone = _data["phone"];
            this.membershipUnitName = _data["membershipUnitName"];
        }
    }

    static fromJS(data: any): ResponsiblePriestMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponsiblePriestMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phone"] = this.phone;
        data["membershipUnitName"] = this.membershipUnitName;
        return data;
    }
}

export interface IResponsiblePriestMemberDto {
    id?: string;
    firstName?: string;
    lastName?: string;
    phone?: string | undefined;
    membershipUnitName?: string | undefined;
}

export class UpdateResponsiblePriestDto implements IUpdateResponsiblePriestDto {
    responsiblePriestId?: string | undefined;

    constructor(data?: IUpdateResponsiblePriestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responsiblePriestId = _data["responsiblePriestId"];
        }
    }

    static fromJS(data: any): UpdateResponsiblePriestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateResponsiblePriestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responsiblePriestId"] = this.responsiblePriestId;
        return data;
    }
}

export interface IUpdateResponsiblePriestDto {
    responsiblePriestId?: string | undefined;
}

export class BulkUpdateResponsiblePriestDto extends UpdateResponsiblePriestDto implements IBulkUpdateResponsiblePriestDto {
    personIds?: string[];

    constructor(data?: IBulkUpdateResponsiblePriestDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["personIds"])) {
                this.personIds = [] as any;
                for (let item of _data["personIds"])
                    this.personIds!.push(item);
            }
        }
    }

    static override fromJS(data: any): BulkUpdateResponsiblePriestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BulkUpdateResponsiblePriestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.personIds)) {
            data["personIds"] = [];
            for (let item of this.personIds)
                data["personIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IBulkUpdateResponsiblePriestDto extends IUpdateResponsiblePriestDto {
    personIds?: string[];
}

export class SavePersonFamilyRelationshipsDto implements ISavePersonFamilyRelationshipsDto {
    parents?: PersonRelationshipDto[];
    children?: PersonRelationshipDto[];

    constructor(data?: ISavePersonFamilyRelationshipsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["parents"])) {
                this.parents = [] as any;
                for (let item of _data["parents"])
                    this.parents!.push(PersonRelationshipDto.fromJS(item));
            }
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(PersonRelationshipDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SavePersonFamilyRelationshipsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SavePersonFamilyRelationshipsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.parents)) {
            data["parents"] = [];
            for (let item of this.parents)
                data["parents"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISavePersonFamilyRelationshipsDto {
    parents?: PersonRelationshipDto[];
    children?: PersonRelationshipDto[];
}

export class PersonEventDto implements IPersonEventDto {
    id?: number;
    category?: PersonEventCategory;
    categoryName?: string;
    eventKind?: string;
    eventTypeKey?: string;
    eventTypeName?: string;
    eventDate?: string;
    endDate?: string | undefined;
    organizationUnitId?: string | undefined;
    organizationUnitName?: string | undefined;
    actOrganizationUnitId?: string | undefined;
    actOrganizationUnitName?: string | undefined;
    detail?: string | undefined;
    notes?: string | undefined;
    canEdit?: boolean;
    canDelete?: boolean;
    ministryId?: number | undefined;
    ministryStatus?: MinistryStatus | undefined;
    appointmentId?: number | undefined;
    assignmentId?: number | undefined;
    requiresActiveMinistry?: boolean;
    activityId?: number | undefined;
    activityRoleId?: number | undefined;
    religiousEventType?: ReligiousEventType | undefined;
    locationOrganizationUnitId?: string | undefined;
    locationOrganizationUnitName?: string | undefined;
    location?: string | undefined;
    anniversaryYears?: number | undefined;
    relatedPersonId?: string | undefined;
    relatedPersonName?: string | undefined;
    relatedPersonCanView?: boolean;
    ministerialAreas?: MinisterialActivityAreaDto[];
    generatedActivityChanges?: MinisterialActivityAreaDto[];
    generatedMembershipTransfer?: MembershipTransferEffectDto | undefined;

    constructor(data?: IPersonEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.category = _data["category"];
            this.categoryName = _data["categoryName"];
            this.eventKind = _data["eventKind"];
            this.eventTypeKey = _data["eventTypeKey"];
            this.eventTypeName = _data["eventTypeName"];
            this.eventDate = _data["eventDate"];
            this.endDate = _data["endDate"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.organizationUnitName = _data["organizationUnitName"];
            this.actOrganizationUnitId = _data["actOrganizationUnitId"];
            this.actOrganizationUnitName = _data["actOrganizationUnitName"];
            this.detail = _data["detail"];
            this.notes = _data["notes"];
            this.canEdit = _data["canEdit"];
            this.canDelete = _data["canDelete"];
            this.ministryId = _data["ministryId"];
            this.ministryStatus = _data["ministryStatus"];
            this.appointmentId = _data["appointmentId"];
            this.assignmentId = _data["assignmentId"];
            this.requiresActiveMinistry = _data["requiresActiveMinistry"];
            this.activityId = _data["activityId"];
            this.activityRoleId = _data["activityRoleId"];
            this.religiousEventType = _data["religiousEventType"];
            this.locationOrganizationUnitId = _data["locationOrganizationUnitId"];
            this.locationOrganizationUnitName = _data["locationOrganizationUnitName"];
            this.location = _data["location"];
            this.anniversaryYears = _data["anniversaryYears"];
            this.relatedPersonId = _data["relatedPersonId"];
            this.relatedPersonName = _data["relatedPersonName"];
            this.relatedPersonCanView = _data["relatedPersonCanView"];
            if (Array.isArray(_data["ministerialAreas"])) {
                this.ministerialAreas = [] as any;
                for (let item of _data["ministerialAreas"])
                    this.ministerialAreas!.push(MinisterialActivityAreaDto.fromJS(item));
            }
            if (Array.isArray(_data["generatedActivityChanges"])) {
                this.generatedActivityChanges = [] as any;
                for (let item of _data["generatedActivityChanges"])
                    this.generatedActivityChanges!.push(MinisterialActivityAreaDto.fromJS(item));
            }
            this.generatedMembershipTransfer = _data["generatedMembershipTransfer"] ? MembershipTransferEffectDto.fromJS(_data["generatedMembershipTransfer"]) : undefined as any;
        }
    }

    static fromJS(data: any): PersonEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["category"] = this.category;
        data["categoryName"] = this.categoryName;
        data["eventKind"] = this.eventKind;
        data["eventTypeKey"] = this.eventTypeKey;
        data["eventTypeName"] = this.eventTypeName;
        data["eventDate"] = this.eventDate;
        data["endDate"] = this.endDate;
        data["organizationUnitId"] = this.organizationUnitId;
        data["organizationUnitName"] = this.organizationUnitName;
        data["actOrganizationUnitId"] = this.actOrganizationUnitId;
        data["actOrganizationUnitName"] = this.actOrganizationUnitName;
        data["detail"] = this.detail;
        data["notes"] = this.notes;
        data["canEdit"] = this.canEdit;
        data["canDelete"] = this.canDelete;
        data["ministryId"] = this.ministryId;
        data["ministryStatus"] = this.ministryStatus;
        data["appointmentId"] = this.appointmentId;
        data["assignmentId"] = this.assignmentId;
        data["requiresActiveMinistry"] = this.requiresActiveMinistry;
        data["activityId"] = this.activityId;
        data["activityRoleId"] = this.activityRoleId;
        data["religiousEventType"] = this.religiousEventType;
        data["locationOrganizationUnitId"] = this.locationOrganizationUnitId;
        data["locationOrganizationUnitName"] = this.locationOrganizationUnitName;
        data["location"] = this.location;
        data["anniversaryYears"] = this.anniversaryYears;
        data["relatedPersonId"] = this.relatedPersonId;
        data["relatedPersonName"] = this.relatedPersonName;
        data["relatedPersonCanView"] = this.relatedPersonCanView;
        if (Array.isArray(this.ministerialAreas)) {
            data["ministerialAreas"] = [];
            for (let item of this.ministerialAreas)
                data["ministerialAreas"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.generatedActivityChanges)) {
            data["generatedActivityChanges"] = [];
            for (let item of this.generatedActivityChanges)
                data["generatedActivityChanges"].push(item ? item.toJSON() : undefined as any);
        }
        data["generatedMembershipTransfer"] = this.generatedMembershipTransfer ? this.generatedMembershipTransfer.toJSON() : undefined as any;
        return data;
    }
}

export interface IPersonEventDto {
    id?: number;
    category?: PersonEventCategory;
    categoryName?: string;
    eventKind?: string;
    eventTypeKey?: string;
    eventTypeName?: string;
    eventDate?: string;
    endDate?: string | undefined;
    organizationUnitId?: string | undefined;
    organizationUnitName?: string | undefined;
    actOrganizationUnitId?: string | undefined;
    actOrganizationUnitName?: string | undefined;
    detail?: string | undefined;
    notes?: string | undefined;
    canEdit?: boolean;
    canDelete?: boolean;
    ministryId?: number | undefined;
    ministryStatus?: MinistryStatus | undefined;
    appointmentId?: number | undefined;
    assignmentId?: number | undefined;
    requiresActiveMinistry?: boolean;
    activityId?: number | undefined;
    activityRoleId?: number | undefined;
    religiousEventType?: ReligiousEventType | undefined;
    locationOrganizationUnitId?: string | undefined;
    locationOrganizationUnitName?: string | undefined;
    location?: string | undefined;
    anniversaryYears?: number | undefined;
    relatedPersonId?: string | undefined;
    relatedPersonName?: string | undefined;
    relatedPersonCanView?: boolean;
    ministerialAreas?: MinisterialActivityAreaDto[];
    generatedActivityChanges?: MinisterialActivityAreaDto[];
    generatedMembershipTransfer?: MembershipTransferEffectDto | undefined;
}

export type PersonEventCategory = "Collaboration" | "MinisterialActivity" | "ReligiousEvent";

export type ReligiousEventType = "Baptism" | "Sealing" | "Confirmation" | "Adoption" | "Wedding" | "WeddingAnniversary" | "Engagement" | "PrenatalBlessing";

export class MinisterialActivityAreaDto implements IMinisterialActivityAreaDto {
    ministryChangeId?: number;
    recordId?: number;
    kind?: MinisterialActivityKind;
    referenceId?: number;
    referenceName?: string;
    organizationUnitId?: string | undefined;
    organizationUnitName?: string;
    isHistoricalOrganizationUnit?: boolean;
    changeType?: MinisterialAreaChangeType;
    validFrom?: string;
    validTo?: string | undefined;

    constructor(data?: IMinisterialActivityAreaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ministryChangeId = _data["ministryChangeId"];
            this.recordId = _data["recordId"];
            this.kind = _data["kind"];
            this.referenceId = _data["referenceId"];
            this.referenceName = _data["referenceName"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.organizationUnitName = _data["organizationUnitName"];
            this.isHistoricalOrganizationUnit = _data["isHistoricalOrganizationUnit"];
            this.changeType = _data["changeType"];
            this.validFrom = _data["validFrom"];
            this.validTo = _data["validTo"];
        }
    }

    static fromJS(data: any): MinisterialActivityAreaDto {
        data = typeof data === 'object' ? data : {};
        let result = new MinisterialActivityAreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ministryChangeId"] = this.ministryChangeId;
        data["recordId"] = this.recordId;
        data["kind"] = this.kind;
        data["referenceId"] = this.referenceId;
        data["referenceName"] = this.referenceName;
        data["organizationUnitId"] = this.organizationUnitId;
        data["organizationUnitName"] = this.organizationUnitName;
        data["isHistoricalOrganizationUnit"] = this.isHistoricalOrganizationUnit;
        data["changeType"] = this.changeType;
        data["validFrom"] = this.validFrom;
        data["validTo"] = this.validTo;
        return data;
    }
}

export interface IMinisterialActivityAreaDto {
    ministryChangeId?: number;
    recordId?: number;
    kind?: MinisterialActivityKind;
    referenceId?: number;
    referenceName?: string;
    organizationUnitId?: string | undefined;
    organizationUnitName?: string;
    isHistoricalOrganizationUnit?: boolean;
    changeType?: MinisterialAreaChangeType;
    validFrom?: string;
    validTo?: string | undefined;
}

export type MinisterialActivityKind = "Ministry" | "Appointment" | "Assignment";

export type MinisterialAreaChangeType = "Added" | "Ended";

export class MembershipTransferEffectDto implements IMembershipTransferEffectDto {
    fromOrganizationUnitId?: string | undefined;
    fromOrganizationUnitName?: string | undefined;
    toOrganizationUnitId?: string;
    toOrganizationUnitName?: string;

    constructor(data?: IMembershipTransferEffectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromOrganizationUnitId = _data["fromOrganizationUnitId"];
            this.fromOrganizationUnitName = _data["fromOrganizationUnitName"];
            this.toOrganizationUnitId = _data["toOrganizationUnitId"];
            this.toOrganizationUnitName = _data["toOrganizationUnitName"];
        }
    }

    static fromJS(data: any): MembershipTransferEffectDto {
        data = typeof data === 'object' ? data : {};
        let result = new MembershipTransferEffectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromOrganizationUnitId"] = this.fromOrganizationUnitId;
        data["fromOrganizationUnitName"] = this.fromOrganizationUnitName;
        data["toOrganizationUnitId"] = this.toOrganizationUnitId;
        data["toOrganizationUnitName"] = this.toOrganizationUnitName;
        return data;
    }
}

export interface IMembershipTransferEffectDto {
    fromOrganizationUnitId?: string | undefined;
    fromOrganizationUnitName?: string | undefined;
    toOrganizationUnitId?: string;
    toOrganizationUnitName?: string;
}

export class MinisterialActivityEffectiveStateDto implements IMinisterialActivityEffectiveStateDto {
    effectiveDate?: string;
    ministryId?: number | undefined;
    ministryName?: string | undefined;
    status?: MinistryStatus | undefined;
    designations?: MinisterialActivityEffectiveDesignationDto[];

    constructor(data?: IMinisterialActivityEffectiveStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.effectiveDate = _data["effectiveDate"];
            this.ministryId = _data["ministryId"];
            this.ministryName = _data["ministryName"];
            this.status = _data["status"];
            if (Array.isArray(_data["designations"])) {
                this.designations = [] as any;
                for (let item of _data["designations"])
                    this.designations!.push(MinisterialActivityEffectiveDesignationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MinisterialActivityEffectiveStateDto {
        data = typeof data === 'object' ? data : {};
        let result = new MinisterialActivityEffectiveStateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["effectiveDate"] = this.effectiveDate;
        data["ministryId"] = this.ministryId;
        data["ministryName"] = this.ministryName;
        data["status"] = this.status;
        if (Array.isArray(this.designations)) {
            data["designations"] = [];
            for (let item of this.designations)
                data["designations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMinisterialActivityEffectiveStateDto {
    effectiveDate?: string;
    ministryId?: number | undefined;
    ministryName?: string | undefined;
    status?: MinistryStatus | undefined;
    designations?: MinisterialActivityEffectiveDesignationDto[];
}

export class MinisterialActivityEffectiveDesignationDto implements IMinisterialActivityEffectiveDesignationDto {
    kind?: MinisterialActivityKind;
    referenceId?: number;
    referenceName?: string;
    organizationUnitId?: string | undefined;
    organizationUnitName?: string;
    isHistoricalOrganizationUnit?: boolean;

    constructor(data?: IMinisterialActivityEffectiveDesignationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kind = _data["kind"];
            this.referenceId = _data["referenceId"];
            this.referenceName = _data["referenceName"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.organizationUnitName = _data["organizationUnitName"];
            this.isHistoricalOrganizationUnit = _data["isHistoricalOrganizationUnit"];
        }
    }

    static fromJS(data: any): MinisterialActivityEffectiveDesignationDto {
        data = typeof data === 'object' ? data : {};
        let result = new MinisterialActivityEffectiveDesignationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kind"] = this.kind;
        data["referenceId"] = this.referenceId;
        data["referenceName"] = this.referenceName;
        data["organizationUnitId"] = this.organizationUnitId;
        data["organizationUnitName"] = this.organizationUnitName;
        data["isHistoricalOrganizationUnit"] = this.isHistoricalOrganizationUnit;
        return data;
    }
}

export interface IMinisterialActivityEffectiveDesignationDto {
    kind?: MinisterialActivityKind;
    referenceId?: number;
    referenceName?: string;
    organizationUnitId?: string | undefined;
    organizationUnitName?: string;
    isHistoricalOrganizationUnit?: boolean;
}

export class MinisterialActivityActionDefinitionDto implements IMinisterialActivityActionDefinitionDto {
    eventType?: MinistryEventType;
    requiresEffectiveDate?: boolean;
    requiresActPlace?: boolean;
    requiresComment?: boolean;
    requiresMinistry?: boolean;
    requiresAppointmentOrAssignment?: boolean;
    requiresArea?: boolean;
    requiresExpectedEndDate?: boolean;
    targetStatus?: MinistryStatus | undefined;

    constructor(data?: IMinisterialActivityActionDefinitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventType = _data["eventType"];
            this.requiresEffectiveDate = _data["requiresEffectiveDate"];
            this.requiresActPlace = _data["requiresActPlace"];
            this.requiresComment = _data["requiresComment"];
            this.requiresMinistry = _data["requiresMinistry"];
            this.requiresAppointmentOrAssignment = _data["requiresAppointmentOrAssignment"];
            this.requiresArea = _data["requiresArea"];
            this.requiresExpectedEndDate = _data["requiresExpectedEndDate"];
            this.targetStatus = _data["targetStatus"];
        }
    }

    static fromJS(data: any): MinisterialActivityActionDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MinisterialActivityActionDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventType"] = this.eventType;
        data["requiresEffectiveDate"] = this.requiresEffectiveDate;
        data["requiresActPlace"] = this.requiresActPlace;
        data["requiresComment"] = this.requiresComment;
        data["requiresMinistry"] = this.requiresMinistry;
        data["requiresAppointmentOrAssignment"] = this.requiresAppointmentOrAssignment;
        data["requiresArea"] = this.requiresArea;
        data["requiresExpectedEndDate"] = this.requiresExpectedEndDate;
        data["targetStatus"] = this.targetStatus;
        return data;
    }
}

export interface IMinisterialActivityActionDefinitionDto {
    eventType?: MinistryEventType;
    requiresEffectiveDate?: boolean;
    requiresActPlace?: boolean;
    requiresComment?: boolean;
    requiresMinistry?: boolean;
    requiresAppointmentOrAssignment?: boolean;
    requiresArea?: boolean;
    requiresExpectedEndDate?: boolean;
    targetStatus?: MinistryStatus | undefined;
}

export type MinistryEventType = "Ordination" | "Reinstatement" | "LeaveOfAbsence" | "Transfer" | "Death" | "Resignation" | "Dismissal" | "Retirement" | "Confirmation" | "Reassignment" | "AppointmentAssignment" | "AppointmentEnd" | "ApostleAreaTransferIn" | "ApostleAreaTransferOut" | "MinisterialActivityExtension" | "MinisterialLicenseRenewal" | "FormerMinisterAsOfficiant" | "NewOfficiant" | "MinisterialInstitution";

export class PersonCommunityHistoryDto implements IPersonCommunityHistoryDto {
    id?: number;
    organizationUnitId?: string | undefined;
    organizationUnitName?: string;
    validFrom?: string | undefined;
    validTo?: string | undefined;
    reason?: string | undefined;
    hasApprovedMinistryTransfer?: boolean;
    isCurrent?: boolean;

    constructor(data?: IPersonCommunityHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.organizationUnitName = _data["organizationUnitName"];
            this.validFrom = _data["validFrom"];
            this.validTo = _data["validTo"];
            this.reason = _data["reason"];
            this.hasApprovedMinistryTransfer = _data["hasApprovedMinistryTransfer"];
            this.isCurrent = _data["isCurrent"];
        }
    }

    static fromJS(data: any): PersonCommunityHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonCommunityHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationUnitId"] = this.organizationUnitId;
        data["organizationUnitName"] = this.organizationUnitName;
        data["validFrom"] = this.validFrom;
        data["validTo"] = this.validTo;
        data["reason"] = this.reason;
        data["hasApprovedMinistryTransfer"] = this.hasApprovedMinistryTransfer;
        data["isCurrent"] = this.isCurrent;
        return data;
    }
}

export interface IPersonCommunityHistoryDto {
    id?: number;
    organizationUnitId?: string | undefined;
    organizationUnitName?: string;
    validFrom?: string | undefined;
    validTo?: string | undefined;
    reason?: string | undefined;
    hasApprovedMinistryTransfer?: boolean;
    isCurrent?: boolean;
}

export class ValidateCommunityTransferDateDto implements IValidateCommunityTransferDateDto {
    effectiveDate?: string;

    constructor(data?: IValidateCommunityTransferDateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.effectiveDate = _data["effectiveDate"];
        }
    }

    static fromJS(data: any): ValidateCommunityTransferDateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateCommunityTransferDateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["effectiveDate"] = this.effectiveDate;
        return data;
    }
}

export interface IValidateCommunityTransferDateDto {
    effectiveDate?: string;
}

export class PersonDivineServiceAttendanceDto implements IPersonDivineServiceAttendanceDto {
    divineServiceId?: string;
    startAt?: string;
    divineServiceTypeName?: string;
    organizationUnitId?: string;
    organizationUnitName?: string;
    attendanceCategory?: AttendanceCategory;
    ageStatus?: PersonAgeStatus;
    isSealed?: boolean;
    isClosed?: boolean;

    constructor(data?: IPersonDivineServiceAttendanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.divineServiceId = _data["divineServiceId"];
            this.startAt = _data["startAt"];
            this.divineServiceTypeName = _data["divineServiceTypeName"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.organizationUnitName = _data["organizationUnitName"];
            this.attendanceCategory = _data["attendanceCategory"];
            this.ageStatus = _data["ageStatus"];
            this.isSealed = _data["isSealed"];
            this.isClosed = _data["isClosed"];
        }
    }

    static fromJS(data: any): PersonDivineServiceAttendanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonDivineServiceAttendanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["divineServiceId"] = this.divineServiceId;
        data["startAt"] = this.startAt;
        data["divineServiceTypeName"] = this.divineServiceTypeName;
        data["organizationUnitId"] = this.organizationUnitId;
        data["organizationUnitName"] = this.organizationUnitName;
        data["attendanceCategory"] = this.attendanceCategory;
        data["ageStatus"] = this.ageStatus;
        data["isSealed"] = this.isSealed;
        data["isClosed"] = this.isClosed;
        return data;
    }
}

export interface IPersonDivineServiceAttendanceDto {
    divineServiceId?: string;
    startAt?: string;
    divineServiceTypeName?: string;
    organizationUnitId?: string;
    organizationUnitName?: string;
    attendanceCategory?: AttendanceCategory;
    ageStatus?: PersonAgeStatus;
    isSealed?: boolean;
    isClosed?: boolean;
}

export class CreatePersonCommunityHistoryDto implements ICreatePersonCommunityHistoryDto {
    organizationUnitId?: string;
    validFrom?: string;
    reason?: string | undefined;

    constructor(data?: ICreatePersonCommunityHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationUnitId = _data["organizationUnitId"];
            this.validFrom = _data["validFrom"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): CreatePersonCommunityHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePersonCommunityHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitId"] = this.organizationUnitId;
        data["validFrom"] = this.validFrom;
        data["reason"] = this.reason;
        return data;
    }
}

export interface ICreatePersonCommunityHistoryDto {
    organizationUnitId?: string;
    validFrom?: string;
    reason?: string | undefined;
}

export class UpdatePersonCommunityHistoryDto implements IUpdatePersonCommunityHistoryDto {
    organizationUnitId?: string;
    validFrom?: string;
    reason?: string | undefined;

    constructor(data?: IUpdatePersonCommunityHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationUnitId = _data["organizationUnitId"];
            this.validFrom = _data["validFrom"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): UpdatePersonCommunityHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePersonCommunityHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitId"] = this.organizationUnitId;
        data["validFrom"] = this.validFrom;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IUpdatePersonCommunityHistoryDto {
    organizationUnitId?: string;
    validFrom?: string;
    reason?: string | undefined;
}

export class PersonEventEditorContextDto implements IPersonEventEditorContextDto {
    units?: PersonEventUnitContextDto[];
    communities?: PersonEventUnitContextDto[];
    ministries?: PersonEventReferenceOptionDto[];
    appointments?: PersonEventReferenceOptionDto[];
    assignments?: PersonEventReferenceOptionDto[];
    activities?: PersonEventActivityOptionDto[];
    activityRoles?: PersonEventActivityRoleOptionDto[];
    currentMinisterialAreas?: MinisterialActivityAreaDto[];

    constructor(data?: IPersonEventEditorContextDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units!.push(PersonEventUnitContextDto.fromJS(item));
            }
            if (Array.isArray(_data["communities"])) {
                this.communities = [] as any;
                for (let item of _data["communities"])
                    this.communities!.push(PersonEventUnitContextDto.fromJS(item));
            }
            if (Array.isArray(_data["ministries"])) {
                this.ministries = [] as any;
                for (let item of _data["ministries"])
                    this.ministries!.push(PersonEventReferenceOptionDto.fromJS(item));
            }
            if (Array.isArray(_data["appointments"])) {
                this.appointments = [] as any;
                for (let item of _data["appointments"])
                    this.appointments!.push(PersonEventReferenceOptionDto.fromJS(item));
            }
            if (Array.isArray(_data["assignments"])) {
                this.assignments = [] as any;
                for (let item of _data["assignments"])
                    this.assignments!.push(PersonEventReferenceOptionDto.fromJS(item));
            }
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities!.push(PersonEventActivityOptionDto.fromJS(item));
            }
            if (Array.isArray(_data["activityRoles"])) {
                this.activityRoles = [] as any;
                for (let item of _data["activityRoles"])
                    this.activityRoles!.push(PersonEventActivityRoleOptionDto.fromJS(item));
            }
            if (Array.isArray(_data["currentMinisterialAreas"])) {
                this.currentMinisterialAreas = [] as any;
                for (let item of _data["currentMinisterialAreas"])
                    this.currentMinisterialAreas!.push(MinisterialActivityAreaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PersonEventEditorContextDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonEventEditorContextDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.communities)) {
            data["communities"] = [];
            for (let item of this.communities)
                data["communities"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.ministries)) {
            data["ministries"] = [];
            for (let item of this.ministries)
                data["ministries"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.appointments)) {
            data["appointments"] = [];
            for (let item of this.appointments)
                data["appointments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.assignments)) {
            data["assignments"] = [];
            for (let item of this.assignments)
                data["assignments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.activityRoles)) {
            data["activityRoles"] = [];
            for (let item of this.activityRoles)
                data["activityRoles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.currentMinisterialAreas)) {
            data["currentMinisterialAreas"] = [];
            for (let item of this.currentMinisterialAreas)
                data["currentMinisterialAreas"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPersonEventEditorContextDto {
    units?: PersonEventUnitContextDto[];
    communities?: PersonEventUnitContextDto[];
    ministries?: PersonEventReferenceOptionDto[];
    appointments?: PersonEventReferenceOptionDto[];
    assignments?: PersonEventReferenceOptionDto[];
    activities?: PersonEventActivityOptionDto[];
    activityRoles?: PersonEventActivityRoleOptionDto[];
    currentMinisterialAreas?: MinisterialActivityAreaDto[];
}

export class PersonEventUnitContextDto implements IPersonEventUnitContextDto {
    id?: string;
    name?: string;
    levelId?: number;
    levelName?: string;
    parentId?: string | undefined;
    ancestorNames?: string[];

    constructor(data?: IPersonEventUnitContextDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.levelId = _data["levelId"];
            this.levelName = _data["levelName"];
            this.parentId = _data["parentId"];
            if (Array.isArray(_data["ancestorNames"])) {
                this.ancestorNames = [] as any;
                for (let item of _data["ancestorNames"])
                    this.ancestorNames!.push(item);
            }
        }
    }

    static fromJS(data: any): PersonEventUnitContextDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonEventUnitContextDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["levelId"] = this.levelId;
        data["levelName"] = this.levelName;
        data["parentId"] = this.parentId;
        if (Array.isArray(this.ancestorNames)) {
            data["ancestorNames"] = [];
            for (let item of this.ancestorNames)
                data["ancestorNames"].push(item);
        }
        return data;
    }
}

export interface IPersonEventUnitContextDto {
    id?: string;
    name?: string;
    levelId?: number;
    levelName?: string;
    parentId?: string | undefined;
    ancestorNames?: string[];
}

export class PersonEventReferenceOptionDto implements IPersonEventReferenceOptionDto {
    id?: number;
    name?: string;
    isActive?: boolean;
    requiresActiveMinistry?: boolean;
    allowedOrganizationLevelIds?: number[];
    allowedOrganizationLevelNames?: string[];

    constructor(data?: IPersonEventReferenceOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.requiresActiveMinistry = _data["requiresActiveMinistry"];
            if (Array.isArray(_data["allowedOrganizationLevelIds"])) {
                this.allowedOrganizationLevelIds = [] as any;
                for (let item of _data["allowedOrganizationLevelIds"])
                    this.allowedOrganizationLevelIds!.push(item);
            }
            if (Array.isArray(_data["allowedOrganizationLevelNames"])) {
                this.allowedOrganizationLevelNames = [] as any;
                for (let item of _data["allowedOrganizationLevelNames"])
                    this.allowedOrganizationLevelNames!.push(item);
            }
        }
    }

    static fromJS(data: any): PersonEventReferenceOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonEventReferenceOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["requiresActiveMinistry"] = this.requiresActiveMinistry;
        if (Array.isArray(this.allowedOrganizationLevelIds)) {
            data["allowedOrganizationLevelIds"] = [];
            for (let item of this.allowedOrganizationLevelIds)
                data["allowedOrganizationLevelIds"].push(item);
        }
        if (Array.isArray(this.allowedOrganizationLevelNames)) {
            data["allowedOrganizationLevelNames"] = [];
            for (let item of this.allowedOrganizationLevelNames)
                data["allowedOrganizationLevelNames"].push(item);
        }
        return data;
    }
}

export interface IPersonEventReferenceOptionDto {
    id?: number;
    name?: string;
    isActive?: boolean;
    requiresActiveMinistry?: boolean;
    allowedOrganizationLevelIds?: number[];
    allowedOrganizationLevelNames?: string[];
}

export class PersonEventActivityOptionDto implements IPersonEventActivityOptionDto {
    id?: number;
    name?: string;

    constructor(data?: IPersonEventActivityOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PersonEventActivityOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonEventActivityOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IPersonEventActivityOptionDto {
    id?: number;
    name?: string;
}

export class PersonEventActivityRoleOptionDto implements IPersonEventActivityRoleOptionDto {
    id?: number;
    activityId?: number;
    name?: string;

    constructor(data?: IPersonEventActivityRoleOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.activityId = _data["activityId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PersonEventActivityRoleOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonEventActivityRoleOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activityId"] = this.activityId;
        data["name"] = this.name;
        return data;
    }
}

export interface IPersonEventActivityRoleOptionDto {
    id?: number;
    activityId?: number;
    name?: string;
}

export class CreatePersonEventDto implements ICreatePersonEventDto {
    category?: PersonEventCategory;
    eventDate?: string;
    endDate?: string | undefined;
    organizationUnitId?: string | undefined;
    activityId?: number | undefined;
    activityRoleId?: number | undefined;
    religiousEventType?: ReligiousEventType | undefined;
    locationOrganizationUnitId?: string | undefined;
    location?: string | undefined;
    anniversaryYears?: number | undefined;
    relatedPersonId?: string | undefined;
    relatedPersonName?: string | undefined;
    notes?: string | undefined;

    constructor(data?: ICreatePersonEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.eventDate = _data["eventDate"];
            this.endDate = _data["endDate"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.activityId = _data["activityId"];
            this.activityRoleId = _data["activityRoleId"];
            this.religiousEventType = _data["religiousEventType"];
            this.locationOrganizationUnitId = _data["locationOrganizationUnitId"];
            this.location = _data["location"];
            this.anniversaryYears = _data["anniversaryYears"];
            this.relatedPersonId = _data["relatedPersonId"];
            this.relatedPersonName = _data["relatedPersonName"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CreatePersonEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePersonEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["eventDate"] = this.eventDate;
        data["endDate"] = this.endDate;
        data["organizationUnitId"] = this.organizationUnitId;
        data["activityId"] = this.activityId;
        data["activityRoleId"] = this.activityRoleId;
        data["religiousEventType"] = this.religiousEventType;
        data["locationOrganizationUnitId"] = this.locationOrganizationUnitId;
        data["location"] = this.location;
        data["anniversaryYears"] = this.anniversaryYears;
        data["relatedPersonId"] = this.relatedPersonId;
        data["relatedPersonName"] = this.relatedPersonName;
        data["notes"] = this.notes;
        return data;
    }
}

export interface ICreatePersonEventDto {
    category?: PersonEventCategory;
    eventDate?: string;
    endDate?: string | undefined;
    organizationUnitId?: string | undefined;
    activityId?: number | undefined;
    activityRoleId?: number | undefined;
    religiousEventType?: ReligiousEventType | undefined;
    locationOrganizationUnitId?: string | undefined;
    location?: string | undefined;
    anniversaryYears?: number | undefined;
    relatedPersonId?: string | undefined;
    relatedPersonName?: string | undefined;
    notes?: string | undefined;
}

export class UpdatePersonEventDto implements IUpdatePersonEventDto {
    category?: PersonEventCategory;
    eventDate?: string;
    endDate?: string | undefined;
    organizationUnitId?: string | undefined;
    activityId?: number | undefined;
    activityRoleId?: number | undefined;
    religiousEventType?: ReligiousEventType | undefined;
    locationOrganizationUnitId?: string | undefined;
    location?: string | undefined;
    anniversaryYears?: number | undefined;
    relatedPersonId?: string | undefined;
    relatedPersonName?: string | undefined;
    notes?: string | undefined;

    constructor(data?: IUpdatePersonEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.eventDate = _data["eventDate"];
            this.endDate = _data["endDate"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.activityId = _data["activityId"];
            this.activityRoleId = _data["activityRoleId"];
            this.religiousEventType = _data["religiousEventType"];
            this.locationOrganizationUnitId = _data["locationOrganizationUnitId"];
            this.location = _data["location"];
            this.anniversaryYears = _data["anniversaryYears"];
            this.relatedPersonId = _data["relatedPersonId"];
            this.relatedPersonName = _data["relatedPersonName"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdatePersonEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePersonEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["eventDate"] = this.eventDate;
        data["endDate"] = this.endDate;
        data["organizationUnitId"] = this.organizationUnitId;
        data["activityId"] = this.activityId;
        data["activityRoleId"] = this.activityRoleId;
        data["religiousEventType"] = this.religiousEventType;
        data["locationOrganizationUnitId"] = this.locationOrganizationUnitId;
        data["location"] = this.location;
        data["anniversaryYears"] = this.anniversaryYears;
        data["relatedPersonId"] = this.relatedPersonId;
        data["relatedPersonName"] = this.relatedPersonName;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IUpdatePersonEventDto {
    category?: PersonEventCategory;
    eventDate?: string;
    endDate?: string | undefined;
    organizationUnitId?: string | undefined;
    activityId?: number | undefined;
    activityRoleId?: number | undefined;
    religiousEventType?: ReligiousEventType | undefined;
    locationOrganizationUnitId?: string | undefined;
    location?: string | undefined;
    anniversaryYears?: number | undefined;
    relatedPersonId?: string | undefined;
    relatedPersonName?: string | undefined;
    notes?: string | undefined;
}

export class CreatePersonRequest implements ICreatePersonRequest {
    membershipUnitId?: string;
    firstName?: string;
    lastName?: string;
    documentType?: DocumentType | undefined;
    documentNumber?: string | undefined;
    birthDate?: string | undefined;
    ageStatusOverride?: PersonAgeStatus | undefined;
    placeOfBirth?: string | undefined;
    countryOfBirthId?: number | undefined;
    gender?: Gender;
    email?: string | undefined;
    address?: string | undefined;
    phone?: string | undefined;
    nationalityId?: number | undefined;
    languages?: string | undefined;
    relationshipSituation?: RelationshipSituation;
    relationshipPersonId?: string | undefined;
    relationshipPersonName?: string | undefined;
    occupation?: string | undefined;
    previousReligion?: string | undefined;

    constructor(data?: ICreatePersonRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.membershipUnitId = _data["membershipUnitId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.documentType = _data["documentType"];
            this.documentNumber = _data["documentNumber"];
            this.birthDate = _data["birthDate"];
            this.ageStatusOverride = _data["ageStatusOverride"];
            this.placeOfBirth = _data["placeOfBirth"];
            this.countryOfBirthId = _data["countryOfBirthId"];
            this.gender = _data["gender"];
            this.email = _data["email"];
            this.address = _data["address"];
            this.phone = _data["phone"];
            this.nationalityId = _data["nationalityId"];
            this.languages = _data["languages"];
            this.relationshipSituation = _data["relationshipSituation"];
            this.relationshipPersonId = _data["relationshipPersonId"];
            this.relationshipPersonName = _data["relationshipPersonName"];
            this.occupation = _data["occupation"];
            this.previousReligion = _data["previousReligion"];
        }
    }

    static fromJS(data: any): CreatePersonRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePersonRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["membershipUnitId"] = this.membershipUnitId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["documentType"] = this.documentType;
        data["documentNumber"] = this.documentNumber;
        data["birthDate"] = this.birthDate;
        data["ageStatusOverride"] = this.ageStatusOverride;
        data["placeOfBirth"] = this.placeOfBirth;
        data["countryOfBirthId"] = this.countryOfBirthId;
        data["gender"] = this.gender;
        data["email"] = this.email;
        data["address"] = this.address;
        data["phone"] = this.phone;
        data["nationalityId"] = this.nationalityId;
        data["languages"] = this.languages;
        data["relationshipSituation"] = this.relationshipSituation;
        data["relationshipPersonId"] = this.relationshipPersonId;
        data["relationshipPersonName"] = this.relationshipPersonName;
        data["occupation"] = this.occupation;
        data["previousReligion"] = this.previousReligion;
        return data;
    }
}

export interface ICreatePersonRequest {
    membershipUnitId?: string;
    firstName?: string;
    lastName?: string;
    documentType?: DocumentType | undefined;
    documentNumber?: string | undefined;
    birthDate?: string | undefined;
    ageStatusOverride?: PersonAgeStatus | undefined;
    placeOfBirth?: string | undefined;
    countryOfBirthId?: number | undefined;
    gender?: Gender;
    email?: string | undefined;
    address?: string | undefined;
    phone?: string | undefined;
    nationalityId?: number | undefined;
    languages?: string | undefined;
    relationshipSituation?: RelationshipSituation;
    relationshipPersonId?: string | undefined;
    relationshipPersonName?: string | undefined;
    occupation?: string | undefined;
    previousReligion?: string | undefined;
}

export class CreateMinisterialActivityEventDto implements ICreateMinisterialActivityEventDto {
    eventType?: MinistryEventType;
    effectiveDate?: string;
    expectedEndDate?: string | undefined;
    actOrganizationUnitId?: string | undefined;
    actLocation?: string | undefined;
    reason?: string | undefined;
    membershipCommunityId?: string | undefined;
    areas?: MinisterialActivityAreaInputDto[];
    keepCurrentMinistryAreas?: boolean | undefined;
    reassignments?: MinisterialActivityReassignmentInputDto[];

    constructor(data?: ICreateMinisterialActivityEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventType = _data["eventType"];
            this.effectiveDate = _data["effectiveDate"];
            this.expectedEndDate = _data["expectedEndDate"];
            this.actOrganizationUnitId = _data["actOrganizationUnitId"];
            this.actLocation = _data["actLocation"];
            this.reason = _data["reason"];
            this.membershipCommunityId = _data["membershipCommunityId"];
            if (Array.isArray(_data["areas"])) {
                this.areas = [] as any;
                for (let item of _data["areas"])
                    this.areas!.push(MinisterialActivityAreaInputDto.fromJS(item));
            }
            this.keepCurrentMinistryAreas = _data["keepCurrentMinistryAreas"];
            if (Array.isArray(_data["reassignments"])) {
                this.reassignments = [] as any;
                for (let item of _data["reassignments"])
                    this.reassignments!.push(MinisterialActivityReassignmentInputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateMinisterialActivityEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMinisterialActivityEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventType"] = this.eventType;
        data["effectiveDate"] = this.effectiveDate;
        data["expectedEndDate"] = this.expectedEndDate;
        data["actOrganizationUnitId"] = this.actOrganizationUnitId;
        data["actLocation"] = this.actLocation;
        data["reason"] = this.reason;
        data["membershipCommunityId"] = this.membershipCommunityId;
        if (Array.isArray(this.areas)) {
            data["areas"] = [];
            for (let item of this.areas)
                data["areas"].push(item ? item.toJSON() : undefined as any);
        }
        data["keepCurrentMinistryAreas"] = this.keepCurrentMinistryAreas;
        if (Array.isArray(this.reassignments)) {
            data["reassignments"] = [];
            for (let item of this.reassignments)
                data["reassignments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateMinisterialActivityEventDto {
    eventType?: MinistryEventType;
    effectiveDate?: string;
    expectedEndDate?: string | undefined;
    actOrganizationUnitId?: string | undefined;
    actLocation?: string | undefined;
    reason?: string | undefined;
    membershipCommunityId?: string | undefined;
    areas?: MinisterialActivityAreaInputDto[];
    keepCurrentMinistryAreas?: boolean | undefined;
    reassignments?: MinisterialActivityReassignmentInputDto[];
}

export class MinisterialActivityAreaInputDto implements IMinisterialActivityAreaInputDto {
    kind?: MinisterialActivityKind;
    referenceId?: number;
    organizationUnitId?: string | undefined;
    historicalOrganizationUnitName?: string | undefined;
    expectedEndDate?: string | undefined;

    constructor(data?: IMinisterialActivityAreaInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kind = _data["kind"];
            this.referenceId = _data["referenceId"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.historicalOrganizationUnitName = _data["historicalOrganizationUnitName"];
            this.expectedEndDate = _data["expectedEndDate"];
        }
    }

    static fromJS(data: any): MinisterialActivityAreaInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MinisterialActivityAreaInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kind"] = this.kind;
        data["referenceId"] = this.referenceId;
        data["organizationUnitId"] = this.organizationUnitId;
        data["historicalOrganizationUnitName"] = this.historicalOrganizationUnitName;
        data["expectedEndDate"] = this.expectedEndDate;
        return data;
    }
}

export interface IMinisterialActivityAreaInputDto {
    kind?: MinisterialActivityKind;
    referenceId?: number;
    organizationUnitId?: string | undefined;
    historicalOrganizationUnitName?: string | undefined;
    expectedEndDate?: string | undefined;
}

export class MinisterialActivityReassignmentInputDto implements IMinisterialActivityReassignmentInputDto {
    kind?: MinisterialActivityKind;
    referenceId?: number;
    fromOrganizationUnitId?: string | undefined;
    fromHistoricalOrganizationUnitName?: string | undefined;
    toOrganizationUnitId?: string | undefined;
    toHistoricalOrganizationUnitName?: string | undefined;

    constructor(data?: IMinisterialActivityReassignmentInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kind = _data["kind"];
            this.referenceId = _data["referenceId"];
            this.fromOrganizationUnitId = _data["fromOrganizationUnitId"];
            this.fromHistoricalOrganizationUnitName = _data["fromHistoricalOrganizationUnitName"];
            this.toOrganizationUnitId = _data["toOrganizationUnitId"];
            this.toHistoricalOrganizationUnitName = _data["toHistoricalOrganizationUnitName"];
        }
    }

    static fromJS(data: any): MinisterialActivityReassignmentInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MinisterialActivityReassignmentInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kind"] = this.kind;
        data["referenceId"] = this.referenceId;
        data["fromOrganizationUnitId"] = this.fromOrganizationUnitId;
        data["fromHistoricalOrganizationUnitName"] = this.fromHistoricalOrganizationUnitName;
        data["toOrganizationUnitId"] = this.toOrganizationUnitId;
        data["toHistoricalOrganizationUnitName"] = this.toHistoricalOrganizationUnitName;
        return data;
    }
}

export interface IMinisterialActivityReassignmentInputDto {
    kind?: MinisterialActivityKind;
    referenceId?: number;
    fromOrganizationUnitId?: string | undefined;
    fromHistoricalOrganizationUnitName?: string | undefined;
    toOrganizationUnitId?: string | undefined;
    toHistoricalOrganizationUnitName?: string | undefined;
}

export class CreateOfficiantCollaborationDto implements ICreateOfficiantCollaborationDto {
    effectiveDate?: string;
    endDate?: string | undefined;
    organizationUnitId?: string;
    reason?: string | undefined;

    constructor(data?: ICreateOfficiantCollaborationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.effectiveDate = _data["effectiveDate"];
            this.endDate = _data["endDate"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): CreateOfficiantCollaborationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOfficiantCollaborationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["effectiveDate"] = this.effectiveDate;
        data["endDate"] = this.endDate;
        data["organizationUnitId"] = this.organizationUnitId;
        data["reason"] = this.reason;
        return data;
    }
}

export interface ICreateOfficiantCollaborationDto {
    effectiveDate?: string;
    endDate?: string | undefined;
    organizationUnitId?: string;
    reason?: string | undefined;
}

export class MinisterialActivityTransitionPreviewDto implements IMinisterialActivityTransitionPreviewDto {
    before?: MinisterialActivityEffectiveStateDto;
    after?: MinisterialActivityEffectiveStateDto;
    added?: MinisterialActivityEffectiveDesignationDto[];
    ended?: MinisterialActivityEffectiveDesignationDto[];
    unchanged?: MinisterialActivityEffectiveDesignationDto[];
    warnings?: string[];

    constructor(data?: IMinisterialActivityTransitionPreviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.before = _data["before"] ? MinisterialActivityEffectiveStateDto.fromJS(_data["before"]) : undefined as any;
            this.after = _data["after"] ? MinisterialActivityEffectiveStateDto.fromJS(_data["after"]) : undefined as any;
            if (Array.isArray(_data["added"])) {
                this.added = [] as any;
                for (let item of _data["added"])
                    this.added!.push(MinisterialActivityEffectiveDesignationDto.fromJS(item));
            }
            if (Array.isArray(_data["ended"])) {
                this.ended = [] as any;
                for (let item of _data["ended"])
                    this.ended!.push(MinisterialActivityEffectiveDesignationDto.fromJS(item));
            }
            if (Array.isArray(_data["unchanged"])) {
                this.unchanged = [] as any;
                for (let item of _data["unchanged"])
                    this.unchanged!.push(MinisterialActivityEffectiveDesignationDto.fromJS(item));
            }
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(item);
            }
        }
    }

    static fromJS(data: any): MinisterialActivityTransitionPreviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new MinisterialActivityTransitionPreviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["before"] = this.before ? this.before.toJSON() : undefined as any;
        data["after"] = this.after ? this.after.toJSON() : undefined as any;
        if (Array.isArray(this.added)) {
            data["added"] = [];
            for (let item of this.added)
                data["added"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.ended)) {
            data["ended"] = [];
            for (let item of this.ended)
                data["ended"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.unchanged)) {
            data["unchanged"] = [];
            for (let item of this.unchanged)
                data["unchanged"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item);
        }
        return data;
    }
}

export interface IMinisterialActivityTransitionPreviewDto {
    before?: MinisterialActivityEffectiveStateDto;
    after?: MinisterialActivityEffectiveStateDto;
    added?: MinisterialActivityEffectiveDesignationDto[];
    ended?: MinisterialActivityEffectiveDesignationDto[];
    unchanged?: MinisterialActivityEffectiveDesignationDto[];
    warnings?: string[];
}

export class CreatePersonMinistryActivityDto implements ICreatePersonMinistryActivityDto {
    unitId?: string;
    validFrom?: string;
    membershipCommunityId?: string | undefined;

    constructor(data?: ICreatePersonMinistryActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitId = _data["unitId"];
            this.validFrom = _data["validFrom"];
            this.membershipCommunityId = _data["membershipCommunityId"];
        }
    }

    static fromJS(data: any): CreatePersonMinistryActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePersonMinistryActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitId"] = this.unitId;
        data["validFrom"] = this.validFrom;
        data["membershipCommunityId"] = this.membershipCommunityId;
        return data;
    }
}

export interface ICreatePersonMinistryActivityDto {
    unitId?: string;
    validFrom?: string;
    membershipCommunityId?: string | undefined;
}

export class EndPersonMinistryActivityDto implements IEndPersonMinistryActivityDto {
    validTo?: string;

    constructor(data?: IEndPersonMinistryActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.validTo = _data["validTo"];
        }
    }

    static fromJS(data: any): EndPersonMinistryActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new EndPersonMinistryActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validTo"] = this.validTo;
        return data;
    }
}

export interface IEndPersonMinistryActivityDto {
    validTo?: string;
}

export class CreatePersonMinistryAppointmentDto implements ICreatePersonMinistryAppointmentDto {
    appointmentId?: number;
    unitId?: string | undefined;
    actOrganizationUnitId?: string | undefined;
    actLocation?: string | undefined;
    validFrom?: string;
    validTo?: string | undefined;
    membershipCommunityId?: string | undefined;

    constructor(data?: ICreatePersonMinistryAppointmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentId = _data["appointmentId"];
            this.unitId = _data["unitId"];
            this.actOrganizationUnitId = _data["actOrganizationUnitId"];
            this.actLocation = _data["actLocation"];
            this.validFrom = _data["validFrom"];
            this.validTo = _data["validTo"];
            this.membershipCommunityId = _data["membershipCommunityId"];
        }
    }

    static fromJS(data: any): CreatePersonMinistryAppointmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePersonMinistryAppointmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointmentId"] = this.appointmentId;
        data["unitId"] = this.unitId;
        data["actOrganizationUnitId"] = this.actOrganizationUnitId;
        data["actLocation"] = this.actLocation;
        data["validFrom"] = this.validFrom;
        data["validTo"] = this.validTo;
        data["membershipCommunityId"] = this.membershipCommunityId;
        return data;
    }
}

export interface ICreatePersonMinistryAppointmentDto {
    appointmentId?: number;
    unitId?: string | undefined;
    actOrganizationUnitId?: string | undefined;
    actLocation?: string | undefined;
    validFrom?: string;
    validTo?: string | undefined;
    membershipCommunityId?: string | undefined;
}

export class UpdatePersonMinistryAppointmentDto implements IUpdatePersonMinistryAppointmentDto {
    appointmentId?: number;
    unitId?: string | undefined;
    actOrganizationUnitId?: string | undefined;
    actLocation?: string | undefined;
    validFrom?: string;
    validTo?: string | undefined;

    constructor(data?: IUpdatePersonMinistryAppointmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentId = _data["appointmentId"];
            this.unitId = _data["unitId"];
            this.actOrganizationUnitId = _data["actOrganizationUnitId"];
            this.actLocation = _data["actLocation"];
            this.validFrom = _data["validFrom"];
            this.validTo = _data["validTo"];
        }
    }

    static fromJS(data: any): UpdatePersonMinistryAppointmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePersonMinistryAppointmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointmentId"] = this.appointmentId;
        data["unitId"] = this.unitId;
        data["actOrganizationUnitId"] = this.actOrganizationUnitId;
        data["actLocation"] = this.actLocation;
        data["validFrom"] = this.validFrom;
        data["validTo"] = this.validTo;
        return data;
    }
}

export interface IUpdatePersonMinistryAppointmentDto {
    appointmentId?: number;
    unitId?: string | undefined;
    actOrganizationUnitId?: string | undefined;
    actLocation?: string | undefined;
    validFrom?: string;
    validTo?: string | undefined;
}

export class CreatePersonAssignmentDto implements ICreatePersonAssignmentDto {
    assignmentId?: number;
    unitId?: string | undefined;
    actOrganizationUnitId?: string | undefined;
    actLocation?: string | undefined;
    validFrom?: string;
    validTo?: string | undefined;
    membershipCommunityId?: string | undefined;

    constructor(data?: ICreatePersonAssignmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignmentId = _data["assignmentId"];
            this.unitId = _data["unitId"];
            this.actOrganizationUnitId = _data["actOrganizationUnitId"];
            this.actLocation = _data["actLocation"];
            this.validFrom = _data["validFrom"];
            this.validTo = _data["validTo"];
            this.membershipCommunityId = _data["membershipCommunityId"];
        }
    }

    static fromJS(data: any): CreatePersonAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePersonAssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignmentId"] = this.assignmentId;
        data["unitId"] = this.unitId;
        data["actOrganizationUnitId"] = this.actOrganizationUnitId;
        data["actLocation"] = this.actLocation;
        data["validFrom"] = this.validFrom;
        data["validTo"] = this.validTo;
        data["membershipCommunityId"] = this.membershipCommunityId;
        return data;
    }
}

export interface ICreatePersonAssignmentDto {
    assignmentId?: number;
    unitId?: string | undefined;
    actOrganizationUnitId?: string | undefined;
    actLocation?: string | undefined;
    validFrom?: string;
    validTo?: string | undefined;
    membershipCommunityId?: string | undefined;
}

export class TransferPersonCommunityDto implements ITransferPersonCommunityDto {
    targetUnitId?: string;
    effectiveDate?: string;
    reason?: string | undefined;

    constructor(data?: ITransferPersonCommunityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetUnitId = _data["targetUnitId"];
            this.effectiveDate = _data["effectiveDate"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): TransferPersonCommunityDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransferPersonCommunityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetUnitId"] = this.targetUnitId;
        data["effectiveDate"] = this.effectiveDate;
        data["reason"] = this.reason;
        return data;
    }
}

export interface ITransferPersonCommunityDto {
    targetUnitId?: string;
    effectiveDate?: string;
    reason?: string | undefined;
}

export class UpdatePersonAssignmentDto implements IUpdatePersonAssignmentDto {
    assignmentId?: number;
    unitId?: string | undefined;
    actOrganizationUnitId?: string | undefined;
    actLocation?: string | undefined;
    validFrom?: string;
    validTo?: string | undefined;

    constructor(data?: IUpdatePersonAssignmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignmentId = _data["assignmentId"];
            this.unitId = _data["unitId"];
            this.actOrganizationUnitId = _data["actOrganizationUnitId"];
            this.actLocation = _data["actLocation"];
            this.validFrom = _data["validFrom"];
            this.validTo = _data["validTo"];
        }
    }

    static fromJS(data: any): UpdatePersonAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePersonAssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignmentId"] = this.assignmentId;
        data["unitId"] = this.unitId;
        data["actOrganizationUnitId"] = this.actOrganizationUnitId;
        data["actLocation"] = this.actLocation;
        data["validFrom"] = this.validFrom;
        data["validTo"] = this.validTo;
        return data;
    }
}

export interface IUpdatePersonAssignmentDto {
    assignmentId?: number;
    unitId?: string | undefined;
    actOrganizationUnitId?: string | undefined;
    actLocation?: string | undefined;
    validFrom?: string;
    validTo?: string | undefined;
}

export class UpdatePersonRequest implements IUpdatePersonRequest {
    firstName?: string;
    lastName?: string;
    email?: string | undefined;
    documentType?: DocumentType | undefined;
    documentNumber?: string | undefined;
    birthDate?: string | undefined;
    ageStatusOverride?: PersonAgeStatus | undefined;
    placeOfBirth?: string | undefined;
    countryOfBirthId?: number | undefined;
    nationalityId?: number | undefined;
    languages?: string | undefined;
    gender?: Gender;
    relationshipSituation?: RelationshipSituation;
    relationshipPersonId?: string | undefined;
    relationshipPersonName?: string | undefined;
    updateRelationshipPerson?: boolean;
    relationshipPersonToUpdateId?: string | undefined;
    address?: string | undefined;
    phone?: string | undefined;
    occupation?: string | undefined;
    previousReligion?: string | undefined;

    constructor(data?: IUpdatePersonRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.documentType = _data["documentType"];
            this.documentNumber = _data["documentNumber"];
            this.birthDate = _data["birthDate"];
            this.ageStatusOverride = _data["ageStatusOverride"];
            this.placeOfBirth = _data["placeOfBirth"];
            this.countryOfBirthId = _data["countryOfBirthId"];
            this.nationalityId = _data["nationalityId"];
            this.languages = _data["languages"];
            this.gender = _data["gender"];
            this.relationshipSituation = _data["relationshipSituation"];
            this.relationshipPersonId = _data["relationshipPersonId"];
            this.relationshipPersonName = _data["relationshipPersonName"];
            this.updateRelationshipPerson = _data["updateRelationshipPerson"];
            this.relationshipPersonToUpdateId = _data["relationshipPersonToUpdateId"];
            this.address = _data["address"];
            this.phone = _data["phone"];
            this.occupation = _data["occupation"];
            this.previousReligion = _data["previousReligion"];
        }
    }

    static fromJS(data: any): UpdatePersonRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePersonRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["documentType"] = this.documentType;
        data["documentNumber"] = this.documentNumber;
        data["birthDate"] = this.birthDate;
        data["ageStatusOverride"] = this.ageStatusOverride;
        data["placeOfBirth"] = this.placeOfBirth;
        data["countryOfBirthId"] = this.countryOfBirthId;
        data["nationalityId"] = this.nationalityId;
        data["languages"] = this.languages;
        data["gender"] = this.gender;
        data["relationshipSituation"] = this.relationshipSituation;
        data["relationshipPersonId"] = this.relationshipPersonId;
        data["relationshipPersonName"] = this.relationshipPersonName;
        data["updateRelationshipPerson"] = this.updateRelationshipPerson;
        data["relationshipPersonToUpdateId"] = this.relationshipPersonToUpdateId;
        data["address"] = this.address;
        data["phone"] = this.phone;
        data["occupation"] = this.occupation;
        data["previousReligion"] = this.previousReligion;
        return data;
    }
}

export interface IUpdatePersonRequest {
    firstName?: string;
    lastName?: string;
    email?: string | undefined;
    documentType?: DocumentType | undefined;
    documentNumber?: string | undefined;
    birthDate?: string | undefined;
    ageStatusOverride?: PersonAgeStatus | undefined;
    placeOfBirth?: string | undefined;
    countryOfBirthId?: number | undefined;
    nationalityId?: number | undefined;
    languages?: string | undefined;
    gender?: Gender;
    relationshipSituation?: RelationshipSituation;
    relationshipPersonId?: string | undefined;
    relationshipPersonName?: string | undefined;
    updateRelationshipPerson?: boolean;
    relationshipPersonToUpdateId?: string | undefined;
    address?: string | undefined;
    phone?: string | undefined;
    occupation?: string | undefined;
    previousReligion?: string | undefined;
}

export class UpdatePersonStatusDto implements IUpdatePersonStatusDto {
    status?: MembershipStatus;
    effectiveDate?: string | undefined;
    deathDate?: string | undefined;

    constructor(data?: IUpdatePersonStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.effectiveDate = _data["effectiveDate"];
            this.deathDate = _data["deathDate"];
        }
    }

    static fromJS(data: any): UpdatePersonStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePersonStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["effectiveDate"] = this.effectiveDate;
        data["deathDate"] = this.deathDate;
        return data;
    }
}

export interface IUpdatePersonStatusDto {
    status?: MembershipStatus;
    effectiveDate?: string | undefined;
    deathDate?: string | undefined;
}

export class DeletePersonDto implements IDeletePersonDto {
    deletionReason?: string;

    constructor(data?: IDeletePersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deletionReason = _data["deletionReason"];
        }
    }

    static fromJS(data: any): DeletePersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeletePersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deletionReason"] = this.deletionReason;
        return data;
    }
}

export interface IDeletePersonDto {
    deletionReason?: string;
}

export class PhotoState implements IPhotoState {
    revision?: string;
    canManage?: boolean;
    photos?: PhotoDescriptor[];

    constructor(data?: IPhotoState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.revision = _data["revision"];
            this.canManage = _data["canManage"];
            if (Array.isArray(_data["photos"])) {
                this.photos = [] as any;
                for (let item of _data["photos"])
                    this.photos!.push(PhotoDescriptor.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PhotoState {
        data = typeof data === 'object' ? data : {};
        let result = new PhotoState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["revision"] = this.revision;
        data["canManage"] = this.canManage;
        if (Array.isArray(this.photos)) {
            data["photos"] = [];
            for (let item of this.photos)
                data["photos"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPhotoState {
    revision?: string;
    canManage?: boolean;
    photos?: PhotoDescriptor[];
}

export class PhotoDescriptor implements IPhotoDescriptor {
    id?: string;
    version?: string;
    mainUrl?: string;
    thumbnailUrl?: string;
    sortOrder?: number;
    isCover?: boolean;
    framing?: PhotoFraming | undefined;

    constructor(data?: IPhotoDescriptor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.version = _data["version"];
            this.mainUrl = _data["mainUrl"];
            this.thumbnailUrl = _data["thumbnailUrl"];
            this.sortOrder = _data["sortOrder"];
            this.isCover = _data["isCover"];
            this.framing = _data["framing"] ? PhotoFraming.fromJS(_data["framing"]) : undefined as any;
        }
    }

    static fromJS(data: any): PhotoDescriptor {
        data = typeof data === 'object' ? data : {};
        let result = new PhotoDescriptor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["version"] = this.version;
        data["mainUrl"] = this.mainUrl;
        data["thumbnailUrl"] = this.thumbnailUrl;
        data["sortOrder"] = this.sortOrder;
        data["isCover"] = this.isCover;
        data["framing"] = this.framing ? this.framing.toJSON() : undefined as any;
        return data;
    }
}

export interface IPhotoDescriptor {
    id?: string;
    version?: string;
    mainUrl?: string;
    thumbnailUrl?: string;
    sortOrder?: number;
    isCover?: boolean;
    framing?: PhotoFraming | undefined;
}

export class PhotoFraming implements IPhotoFraming {
    x?: number;
    y?: number;
    size?: number;

    constructor(data?: IPhotoFraming) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"];
            this.y = _data["y"];
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): PhotoFraming {
        data = typeof data === 'object' ? data : {};
        let result = new PhotoFraming();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x;
        data["y"] = this.y;
        data["size"] = this.size;
        return data;
    }
}

export interface IPhotoFraming {
    x?: number;
    y?: number;
    size?: number;
}

export class PhotoGalleryChange implements IPhotoGalleryChange {
    revision?: string;
    coverId?: string;
    orderedIds?: string[];

    constructor(data?: IPhotoGalleryChange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.revision = _data["revision"];
            this.coverId = _data["coverId"];
            if (Array.isArray(_data["orderedIds"])) {
                this.orderedIds = [] as any;
                for (let item of _data["orderedIds"])
                    this.orderedIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PhotoGalleryChange {
        data = typeof data === 'object' ? data : {};
        let result = new PhotoGalleryChange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["revision"] = this.revision;
        data["coverId"] = this.coverId;
        if (Array.isArray(this.orderedIds)) {
            data["orderedIds"] = [];
            for (let item of this.orderedIds)
                data["orderedIds"].push(item);
        }
        return data;
    }
}

export interface IPhotoGalleryChange {
    revision?: string;
    coverId?: string;
    orderedIds?: string[];
}

export class PortalPhotoPreview implements IPortalPhotoPreview {
    id?: string;
    reference?: string;
    isUnit?: boolean;
    role?: string;
    error?: string | undefined;
    thumbnailUrl?: string | undefined;
    personId?: string | undefined;
    consumed?: boolean;

    constructor(data?: IPortalPhotoPreview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reference = _data["reference"];
            this.isUnit = _data["isUnit"];
            this.role = _data["role"];
            this.error = _data["error"];
            this.thumbnailUrl = _data["thumbnailUrl"];
            this.personId = _data["personId"];
            this.consumed = _data["consumed"];
        }
    }

    static fromJS(data: any): PortalPhotoPreview {
        data = typeof data === 'object' ? data : {};
        let result = new PortalPhotoPreview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reference"] = this.reference;
        data["isUnit"] = this.isUnit;
        data["role"] = this.role;
        data["error"] = this.error;
        data["thumbnailUrl"] = this.thumbnailUrl;
        data["personId"] = this.personId;
        data["consumed"] = this.consumed;
        return data;
    }
}

export interface IPortalPhotoPreview {
    id?: string;
    reference?: string;
    isUnit?: boolean;
    role?: string;
    error?: string | undefined;
    thumbnailUrl?: string | undefined;
    personId?: string | undefined;
    consumed?: boolean;
}

export class PortalImportEquivalenceDto implements IPortalImportEquivalenceDto {
    id?: number;
    sourceSection?: string;
    sourceValue?: string;
    targetKind?: string;
    targetId?: number | undefined;
    targetReference?: string | undefined;
    activityRoleId?: number | undefined;
    ignore?: boolean;
    unitRule?: string;
    sourceLabel?: string | undefined;

    constructor(data?: IPortalImportEquivalenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceSection = _data["sourceSection"];
            this.sourceValue = _data["sourceValue"];
            this.targetKind = _data["targetKind"];
            this.targetId = _data["targetId"];
            this.targetReference = _data["targetReference"];
            this.activityRoleId = _data["activityRoleId"];
            this.ignore = _data["ignore"];
            this.unitRule = _data["unitRule"];
            this.sourceLabel = _data["sourceLabel"];
        }
    }

    static fromJS(data: any): PortalImportEquivalenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PortalImportEquivalenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceSection"] = this.sourceSection;
        data["sourceValue"] = this.sourceValue;
        data["targetKind"] = this.targetKind;
        data["targetId"] = this.targetId;
        data["targetReference"] = this.targetReference;
        data["activityRoleId"] = this.activityRoleId;
        data["ignore"] = this.ignore;
        data["unitRule"] = this.unitRule;
        data["sourceLabel"] = this.sourceLabel;
        return data;
    }
}

export interface IPortalImportEquivalenceDto {
    id?: number;
    sourceSection?: string;
    sourceValue?: string;
    targetKind?: string;
    targetId?: number | undefined;
    targetReference?: string | undefined;
    activityRoleId?: number | undefined;
    ignore?: boolean;
    unitRule?: string;
    sourceLabel?: string | undefined;
}

export class SavePortalImportEquivalenceRequest implements ISavePortalImportEquivalenceRequest {
    sourceSection?: string;
    sourceValue?: string;
    sourceLabel?: string | undefined;
    targetKind?: string;
    targetId?: number | undefined;
    targetReference?: string | undefined;
    activityRoleId?: number | undefined;
    ignore?: boolean;
    unitRule?: string;

    constructor(data?: ISavePortalImportEquivalenceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceSection = _data["sourceSection"];
            this.sourceValue = _data["sourceValue"];
            this.sourceLabel = _data["sourceLabel"];
            this.targetKind = _data["targetKind"];
            this.targetId = _data["targetId"];
            this.targetReference = _data["targetReference"];
            this.activityRoleId = _data["activityRoleId"];
            this.ignore = _data["ignore"];
            this.unitRule = _data["unitRule"];
        }
    }

    static fromJS(data: any): SavePortalImportEquivalenceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SavePortalImportEquivalenceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceSection"] = this.sourceSection;
        data["sourceValue"] = this.sourceValue;
        data["sourceLabel"] = this.sourceLabel;
        data["targetKind"] = this.targetKind;
        data["targetId"] = this.targetId;
        data["targetReference"] = this.targetReference;
        data["activityRoleId"] = this.activityRoleId;
        data["ignore"] = this.ignore;
        data["unitRule"] = this.unitRule;
        return data;
    }
}

export interface ISavePortalImportEquivalenceRequest {
    sourceSection?: string;
    sourceValue?: string;
    sourceLabel?: string | undefined;
    targetKind?: string;
    targetId?: number | undefined;
    targetReference?: string | undefined;
    activityRoleId?: number | undefined;
    ignore?: boolean;
    unitRule?: string;
}

export class PortalImportHistoryItemDto implements IPortalImportHistoryItemDto {
    id?: string;
    fileName?: string;
    uploadedBy?: string | undefined;
    importedAtUtc?: string;
    created?: number;
    existing?: number;
    blocked?: number;
    omitted?: number;
    memberCount?: number;

    constructor(data?: IPortalImportHistoryItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.uploadedBy = _data["uploadedBy"];
            this.importedAtUtc = _data["importedAtUtc"];
            this.created = _data["created"];
            this.existing = _data["existing"];
            this.blocked = _data["blocked"];
            this.omitted = _data["omitted"];
            this.memberCount = _data["memberCount"];
        }
    }

    static fromJS(data: any): PortalImportHistoryItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PortalImportHistoryItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["uploadedBy"] = this.uploadedBy;
        data["importedAtUtc"] = this.importedAtUtc;
        data["created"] = this.created;
        data["existing"] = this.existing;
        data["blocked"] = this.blocked;
        data["omitted"] = this.omitted;
        data["memberCount"] = this.memberCount;
        return data;
    }
}

export interface IPortalImportHistoryItemDto {
    id?: string;
    fileName?: string;
    uploadedBy?: string | undefined;
    importedAtUtc?: string;
    created?: number;
    existing?: number;
    blocked?: number;
    omitted?: number;
    memberCount?: number;
}

export class PortalImportHistoryDetailDto implements IPortalImportHistoryDetailDto {
    batch?: PortalImportHistoryItemDto;
    result?: PortalMemberImportResultDto;

    constructor(data?: IPortalImportHistoryDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batch = _data["batch"] ? PortalImportHistoryItemDto.fromJS(_data["batch"]) : undefined as any;
            this.result = _data["result"] ? PortalMemberImportResultDto.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): PortalImportHistoryDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new PortalImportHistoryDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batch"] = this.batch ? this.batch.toJSON() : undefined as any;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IPortalImportHistoryDetailDto {
    batch?: PortalImportHistoryItemDto;
    result?: PortalMemberImportResultDto;
}

export class PortalMemberImportResultDto implements IPortalMemberImportResultDto {
    created?: number;
    skipped?: number;
    warnings?: string[];
    members?: PortalMemberImportMemberResultDto[];

    constructor(data?: IPortalMemberImportResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"];
            this.skipped = _data["skipped"];
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(item);
            }
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(PortalMemberImportMemberResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PortalMemberImportResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PortalMemberImportResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created;
        data["skipped"] = this.skipped;
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item);
        }
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPortalMemberImportResultDto {
    created?: number;
    skipped?: number;
    warnings?: string[];
    members?: PortalMemberImportMemberResultDto[];
}

export class PortalMemberImportMemberResultDto implements IPortalMemberImportMemberResultDto {
    portalMemberId?: string;
    fullName?: string;
    status?: string;
    messages?: string[];
    personId?: string | undefined;

    constructor(data?: IPortalMemberImportMemberResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.portalMemberId = _data["portalMemberId"];
            this.fullName = _data["fullName"];
            this.status = _data["status"];
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.personId = _data["personId"];
        }
    }

    static fromJS(data: any): PortalMemberImportMemberResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PortalMemberImportMemberResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["portalMemberId"] = this.portalMemberId;
        data["fullName"] = this.fullName;
        data["status"] = this.status;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["personId"] = this.personId;
        return data;
    }
}

export interface IPortalMemberImportMemberResultDto {
    portalMemberId?: string;
    fullName?: string;
    status?: string;
    messages?: string[];
    personId?: string | undefined;
}

export class PortalImportSourceJsonDto implements IPortalImportSourceJsonDto {
    batchId?: string;
    fileName?: string;
    sourceJson?: string;

    constructor(data?: IPortalImportSourceJsonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchId = _data["batchId"];
            this.fileName = _data["fileName"];
            this.sourceJson = _data["sourceJson"];
        }
    }

    static fromJS(data: any): PortalImportSourceJsonDto {
        data = typeof data === 'object' ? data : {};
        let result = new PortalImportSourceJsonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchId"] = this.batchId;
        data["fileName"] = this.fileName;
        data["sourceJson"] = this.sourceJson;
        return data;
    }
}

export interface IPortalImportSourceJsonDto {
    batchId?: string;
    fileName?: string;
    sourceJson?: string;
}

export class PortalMemberImportPreviewDto implements IPortalMemberImportPreviewDto {
    members?: PortalMemberImportPersonPreviewDto[];
    catalogs?: PortalMemberImportCatalogDto[];
    batchId?: string | undefined;
    warnings?: string[] | undefined;
    missingEquivalences?: PortalImportEquivalencePreviewDto[] | undefined;
    equivalences?: PortalImportEquivalencePreviewDto[] | undefined;
    configuredEquivalences?: PortalImportEquivalenceDto[] | undefined;

    constructor(data?: IPortalMemberImportPreviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(PortalMemberImportPersonPreviewDto.fromJS(item));
            }
            if (Array.isArray(_data["catalogs"])) {
                this.catalogs = [] as any;
                for (let item of _data["catalogs"])
                    this.catalogs!.push(PortalMemberImportCatalogDto.fromJS(item));
            }
            this.batchId = _data["batchId"];
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(item);
            }
            if (Array.isArray(_data["missingEquivalences"])) {
                this.missingEquivalences = [] as any;
                for (let item of _data["missingEquivalences"])
                    this.missingEquivalences!.push(PortalImportEquivalencePreviewDto.fromJS(item));
            }
            if (Array.isArray(_data["equivalences"])) {
                this.equivalences = [] as any;
                for (let item of _data["equivalences"])
                    this.equivalences!.push(PortalImportEquivalencePreviewDto.fromJS(item));
            }
            if (Array.isArray(_data["configuredEquivalences"])) {
                this.configuredEquivalences = [] as any;
                for (let item of _data["configuredEquivalences"])
                    this.configuredEquivalences!.push(PortalImportEquivalenceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PortalMemberImportPreviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PortalMemberImportPreviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.catalogs)) {
            data["catalogs"] = [];
            for (let item of this.catalogs)
                data["catalogs"].push(item ? item.toJSON() : undefined as any);
        }
        data["batchId"] = this.batchId;
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item);
        }
        if (Array.isArray(this.missingEquivalences)) {
            data["missingEquivalences"] = [];
            for (let item of this.missingEquivalences)
                data["missingEquivalences"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.equivalences)) {
            data["equivalences"] = [];
            for (let item of this.equivalences)
                data["equivalences"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.configuredEquivalences)) {
            data["configuredEquivalences"] = [];
            for (let item of this.configuredEquivalences)
                data["configuredEquivalences"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPortalMemberImportPreviewDto {
    members?: PortalMemberImportPersonPreviewDto[];
    catalogs?: PortalMemberImportCatalogDto[];
    batchId?: string | undefined;
    warnings?: string[] | undefined;
    missingEquivalences?: PortalImportEquivalencePreviewDto[] | undefined;
    equivalences?: PortalImportEquivalencePreviewDto[] | undefined;
    configuredEquivalences?: PortalImportEquivalenceDto[] | undefined;
}

export class PortalMemberImportPersonPreviewDto implements IPortalMemberImportPersonPreviewDto {
    portalMemberId?: string;
    fullName?: string;
    community?: string | undefined;
    details?: PortalMemberImportFieldDto[];
    events?: PortalMemberImportEventPreviewDto[];
    sections?: PortalMemberImportSectionPreviewDto[];
    emails?: string[];
    phones?: string[];
    addresses?: string[];
    warnings?: string[];
    notImportedSections?: string[];
    communityHistory?: PortalMemberImportCommunityHistoryPreviewDto[] | undefined;
    isExisting?: boolean;
    existingDetails?: PortalMemberImportFieldDto[] | undefined;
    civilEvents?: PortalMemberImportCivilEventPreviewDto[] | undefined;
    sourceCommunityReference?: string | undefined;

    constructor(data?: IPortalMemberImportPersonPreviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.portalMemberId = _data["portalMemberId"];
            this.fullName = _data["fullName"];
            this.community = _data["community"];
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(PortalMemberImportFieldDto.fromJS(item));
            }
            if (Array.isArray(_data["events"])) {
                this.events = [] as any;
                for (let item of _data["events"])
                    this.events!.push(PortalMemberImportEventPreviewDto.fromJS(item));
            }
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(PortalMemberImportSectionPreviewDto.fromJS(item));
            }
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(item);
            }
            if (Array.isArray(_data["phones"])) {
                this.phones = [] as any;
                for (let item of _data["phones"])
                    this.phones!.push(item);
            }
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(item);
            }
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(item);
            }
            if (Array.isArray(_data["notImportedSections"])) {
                this.notImportedSections = [] as any;
                for (let item of _data["notImportedSections"])
                    this.notImportedSections!.push(item);
            }
            if (Array.isArray(_data["communityHistory"])) {
                this.communityHistory = [] as any;
                for (let item of _data["communityHistory"])
                    this.communityHistory!.push(PortalMemberImportCommunityHistoryPreviewDto.fromJS(item));
            }
            this.isExisting = _data["isExisting"];
            if (Array.isArray(_data["existingDetails"])) {
                this.existingDetails = [] as any;
                for (let item of _data["existingDetails"])
                    this.existingDetails!.push(PortalMemberImportFieldDto.fromJS(item));
            }
            if (Array.isArray(_data["civilEvents"])) {
                this.civilEvents = [] as any;
                for (let item of _data["civilEvents"])
                    this.civilEvents!.push(PortalMemberImportCivilEventPreviewDto.fromJS(item));
            }
            this.sourceCommunityReference = _data["sourceCommunityReference"];
        }
    }

    static fromJS(data: any): PortalMemberImportPersonPreviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PortalMemberImportPersonPreviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["portalMemberId"] = this.portalMemberId;
        data["fullName"] = this.fullName;
        data["community"] = this.community;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.events)) {
            data["events"] = [];
            for (let item of this.events)
                data["events"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        if (Array.isArray(this.phones)) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item);
        }
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item);
        }
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item);
        }
        if (Array.isArray(this.notImportedSections)) {
            data["notImportedSections"] = [];
            for (let item of this.notImportedSections)
                data["notImportedSections"].push(item);
        }
        if (Array.isArray(this.communityHistory)) {
            data["communityHistory"] = [];
            for (let item of this.communityHistory)
                data["communityHistory"].push(item ? item.toJSON() : undefined as any);
        }
        data["isExisting"] = this.isExisting;
        if (Array.isArray(this.existingDetails)) {
            data["existingDetails"] = [];
            for (let item of this.existingDetails)
                data["existingDetails"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.civilEvents)) {
            data["civilEvents"] = [];
            for (let item of this.civilEvents)
                data["civilEvents"].push(item ? item.toJSON() : undefined as any);
        }
        data["sourceCommunityReference"] = this.sourceCommunityReference;
        return data;
    }
}

export interface IPortalMemberImportPersonPreviewDto {
    portalMemberId?: string;
    fullName?: string;
    community?: string | undefined;
    details?: PortalMemberImportFieldDto[];
    events?: PortalMemberImportEventPreviewDto[];
    sections?: PortalMemberImportSectionPreviewDto[];
    emails?: string[];
    phones?: string[];
    addresses?: string[];
    warnings?: string[];
    notImportedSections?: string[];
    communityHistory?: PortalMemberImportCommunityHistoryPreviewDto[] | undefined;
    isExisting?: boolean;
    existingDetails?: PortalMemberImportFieldDto[] | undefined;
    civilEvents?: PortalMemberImportCivilEventPreviewDto[] | undefined;
    sourceCommunityReference?: string | undefined;
}

export class PortalMemberImportFieldDto implements IPortalMemberImportFieldDto {
    label?: string;
    value?: string | undefined;
    sourceReference?: string | undefined;

    constructor(data?: IPortalMemberImportFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"];
            this.sourceReference = _data["sourceReference"];
        }
    }

    static fromJS(data: any): PortalMemberImportFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new PortalMemberImportFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        data["sourceReference"] = this.sourceReference;
        return data;
    }
}

export interface IPortalMemberImportFieldDto {
    label?: string;
    value?: string | undefined;
    sourceReference?: string | undefined;
}

export class PortalMemberImportEventPreviewDto implements IPortalMemberImportEventPreviewDto {
    index?: number;
    name?: string;
    date?: string | undefined;
    location?: string | undefined;
    isImportable?: boolean;
    rawDate?: string | undefined;

    constructor(data?: IPortalMemberImportEventPreviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"];
            this.name = _data["name"];
            this.date = _data["date"];
            this.location = _data["location"];
            this.isImportable = _data["isImportable"];
            this.rawDate = _data["rawDate"];
        }
    }

    static fromJS(data: any): PortalMemberImportEventPreviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PortalMemberImportEventPreviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["name"] = this.name;
        data["date"] = this.date;
        data["location"] = this.location;
        data["isImportable"] = this.isImportable;
        data["rawDate"] = this.rawDate;
        return data;
    }
}

export interface IPortalMemberImportEventPreviewDto {
    index?: number;
    name?: string;
    date?: string | undefined;
    location?: string | undefined;
    isImportable?: boolean;
    rawDate?: string | undefined;
}

export class PortalMemberImportSectionPreviewDto implements IPortalMemberImportSectionPreviewDto {
    name?: string;
    rows?: string[];
    records?: PortalMemberImportFieldDto[][] | undefined;
    importedRecords?: PortalMemberImportFieldDto[][] | undefined;

    constructor(data?: IPortalMemberImportSectionPreviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(item);
            }
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(item);
            }
            if (Array.isArray(_data["importedRecords"])) {
                this.importedRecords = [] as any;
                for (let item of _data["importedRecords"])
                    this.importedRecords!.push(item);
            }
        }
    }

    static fromJS(data: any): PortalMemberImportSectionPreviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PortalMemberImportSectionPreviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item);
        }
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item);
        }
        if (Array.isArray(this.importedRecords)) {
            data["importedRecords"] = [];
            for (let item of this.importedRecords)
                data["importedRecords"].push(item);
        }
        return data;
    }
}

export interface IPortalMemberImportSectionPreviewDto {
    name?: string;
    rows?: string[];
    records?: PortalMemberImportFieldDto[][] | undefined;
    importedRecords?: PortalMemberImportFieldDto[][] | undefined;
}

export class PortalMemberImportCommunityHistoryPreviewDto implements IPortalMemberImportCommunityHistoryPreviewDto {
    index?: number;
    startDate?: string | undefined;
    endDate?: string | undefined;
    community?: string | undefined;
    sourceCommunityMdmNo?: string | undefined;

    constructor(data?: IPortalMemberImportCommunityHistoryPreviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.community = _data["community"];
            this.sourceCommunityMdmNo = _data["sourceCommunityMdmNo"];
        }
    }

    static fromJS(data: any): PortalMemberImportCommunityHistoryPreviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PortalMemberImportCommunityHistoryPreviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["community"] = this.community;
        data["sourceCommunityMdmNo"] = this.sourceCommunityMdmNo;
        return data;
    }
}

export interface IPortalMemberImportCommunityHistoryPreviewDto {
    index?: number;
    startDate?: string | undefined;
    endDate?: string | undefined;
    community?: string | undefined;
    sourceCommunityMdmNo?: string | undefined;
}

export class PortalMemberImportCivilEventPreviewDto implements IPortalMemberImportCivilEventPreviewDto {
    name?: string;
    date?: string | undefined;
    location?: string | undefined;
    partnerName?: string | undefined;
    partnerMdm?: string | undefined;
    targetEventType?: string | undefined;
    targetEventName?: string | undefined;
    anniversaryYears?: number | undefined;
    issue?: string | undefined;
    rawDate?: string | undefined;

    constructor(data?: IPortalMemberImportCivilEventPreviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.date = _data["date"];
            this.location = _data["location"];
            this.partnerName = _data["partnerName"];
            this.partnerMdm = _data["partnerMdm"];
            this.targetEventType = _data["targetEventType"];
            this.targetEventName = _data["targetEventName"];
            this.anniversaryYears = _data["anniversaryYears"];
            this.issue = _data["issue"];
            this.rawDate = _data["rawDate"];
        }
    }

    static fromJS(data: any): PortalMemberImportCivilEventPreviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PortalMemberImportCivilEventPreviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["date"] = this.date;
        data["location"] = this.location;
        data["partnerName"] = this.partnerName;
        data["partnerMdm"] = this.partnerMdm;
        data["targetEventType"] = this.targetEventType;
        data["targetEventName"] = this.targetEventName;
        data["anniversaryYears"] = this.anniversaryYears;
        data["issue"] = this.issue;
        data["rawDate"] = this.rawDate;
        return data;
    }
}

export interface IPortalMemberImportCivilEventPreviewDto {
    name?: string;
    date?: string | undefined;
    location?: string | undefined;
    partnerName?: string | undefined;
    partnerMdm?: string | undefined;
    targetEventType?: string | undefined;
    targetEventName?: string | undefined;
    anniversaryYears?: number | undefined;
    issue?: string | undefined;
    rawDate?: string | undefined;
}

export class PortalMemberImportCatalogDto implements IPortalMemberImportCatalogDto {
    kind?: string;
    source?: string;
    options?: PortalMemberImportCatalogOptionDto[];

    constructor(data?: IPortalMemberImportCatalogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kind = _data["kind"];
            this.source = _data["source"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(PortalMemberImportCatalogOptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PortalMemberImportCatalogDto {
        data = typeof data === 'object' ? data : {};
        let result = new PortalMemberImportCatalogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kind"] = this.kind;
        data["source"] = this.source;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPortalMemberImportCatalogDto {
    kind?: string;
    source?: string;
    options?: PortalMemberImportCatalogOptionDto[];
}

export class PortalMemberImportCatalogOptionDto implements IPortalMemberImportCatalogOptionDto {
    id?: string;
    name?: string;

    constructor(data?: IPortalMemberImportCatalogOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PortalMemberImportCatalogOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PortalMemberImportCatalogOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IPortalMemberImportCatalogOptionDto {
    id?: string;
    name?: string;
}

export class PortalImportEquivalencePreviewDto implements IPortalImportEquivalencePreviewDto {
    sourceSection?: string;
    sourceValue?: string;
    occurrences?: number;
    sourceLabel?: string | undefined;
    sourceContext?: string | undefined;
    memberNames?: string[] | undefined;

    constructor(data?: IPortalImportEquivalencePreviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceSection = _data["sourceSection"];
            this.sourceValue = _data["sourceValue"];
            this.occurrences = _data["occurrences"];
            this.sourceLabel = _data["sourceLabel"];
            this.sourceContext = _data["sourceContext"];
            if (Array.isArray(_data["memberNames"])) {
                this.memberNames = [] as any;
                for (let item of _data["memberNames"])
                    this.memberNames!.push(item);
            }
        }
    }

    static fromJS(data: any): PortalImportEquivalencePreviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PortalImportEquivalencePreviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceSection"] = this.sourceSection;
        data["sourceValue"] = this.sourceValue;
        data["occurrences"] = this.occurrences;
        data["sourceLabel"] = this.sourceLabel;
        data["sourceContext"] = this.sourceContext;
        if (Array.isArray(this.memberNames)) {
            data["memberNames"] = [];
            for (let item of this.memberNames)
                data["memberNames"].push(item);
        }
        return data;
    }
}

export interface IPortalImportEquivalencePreviewDto {
    sourceSection?: string;
    sourceValue?: string;
    occurrences?: number;
    sourceLabel?: string | undefined;
    sourceContext?: string | undefined;
    memberNames?: string[] | undefined;
}

export class PortalMemberImportRequest implements IPortalMemberImportRequest {
    photos?: PortalPhotoSelection[];
    batchId?: string | undefined;
    sourceJson?: string;
    sourceFileName?: string | undefined;
    selections?: PortalMemberImportPersonSelectionDto[];
    catalogMappings?: PortalMemberImportCatalogMappingDto[];

    constructor(data?: IPortalMemberImportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["photos"])) {
                this.photos = [] as any;
                for (let item of _data["photos"])
                    this.photos!.push(PortalPhotoSelection.fromJS(item));
            }
            this.batchId = _data["batchId"];
            this.sourceJson = _data["sourceJson"];
            this.sourceFileName = _data["sourceFileName"];
            if (Array.isArray(_data["selections"])) {
                this.selections = [] as any;
                for (let item of _data["selections"])
                    this.selections!.push(PortalMemberImportPersonSelectionDto.fromJS(item));
            }
            if (Array.isArray(_data["catalogMappings"])) {
                this.catalogMappings = [] as any;
                for (let item of _data["catalogMappings"])
                    this.catalogMappings!.push(PortalMemberImportCatalogMappingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PortalMemberImportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PortalMemberImportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.photos)) {
            data["photos"] = [];
            for (let item of this.photos)
                data["photos"].push(item ? item.toJSON() : undefined as any);
        }
        data["batchId"] = this.batchId;
        data["sourceJson"] = this.sourceJson;
        data["sourceFileName"] = this.sourceFileName;
        if (Array.isArray(this.selections)) {
            data["selections"] = [];
            for (let item of this.selections)
                data["selections"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.catalogMappings)) {
            data["catalogMappings"] = [];
            for (let item of this.catalogMappings)
                data["catalogMappings"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPortalMemberImportRequest {
    photos?: PortalPhotoSelection[];
    batchId?: string | undefined;
    sourceJson?: string;
    sourceFileName?: string | undefined;
    selections?: PortalMemberImportPersonSelectionDto[];
    catalogMappings?: PortalMemberImportCatalogMappingDto[];
}

export class PortalPhotoSelection implements IPortalPhotoSelection {
    assetId?: string;
    include?: boolean;
    revision?: string;
    unitId?: string | undefined;
    replacePhotoId?: string | undefined;
    crop?: PhotoCrop | undefined;

    constructor(data?: IPortalPhotoSelection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetId = _data["assetId"];
            this.include = _data["include"];
            this.revision = _data["revision"];
            this.unitId = _data["unitId"];
            this.replacePhotoId = _data["replacePhotoId"];
            this.crop = _data["crop"] ? PhotoCrop.fromJS(_data["crop"]) : undefined as any;
        }
    }

    static fromJS(data: any): PortalPhotoSelection {
        data = typeof data === 'object' ? data : {};
        let result = new PortalPhotoSelection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetId"] = this.assetId;
        data["include"] = this.include;
        data["revision"] = this.revision;
        data["unitId"] = this.unitId;
        data["replacePhotoId"] = this.replacePhotoId;
        data["crop"] = this.crop ? this.crop.toJSON() : undefined as any;
        return data;
    }
}

export interface IPortalPhotoSelection {
    assetId?: string;
    include?: boolean;
    revision?: string;
    unitId?: string | undefined;
    replacePhotoId?: string | undefined;
    crop?: PhotoCrop | undefined;
}

export class PhotoCrop implements IPhotoCrop {
    x?: number;
    y?: number;
    size?: number;

    constructor(data?: IPhotoCrop) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"];
            this.y = _data["y"];
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): PhotoCrop {
        data = typeof data === 'object' ? data : {};
        let result = new PhotoCrop();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x;
        data["y"] = this.y;
        data["size"] = this.size;
        return data;
    }
}

export interface IPhotoCrop {
    x?: number;
    y?: number;
    size?: number;
}

export class PortalMemberImportPersonSelectionDto implements IPortalMemberImportPersonSelectionDto {
    portalMemberId?: string;
    include?: boolean;
    status?: MembershipStatus;
    email?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    community?: string | undefined;
    communityHistory?: PortalMemberImportCommunityHistorySelectionDto[];
    personalData?: PortalPersonalDataSelectionDto | undefined;
    family?: PortalFamilySelectionDto[];
    ministries?: PortalMinistrySelectionDto[];
    services?: PortalServiceSelectionDto[];
    qualities?: PortalMemberImportQualitySelectionDto[];
    events?: PortalMemberImportEventSelectionDto[];

    constructor(data?: IPortalMemberImportPersonSelectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.portalMemberId = _data["portalMemberId"];
            this.include = _data["include"];
            this.status = _data["status"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.address = _data["address"];
            this.community = _data["community"];
            if (Array.isArray(_data["communityHistory"])) {
                this.communityHistory = [] as any;
                for (let item of _data["communityHistory"])
                    this.communityHistory!.push(PortalMemberImportCommunityHistorySelectionDto.fromJS(item));
            }
            this.personalData = _data["personalData"] ? PortalPersonalDataSelectionDto.fromJS(_data["personalData"]) : undefined as any;
            if (Array.isArray(_data["family"])) {
                this.family = [] as any;
                for (let item of _data["family"])
                    this.family!.push(PortalFamilySelectionDto.fromJS(item));
            }
            if (Array.isArray(_data["ministries"])) {
                this.ministries = [] as any;
                for (let item of _data["ministries"])
                    this.ministries!.push(PortalMinistrySelectionDto.fromJS(item));
            }
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(PortalServiceSelectionDto.fromJS(item));
            }
            if (Array.isArray(_data["qualities"])) {
                this.qualities = [] as any;
                for (let item of _data["qualities"])
                    this.qualities!.push(PortalMemberImportQualitySelectionDto.fromJS(item));
            }
            if (Array.isArray(_data["events"])) {
                this.events = [] as any;
                for (let item of _data["events"])
                    this.events!.push(PortalMemberImportEventSelectionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PortalMemberImportPersonSelectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PortalMemberImportPersonSelectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["portalMemberId"] = this.portalMemberId;
        data["include"] = this.include;
        data["status"] = this.status;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["address"] = this.address;
        data["community"] = this.community;
        if (Array.isArray(this.communityHistory)) {
            data["communityHistory"] = [];
            for (let item of this.communityHistory)
                data["communityHistory"].push(item ? item.toJSON() : undefined as any);
        }
        data["personalData"] = this.personalData ? this.personalData.toJSON() : undefined as any;
        if (Array.isArray(this.family)) {
            data["family"] = [];
            for (let item of this.family)
                data["family"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.ministries)) {
            data["ministries"] = [];
            for (let item of this.ministries)
                data["ministries"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.qualities)) {
            data["qualities"] = [];
            for (let item of this.qualities)
                data["qualities"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.events)) {
            data["events"] = [];
            for (let item of this.events)
                data["events"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPortalMemberImportPersonSelectionDto {
    portalMemberId?: string;
    include?: boolean;
    status?: MembershipStatus;
    email?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    community?: string | undefined;
    communityHistory?: PortalMemberImportCommunityHistorySelectionDto[];
    personalData?: PortalPersonalDataSelectionDto | undefined;
    family?: PortalFamilySelectionDto[];
    ministries?: PortalMinistrySelectionDto[];
    services?: PortalServiceSelectionDto[];
    qualities?: PortalMemberImportQualitySelectionDto[];
    events?: PortalMemberImportEventSelectionDto[];
}

export class PortalMemberImportCommunityHistorySelectionDto implements IPortalMemberImportCommunityHistorySelectionDto {
    index?: number;
    community?: string | undefined;
    startDate?: string | undefined;

    constructor(data?: IPortalMemberImportCommunityHistorySelectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"];
            this.community = _data["community"];
            this.startDate = _data["startDate"];
        }
    }

    static fromJS(data: any): PortalMemberImportCommunityHistorySelectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PortalMemberImportCommunityHistorySelectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["community"] = this.community;
        data["startDate"] = this.startDate;
        return data;
    }
}

export interface IPortalMemberImportCommunityHistorySelectionDto {
    index?: number;
    community?: string | undefined;
    startDate?: string | undefined;
}

export class PortalPersonalDataSelectionDto implements IPortalPersonalDataSelectionDto {
    gender?: Gender | undefined;
    relationshipSituation?: RelationshipSituation | undefined;
    documentNumber?: string | undefined;
    languages?: string | undefined;
    countryOfBirthId?: number | undefined;
    nationalityId?: number | undefined;

    constructor(data?: IPortalPersonalDataSelectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gender = _data["gender"];
            this.relationshipSituation = _data["relationshipSituation"];
            this.documentNumber = _data["documentNumber"];
            this.languages = _data["languages"];
            this.countryOfBirthId = _data["countryOfBirthId"];
            this.nationalityId = _data["nationalityId"];
        }
    }

    static fromJS(data: any): PortalPersonalDataSelectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PortalPersonalDataSelectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gender"] = this.gender;
        data["relationshipSituation"] = this.relationshipSituation;
        data["documentNumber"] = this.documentNumber;
        data["languages"] = this.languages;
        data["countryOfBirthId"] = this.countryOfBirthId;
        data["nationalityId"] = this.nationalityId;
        return data;
    }
}

export interface IPortalPersonalDataSelectionDto {
    gender?: Gender | undefined;
    relationshipSituation?: RelationshipSituation | undefined;
    documentNumber?: string | undefined;
    languages?: string | undefined;
    countryOfBirthId?: number | undefined;
    nationalityId?: number | undefined;
}

export class PortalFamilySelectionDto implements IPortalFamilySelectionDto {
    index?: number;
    associate?: boolean;
    personId?: string | undefined;

    constructor(data?: IPortalFamilySelectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"];
            this.associate = _data["associate"];
            this.personId = _data["personId"];
        }
    }

    static fromJS(data: any): PortalFamilySelectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PortalFamilySelectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["associate"] = this.associate;
        data["personId"] = this.personId;
        return data;
    }
}

export interface IPortalFamilySelectionDto {
    index?: number;
    associate?: boolean;
    personId?: string | undefined;
}

export class PortalMinistrySelectionDto implements IPortalMinistrySelectionDto {
    index?: number;
    ignore?: boolean;
    eventType?: MinistryEventType;
    ministryId?: number;
    community?: string | undefined;
    location?: string | undefined;
    notes?: string | undefined;
    expectedEndDate?: string | undefined;

    constructor(data?: IPortalMinistrySelectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"];
            this.ignore = _data["ignore"];
            this.eventType = _data["eventType"];
            this.ministryId = _data["ministryId"];
            this.community = _data["community"];
            this.location = _data["location"];
            this.notes = _data["notes"];
            this.expectedEndDate = _data["expectedEndDate"];
        }
    }

    static fromJS(data: any): PortalMinistrySelectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PortalMinistrySelectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["ignore"] = this.ignore;
        data["eventType"] = this.eventType;
        data["ministryId"] = this.ministryId;
        data["community"] = this.community;
        data["location"] = this.location;
        data["notes"] = this.notes;
        data["expectedEndDate"] = this.expectedEndDate;
        return data;
    }
}

export interface IPortalMinistrySelectionDto {
    index?: number;
    ignore?: boolean;
    eventType?: MinistryEventType;
    ministryId?: number;
    community?: string | undefined;
    location?: string | undefined;
    notes?: string | undefined;
    expectedEndDate?: string | undefined;
}

export class PortalServiceSelectionDto implements IPortalServiceSelectionDto {
    section?: string;
    index?: number;
    ignore?: boolean;
    targetKind?: string;
    targetId?: number | undefined;
    activityRoleId?: number | undefined;
    unitRule?: string;
    targetReference?: string | undefined;

    constructor(data?: IPortalServiceSelectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.section = _data["section"];
            this.index = _data["index"];
            this.ignore = _data["ignore"];
            this.targetKind = _data["targetKind"];
            this.targetId = _data["targetId"];
            this.activityRoleId = _data["activityRoleId"];
            this.unitRule = _data["unitRule"];
            this.targetReference = _data["targetReference"];
        }
    }

    static fromJS(data: any): PortalServiceSelectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PortalServiceSelectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["section"] = this.section;
        data["index"] = this.index;
        data["ignore"] = this.ignore;
        data["targetKind"] = this.targetKind;
        data["targetId"] = this.targetId;
        data["activityRoleId"] = this.activityRoleId;
        data["unitRule"] = this.unitRule;
        data["targetReference"] = this.targetReference;
        return data;
    }
}

export interface IPortalServiceSelectionDto {
    section?: string;
    index?: number;
    ignore?: boolean;
    targetKind?: string;
    targetId?: number | undefined;
    activityRoleId?: number | undefined;
    unitRule?: string;
    targetReference?: string | undefined;
}

export class PortalMemberImportQualitySelectionDto implements IPortalMemberImportQualitySelectionDto {
    index?: number;
    ignore?: boolean;
    data?: PortalImportQualityDataDto | undefined;

    constructor(data?: IPortalMemberImportQualitySelectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"];
            this.ignore = _data["ignore"];
            this.data = _data["data"] ? PortalImportQualityDataDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): PortalMemberImportQualitySelectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PortalMemberImportQualitySelectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["ignore"] = this.ignore;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IPortalMemberImportQualitySelectionDto {
    index?: number;
    ignore?: boolean;
    data?: PortalImportQualityDataDto | undefined;
}

export class PortalImportQualityDataDto implements IPortalImportQualityDataDto {
    name?: string;
    type?: PersonCharacteristicType;
    notes?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;

    constructor(data?: IPortalImportQualityDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
            this.notes = _data["notes"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
        }
    }

    static fromJS(data: any): PortalImportQualityDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new PortalImportQualityDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        data["notes"] = this.notes;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        return data;
    }
}

export interface IPortalImportQualityDataDto {
    name?: string;
    type?: PersonCharacteristicType;
    notes?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
}

export type PersonCharacteristicType = "Other" | "SignedFormAtAdministration" | "ConfidentialityAgreement";

export class PortalMemberImportEventSelectionDto implements IPortalMemberImportEventSelectionDto {
    index?: number;
    section?: string;
    include?: boolean;
    associate?: boolean;
    personId?: string | undefined;
    date?: string | undefined;

    constructor(data?: IPortalMemberImportEventSelectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"];
            this.section = _data["section"];
            this.include = _data["include"];
            this.associate = _data["associate"];
            this.personId = _data["personId"];
            this.date = _data["date"];
        }
    }

    static fromJS(data: any): PortalMemberImportEventSelectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PortalMemberImportEventSelectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["section"] = this.section;
        data["include"] = this.include;
        data["associate"] = this.associate;
        data["personId"] = this.personId;
        data["date"] = this.date;
        return data;
    }
}

export interface IPortalMemberImportEventSelectionDto {
    index?: number;
    section?: string;
    include?: boolean;
    associate?: boolean;
    personId?: string | undefined;
    date?: string | undefined;
}

export class PortalMemberImportCatalogMappingDto implements IPortalMemberImportCatalogMappingDto {
    kind?: string;
    source?: string;
    targetId?: string | undefined;

    constructor(data?: IPortalMemberImportCatalogMappingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kind = _data["kind"];
            this.source = _data["source"];
            this.targetId = _data["targetId"];
        }
    }

    static fromJS(data: any): PortalMemberImportCatalogMappingDto {
        data = typeof data === 'object' ? data : {};
        let result = new PortalMemberImportCatalogMappingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kind"] = this.kind;
        data["source"] = this.source;
        data["targetId"] = this.targetId;
        return data;
    }
}

export interface IPortalMemberImportCatalogMappingDto {
    kind?: string;
    source?: string;
    targetId?: string | undefined;
}

export class GlobalSearchResponseDto implements IGlobalSearchResponseDto {
    people?: GlobalSearchPersonResultDto[];
    units?: GlobalSearchUnitResultDto[];

    constructor(data?: IGlobalSearchResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["people"])) {
                this.people = [] as any;
                for (let item of _data["people"])
                    this.people!.push(GlobalSearchPersonResultDto.fromJS(item));
            }
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units!.push(GlobalSearchUnitResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GlobalSearchResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalSearchResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.people)) {
            data["people"] = [];
            for (let item of this.people)
                data["people"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGlobalSearchResponseDto {
    people?: GlobalSearchPersonResultDto[];
    units?: GlobalSearchUnitResultDto[];
}

export class GlobalSearchPersonResultDto implements IGlobalSearchPersonResultDto {
    id?: string;
    fullName?: string;
    documentNumber?: string | undefined;
    membershipUnitId?: string;
    membershipUnitName?: string;
    ministryName?: string | undefined;
    ministrySortOrder?: number | undefined;

    constructor(data?: IGlobalSearchPersonResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.documentNumber = _data["documentNumber"];
            this.membershipUnitId = _data["membershipUnitId"];
            this.membershipUnitName = _data["membershipUnitName"];
            this.ministryName = _data["ministryName"];
            this.ministrySortOrder = _data["ministrySortOrder"];
        }
    }

    static fromJS(data: any): GlobalSearchPersonResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalSearchPersonResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["documentNumber"] = this.documentNumber;
        data["membershipUnitId"] = this.membershipUnitId;
        data["membershipUnitName"] = this.membershipUnitName;
        data["ministryName"] = this.ministryName;
        data["ministrySortOrder"] = this.ministrySortOrder;
        return data;
    }
}

export interface IGlobalSearchPersonResultDto {
    id?: string;
    fullName?: string;
    documentNumber?: string | undefined;
    membershipUnitId?: string;
    membershipUnitName?: string;
    ministryName?: string | undefined;
    ministrySortOrder?: number | undefined;
}

export class GlobalSearchUnitResultDto implements IGlobalSearchUnitResultDto {
    id?: string;
    name?: string;
    levelName?: string;
    organizationLevelId?: number;
    parentName?: string | undefined;

    constructor(data?: IGlobalSearchUnitResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.levelName = _data["levelName"];
            this.organizationLevelId = _data["organizationLevelId"];
            this.parentName = _data["parentName"];
        }
    }

    static fromJS(data: any): GlobalSearchUnitResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalSearchUnitResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["levelName"] = this.levelName;
        data["organizationLevelId"] = this.organizationLevelId;
        data["parentName"] = this.parentName;
        return data;
    }
}

export interface IGlobalSearchUnitResultDto {
    id?: string;
    name?: string;
    levelName?: string;
    organizationLevelId?: number;
    parentName?: string | undefined;
}

export class SpiritualAssistanceVisitGroupDto implements ISpiritualAssistanceVisitGroupDto {
    organizationUnitId?: string;
    organizationUnitName?: string;
    recipients?: SpiritualAssistanceVisitPersonDto[];

    constructor(data?: ISpiritualAssistanceVisitGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationUnitId = _data["organizationUnitId"];
            this.organizationUnitName = _data["organizationUnitName"];
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(SpiritualAssistanceVisitPersonDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SpiritualAssistanceVisitGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpiritualAssistanceVisitGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitId"] = this.organizationUnitId;
        data["organizationUnitName"] = this.organizationUnitName;
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISpiritualAssistanceVisitGroupDto {
    organizationUnitId?: string;
    organizationUnitName?: string;
    recipients?: SpiritualAssistanceVisitPersonDto[];
}

export class SpiritualAssistanceVisitPersonDto implements ISpiritualAssistanceVisitPersonDto {
    id?: string;
    fullName?: string;
    membershipUnitId?: string | undefined;
    membershipUnitName?: string | undefined;
    responsiblePriestId?: string | undefined;
    responsiblePriestName?: string | undefined;

    constructor(data?: ISpiritualAssistanceVisitPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.membershipUnitId = _data["membershipUnitId"];
            this.membershipUnitName = _data["membershipUnitName"];
            this.responsiblePriestId = _data["responsiblePriestId"];
            this.responsiblePriestName = _data["responsiblePriestName"];
        }
    }

    static fromJS(data: any): SpiritualAssistanceVisitPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpiritualAssistanceVisitPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["membershipUnitId"] = this.membershipUnitId;
        data["membershipUnitName"] = this.membershipUnitName;
        data["responsiblePriestId"] = this.responsiblePriestId;
        data["responsiblePriestName"] = this.responsiblePriestName;
        return data;
    }
}

export interface ISpiritualAssistanceVisitPersonDto {
    id?: string;
    fullName?: string;
    membershipUnitId?: string | undefined;
    membershipUnitName?: string | undefined;
    responsiblePriestId?: string | undefined;
    responsiblePriestName?: string | undefined;
}

export class CreateSpiritualAssistanceVisitRequest implements ICreateSpiritualAssistanceVisitRequest {
    visitDate?: string;
    locationType?: SpiritualAssistanceVisitLocationType;
    locationDescription?: string | undefined;
    holyCommunionDelivered?: boolean;
    recipientIds?: string[];
    visitorIds?: string[];

    constructor(data?: ICreateSpiritualAssistanceVisitRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.visitDate = _data["visitDate"];
            this.locationType = _data["locationType"];
            this.locationDescription = _data["locationDescription"];
            this.holyCommunionDelivered = _data["holyCommunionDelivered"];
            if (Array.isArray(_data["recipientIds"])) {
                this.recipientIds = [] as any;
                for (let item of _data["recipientIds"])
                    this.recipientIds!.push(item);
            }
            if (Array.isArray(_data["visitorIds"])) {
                this.visitorIds = [] as any;
                for (let item of _data["visitorIds"])
                    this.visitorIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateSpiritualAssistanceVisitRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSpiritualAssistanceVisitRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["visitDate"] = this.visitDate;
        data["locationType"] = this.locationType;
        data["locationDescription"] = this.locationDescription;
        data["holyCommunionDelivered"] = this.holyCommunionDelivered;
        if (Array.isArray(this.recipientIds)) {
            data["recipientIds"] = [];
            for (let item of this.recipientIds)
                data["recipientIds"].push(item);
        }
        if (Array.isArray(this.visitorIds)) {
            data["visitorIds"] = [];
            for (let item of this.visitorIds)
                data["visitorIds"].push(item);
        }
        return data;
    }
}

export interface ICreateSpiritualAssistanceVisitRequest {
    visitDate?: string;
    locationType?: SpiritualAssistanceVisitLocationType;
    locationDescription?: string | undefined;
    holyCommunionDelivered?: boolean;
    recipientIds?: string[];
    visitorIds?: string[];
}

export type SpiritualAssistanceVisitLocationType = "Home" | "Community" | "Other";

export class SpiritualAssistanceVisitCreatedDto implements ISpiritualAssistanceVisitCreatedDto {
    visitIds?: string[];
    groups?: SpiritualAssistanceVisitGroupDto[];

    constructor(data?: ISpiritualAssistanceVisitCreatedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["visitIds"])) {
                this.visitIds = [] as any;
                for (let item of _data["visitIds"])
                    this.visitIds!.push(item);
            }
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(SpiritualAssistanceVisitGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SpiritualAssistanceVisitCreatedDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpiritualAssistanceVisitCreatedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.visitIds)) {
            data["visitIds"] = [];
            for (let item of this.visitIds)
                data["visitIds"].push(item);
        }
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISpiritualAssistanceVisitCreatedDto {
    visitIds?: string[];
    groups?: SpiritualAssistanceVisitGroupDto[];
}

export class SpiritualAssistanceVisitDetailDto implements ISpiritualAssistanceVisitDetailDto {
    id?: string;
    visitDate?: string;
    organizationUnitId?: string;
    organizationUnitName?: string;
    locationType?: SpiritualAssistanceVisitLocationType;
    locationDescription?: string | undefined;
    holyCommunionDelivered?: boolean;
    recipients?: SpiritualAssistanceVisitPersonDto[];
    visitors?: SpiritualAssistanceVisitPersonDto[];

    constructor(data?: ISpiritualAssistanceVisitDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.visitDate = _data["visitDate"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.organizationUnitName = _data["organizationUnitName"];
            this.locationType = _data["locationType"];
            this.locationDescription = _data["locationDescription"];
            this.holyCommunionDelivered = _data["holyCommunionDelivered"];
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(SpiritualAssistanceVisitPersonDto.fromJS(item));
            }
            if (Array.isArray(_data["visitors"])) {
                this.visitors = [] as any;
                for (let item of _data["visitors"])
                    this.visitors!.push(SpiritualAssistanceVisitPersonDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SpiritualAssistanceVisitDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpiritualAssistanceVisitDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["visitDate"] = this.visitDate;
        data["organizationUnitId"] = this.organizationUnitId;
        data["organizationUnitName"] = this.organizationUnitName;
        data["locationType"] = this.locationType;
        data["locationDescription"] = this.locationDescription;
        data["holyCommunionDelivered"] = this.holyCommunionDelivered;
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.visitors)) {
            data["visitors"] = [];
            for (let item of this.visitors)
                data["visitors"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISpiritualAssistanceVisitDetailDto {
    id?: string;
    visitDate?: string;
    organizationUnitId?: string;
    organizationUnitName?: string;
    locationType?: SpiritualAssistanceVisitLocationType;
    locationDescription?: string | undefined;
    holyCommunionDelivered?: boolean;
    recipients?: SpiritualAssistanceVisitPersonDto[];
    visitors?: SpiritualAssistanceVisitPersonDto[];
}

export class SpiritualAssistanceVisitListItemDto implements ISpiritualAssistanceVisitListItemDto {
    id?: string;
    visitDate?: string;
    organizationUnitId?: string;
    organizationUnitName?: string;
    locationType?: SpiritualAssistanceVisitLocationType;
    locationDescription?: string | undefined;
    holyCommunionDelivered?: boolean;
    recipients?: SpiritualAssistanceVisitPersonDto[];
    visitors?: SpiritualAssistanceVisitPersonDto[];

    constructor(data?: ISpiritualAssistanceVisitListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.visitDate = _data["visitDate"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.organizationUnitName = _data["organizationUnitName"];
            this.locationType = _data["locationType"];
            this.locationDescription = _data["locationDescription"];
            this.holyCommunionDelivered = _data["holyCommunionDelivered"];
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(SpiritualAssistanceVisitPersonDto.fromJS(item));
            }
            if (Array.isArray(_data["visitors"])) {
                this.visitors = [] as any;
                for (let item of _data["visitors"])
                    this.visitors!.push(SpiritualAssistanceVisitPersonDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SpiritualAssistanceVisitListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpiritualAssistanceVisitListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["visitDate"] = this.visitDate;
        data["organizationUnitId"] = this.organizationUnitId;
        data["organizationUnitName"] = this.organizationUnitName;
        data["locationType"] = this.locationType;
        data["locationDescription"] = this.locationDescription;
        data["holyCommunionDelivered"] = this.holyCommunionDelivered;
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.visitors)) {
            data["visitors"] = [];
            for (let item of this.visitors)
                data["visitors"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISpiritualAssistanceVisitListItemDto {
    id?: string;
    visitDate?: string;
    organizationUnitId?: string;
    organizationUnitName?: string;
    locationType?: SpiritualAssistanceVisitLocationType;
    locationDescription?: string | undefined;
    holyCommunionDelivered?: boolean;
    recipients?: SpiritualAssistanceVisitPersonDto[];
    visitors?: SpiritualAssistanceVisitPersonDto[];
}

export class PaginatedResponseOfSpiritualAssistanceVisitVisitorOptionDto implements IPaginatedResponseOfSpiritualAssistanceVisitVisitorOptionDto {
    items?: SpiritualAssistanceVisitVisitorOptionDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResponseOfSpiritualAssistanceVisitVisitorOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SpiritualAssistanceVisitVisitorOptionDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfSpiritualAssistanceVisitVisitorOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfSpiritualAssistanceVisitVisitorOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedResponseOfSpiritualAssistanceVisitVisitorOptionDto {
    items?: SpiritualAssistanceVisitVisitorOptionDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class SpiritualAssistanceVisitVisitorOptionDto implements ISpiritualAssistanceVisitVisitorOptionDto {
    id?: string;
    fullName?: string;
    ministryName?: string | undefined;
    ministryActivityUnitNames?: string[];
    officiantActivityUnitNames?: string[];

    constructor(data?: ISpiritualAssistanceVisitVisitorOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.ministryName = _data["ministryName"];
            if (Array.isArray(_data["ministryActivityUnitNames"])) {
                this.ministryActivityUnitNames = [] as any;
                for (let item of _data["ministryActivityUnitNames"])
                    this.ministryActivityUnitNames!.push(item);
            }
            if (Array.isArray(_data["officiantActivityUnitNames"])) {
                this.officiantActivityUnitNames = [] as any;
                for (let item of _data["officiantActivityUnitNames"])
                    this.officiantActivityUnitNames!.push(item);
            }
        }
    }

    static fromJS(data: any): SpiritualAssistanceVisitVisitorOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpiritualAssistanceVisitVisitorOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["ministryName"] = this.ministryName;
        if (Array.isArray(this.ministryActivityUnitNames)) {
            data["ministryActivityUnitNames"] = [];
            for (let item of this.ministryActivityUnitNames)
                data["ministryActivityUnitNames"].push(item);
        }
        if (Array.isArray(this.officiantActivityUnitNames)) {
            data["officiantActivityUnitNames"] = [];
            for (let item of this.officiantActivityUnitNames)
                data["officiantActivityUnitNames"].push(item);
        }
        return data;
    }
}

export interface ISpiritualAssistanceVisitVisitorOptionDto {
    id?: string;
    fullName?: string;
    ministryName?: string | undefined;
    ministryActivityUnitNames?: string[];
    officiantActivityUnitNames?: string[];
}

export class PersonSpiritualAssistanceVisitSummaryDto implements IPersonSpiritualAssistanceVisitSummaryDto {
    personId?: string;
    lastVisitDate?: string | undefined;
    daysSinceLastVisit?: number | undefined;

    constructor(data?: IPersonSpiritualAssistanceVisitSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.lastVisitDate = _data["lastVisitDate"];
            this.daysSinceLastVisit = _data["daysSinceLastVisit"];
        }
    }

    static fromJS(data: any): PersonSpiritualAssistanceVisitSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonSpiritualAssistanceVisitSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["lastVisitDate"] = this.lastVisitDate;
        data["daysSinceLastVisit"] = this.daysSinceLastVisit;
        return data;
    }
}

export interface IPersonSpiritualAssistanceVisitSummaryDto {
    personId?: string;
    lastVisitDate?: string | undefined;
    daysSinceLastVisit?: number | undefined;
}

export class UserIdentityReconciliationReportDto implements IUserIdentityReconciliationReportDto {
    applied?: boolean;
    identityUsersCount?: number;
    localUsersCount?: number;
    alreadyLinkedCount?: number;
    safeRelinksCount?: number;
    safeCreationsCount?: number;
    attentionRequiredCount?: number;
    items?: UserIdentityReconciliationItemDto[];

    constructor(data?: IUserIdentityReconciliationReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applied = _data["applied"];
            this.identityUsersCount = _data["identityUsersCount"];
            this.localUsersCount = _data["localUsersCount"];
            this.alreadyLinkedCount = _data["alreadyLinkedCount"];
            this.safeRelinksCount = _data["safeRelinksCount"];
            this.safeCreationsCount = _data["safeCreationsCount"];
            this.attentionRequiredCount = _data["attentionRequiredCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserIdentityReconciliationItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserIdentityReconciliationReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserIdentityReconciliationReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applied"] = this.applied;
        data["identityUsersCount"] = this.identityUsersCount;
        data["localUsersCount"] = this.localUsersCount;
        data["alreadyLinkedCount"] = this.alreadyLinkedCount;
        data["safeRelinksCount"] = this.safeRelinksCount;
        data["safeCreationsCount"] = this.safeCreationsCount;
        data["attentionRequiredCount"] = this.attentionRequiredCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserIdentityReconciliationReportDto {
    applied?: boolean;
    identityUsersCount?: number;
    localUsersCount?: number;
    alreadyLinkedCount?: number;
    safeRelinksCount?: number;
    safeCreationsCount?: number;
    attentionRequiredCount?: number;
    items?: UserIdentityReconciliationItemDto[];
}

export class UserIdentityReconciliationItemDto implements IUserIdentityReconciliationItemDto {
    status?: UserIdentityReconciliationStatus;
    applied?: boolean;
    personId?: string | undefined;
    localUserId?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    identityUsername?: string | undefined;
    identityUserId?: string | undefined;
    previousExternalId?: string | undefined;
    detail?: string;

    constructor(data?: IUserIdentityReconciliationItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.applied = _data["applied"];
            this.personId = _data["personId"];
            this.localUserId = _data["localUserId"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.identityUsername = _data["identityUsername"];
            this.identityUserId = _data["identityUserId"];
            this.previousExternalId = _data["previousExternalId"];
            this.detail = _data["detail"];
        }
    }

    static fromJS(data: any): UserIdentityReconciliationItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserIdentityReconciliationItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["applied"] = this.applied;
        data["personId"] = this.personId;
        data["localUserId"] = this.localUserId;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["identityUsername"] = this.identityUsername;
        data["identityUserId"] = this.identityUserId;
        data["previousExternalId"] = this.previousExternalId;
        data["detail"] = this.detail;
        return data;
    }
}

export interface IUserIdentityReconciliationItemDto {
    status?: UserIdentityReconciliationStatus;
    applied?: boolean;
    personId?: string | undefined;
    localUserId?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    identityUsername?: string | undefined;
    identityUserId?: string | undefined;
    previousExternalId?: string | undefined;
    detail?: string;
}

export type UserIdentityReconciliationStatus = "AlreadyLinked" | "Relinked" | "Created" | "MissingEmail" | "DuplicateIdentityEmail" | "DuplicatePersonEmail" | "NoMatchingPerson" | "ExternalIdConflict" | "IdentityUserMissing";

export class PaginatedResponseOfIdentityUserDto implements IPaginatedResponseOfIdentityUserDto {
    items?: IdentityUserDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResponseOfIdentityUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(IdentityUserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfIdentityUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfIdentityUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedResponseOfIdentityUserDto {
    items?: IdentityUserDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class IdentityUserDto implements IIdentityUserDto {
    id?: string;
    username?: string;
    email?: string | undefined;
    enabled?: boolean;
    emailVerified?: boolean;
    source?: string | undefined;
    hasLocalUser?: boolean;
    lastActivityAtUtc?: string | undefined;
    linkedMember?: IdentityUserLinkedMemberDto | undefined;
    roles?: UserRole[];
    roleAssignments?: IdentityUserRoleAssignmentDto[];

    constructor(data?: IIdentityUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.username = _data["username"];
            this.email = _data["email"];
            this.enabled = _data["enabled"];
            this.emailVerified = _data["emailVerified"];
            this.source = _data["source"];
            this.hasLocalUser = _data["hasLocalUser"];
            this.lastActivityAtUtc = _data["lastActivityAtUtc"];
            this.linkedMember = _data["linkedMember"] ? IdentityUserLinkedMemberDto.fromJS(_data["linkedMember"]) : undefined as any;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["roleAssignments"])) {
                this.roleAssignments = [] as any;
                for (let item of _data["roleAssignments"])
                    this.roleAssignments!.push(IdentityUserRoleAssignmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IdentityUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["username"] = this.username;
        data["email"] = this.email;
        data["enabled"] = this.enabled;
        data["emailVerified"] = this.emailVerified;
        data["source"] = this.source;
        data["hasLocalUser"] = this.hasLocalUser;
        data["lastActivityAtUtc"] = this.lastActivityAtUtc;
        data["linkedMember"] = this.linkedMember ? this.linkedMember.toJSON() : undefined as any;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.roleAssignments)) {
            data["roleAssignments"] = [];
            for (let item of this.roleAssignments)
                data["roleAssignments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IIdentityUserDto {
    id?: string;
    username?: string;
    email?: string | undefined;
    enabled?: boolean;
    emailVerified?: boolean;
    source?: string | undefined;
    hasLocalUser?: boolean;
    lastActivityAtUtc?: string | undefined;
    linkedMember?: IdentityUserLinkedMemberDto | undefined;
    roles?: UserRole[];
    roleAssignments?: IdentityUserRoleAssignmentDto[];
}

export class IdentityUserLinkedMemberDto implements IIdentityUserLinkedMemberDto {
    personId?: string;
    fullName?: string;
    hasMembershipUnit?: boolean;
    membershipUnitId?: string | undefined;
    activeMinistryId?: number | undefined;
    activeMinistryUnitIds?: string[];
    activeMinistryName?: string | undefined;
    activeMinistryUnitId?: string | undefined;
    activeMinistryUnitName?: string | undefined;

    constructor(data?: IIdentityUserLinkedMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.fullName = _data["fullName"];
            this.hasMembershipUnit = _data["hasMembershipUnit"];
            this.membershipUnitId = _data["membershipUnitId"];
            this.activeMinistryId = _data["activeMinistryId"];
            if (Array.isArray(_data["activeMinistryUnitIds"])) {
                this.activeMinistryUnitIds = [] as any;
                for (let item of _data["activeMinistryUnitIds"])
                    this.activeMinistryUnitIds!.push(item);
            }
            this.activeMinistryName = _data["activeMinistryName"];
            this.activeMinistryUnitId = _data["activeMinistryUnitId"];
            this.activeMinistryUnitName = _data["activeMinistryUnitName"];
        }
    }

    static fromJS(data: any): IdentityUserLinkedMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityUserLinkedMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["fullName"] = this.fullName;
        data["hasMembershipUnit"] = this.hasMembershipUnit;
        data["membershipUnitId"] = this.membershipUnitId;
        data["activeMinistryId"] = this.activeMinistryId;
        if (Array.isArray(this.activeMinistryUnitIds)) {
            data["activeMinistryUnitIds"] = [];
            for (let item of this.activeMinistryUnitIds)
                data["activeMinistryUnitIds"].push(item);
        }
        data["activeMinistryName"] = this.activeMinistryName;
        data["activeMinistryUnitId"] = this.activeMinistryUnitId;
        data["activeMinistryUnitName"] = this.activeMinistryUnitName;
        return data;
    }
}

export interface IIdentityUserLinkedMemberDto {
    personId?: string;
    fullName?: string;
    hasMembershipUnit?: boolean;
    membershipUnitId?: string | undefined;
    activeMinistryId?: number | undefined;
    activeMinistryUnitIds?: string[];
    activeMinistryName?: string | undefined;
    activeMinistryUnitId?: string | undefined;
    activeMinistryUnitName?: string | undefined;
}

export class IdentityUserRoleAssignmentDto implements IIdentityUserRoleAssignmentDto {
    role?: UserRole;
    organizationUnitId?: string | undefined;
    organizationUnitName?: string | undefined;
    organizationUnitLevelId?: number | undefined;

    constructor(data?: IIdentityUserRoleAssignmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.organizationUnitName = _data["organizationUnitName"];
            this.organizationUnitLevelId = _data["organizationUnitLevelId"];
        }
    }

    static fromJS(data: any): IdentityUserRoleAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityUserRoleAssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role;
        data["organizationUnitId"] = this.organizationUnitId;
        data["organizationUnitName"] = this.organizationUnitName;
        data["organizationUnitLevelId"] = this.organizationUnitLevelId;
        return data;
    }
}

export interface IIdentityUserRoleAssignmentDto {
    role?: UserRole;
    organizationUnitId?: string | undefined;
    organizationUnitName?: string | undefined;
    organizationUnitLevelId?: number | undefined;
}

export class UserActivitySummaryDto implements IUserActivitySummaryDto {
    lastActivity?: UserActivityItemDto | undefined;
    totalCount?: number;
    last7DaysCount?: number;
    last30DaysCount?: number;
    countsByActionType?: UserActivityTypeCountDto[];

    constructor(data?: IUserActivitySummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastActivity = _data["lastActivity"] ? UserActivityItemDto.fromJS(_data["lastActivity"]) : undefined as any;
            this.totalCount = _data["totalCount"];
            this.last7DaysCount = _data["last7DaysCount"];
            this.last30DaysCount = _data["last30DaysCount"];
            if (Array.isArray(_data["countsByActionType"])) {
                this.countsByActionType = [] as any;
                for (let item of _data["countsByActionType"])
                    this.countsByActionType!.push(UserActivityTypeCountDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserActivitySummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserActivitySummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastActivity"] = this.lastActivity ? this.lastActivity.toJSON() : undefined as any;
        data["totalCount"] = this.totalCount;
        data["last7DaysCount"] = this.last7DaysCount;
        data["last30DaysCount"] = this.last30DaysCount;
        if (Array.isArray(this.countsByActionType)) {
            data["countsByActionType"] = [];
            for (let item of this.countsByActionType)
                data["countsByActionType"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserActivitySummaryDto {
    lastActivity?: UserActivityItemDto | undefined;
    totalCount?: number;
    last7DaysCount?: number;
    last30DaysCount?: number;
    countsByActionType?: UserActivityTypeCountDto[];
}

export class UserActivityItemDto implements IUserActivityItemDto {
    id?: string;
    timestampUtc?: string;
    actionType?: string;
    entity?: string;
    entityId?: string | undefined;
    details?: string;
    isSuccessful?: boolean;
    errorMessage?: string | undefined;
    previousData?: string | undefined;
    newData?: string | undefined;

    constructor(data?: IUserActivityItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.timestampUtc = _data["timestampUtc"];
            this.actionType = _data["actionType"];
            this.entity = _data["entity"];
            this.entityId = _data["entityId"];
            this.details = _data["details"];
            this.isSuccessful = _data["isSuccessful"];
            this.errorMessage = _data["errorMessage"];
            this.previousData = _data["previousData"];
            this.newData = _data["newData"];
        }
    }

    static fromJS(data: any): UserActivityItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserActivityItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["timestampUtc"] = this.timestampUtc;
        data["actionType"] = this.actionType;
        data["entity"] = this.entity;
        data["entityId"] = this.entityId;
        data["details"] = this.details;
        data["isSuccessful"] = this.isSuccessful;
        data["errorMessage"] = this.errorMessage;
        data["previousData"] = this.previousData;
        data["newData"] = this.newData;
        return data;
    }
}

export interface IUserActivityItemDto {
    id?: string;
    timestampUtc?: string;
    actionType?: string;
    entity?: string;
    entityId?: string | undefined;
    details?: string;
    isSuccessful?: boolean;
    errorMessage?: string | undefined;
    previousData?: string | undefined;
    newData?: string | undefined;
}

export class UserActivityTypeCountDto implements IUserActivityTypeCountDto {
    actionType?: string;
    count?: number;

    constructor(data?: IUserActivityTypeCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionType = _data["actionType"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): UserActivityTypeCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserActivityTypeCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionType"] = this.actionType;
        data["count"] = this.count;
        return data;
    }
}

export interface IUserActivityTypeCountDto {
    actionType?: string;
    count?: number;
}

export class PaginatedResponseOfUserActivityItemDto implements IPaginatedResponseOfUserActivityItemDto {
    items?: UserActivityItemDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedResponseOfUserActivityItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserActivityItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfUserActivityItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfUserActivityItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedResponseOfUserActivityItemDto {
    items?: UserActivityItemDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class UpsertUserRoleAssignmentDto implements IUpsertUserRoleAssignmentDto {
    role?: UserRole;
    organizationUnitId?: string | undefined;
    includeDescendants?: boolean;
    validFrom?: string | undefined;
    validTo?: string | undefined;

    constructor(data?: IUpsertUserRoleAssignmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.includeDescendants = _data["includeDescendants"];
            this.validFrom = _data["validFrom"];
            this.validTo = _data["validTo"];
        }
    }

    static fromJS(data: any): UpsertUserRoleAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertUserRoleAssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role;
        data["organizationUnitId"] = this.organizationUnitId;
        data["includeDescendants"] = this.includeDescendants;
        data["validFrom"] = this.validFrom;
        data["validTo"] = this.validTo;
        return data;
    }
}

export interface IUpsertUserRoleAssignmentDto {
    role?: UserRole;
    organizationUnitId?: string | undefined;
    includeDescendants?: boolean;
    validFrom?: string | undefined;
    validTo?: string | undefined;
}

export class CreateUserRequest implements ICreateUserRequest {
    memberId?: string;
    username?: string;
    email?: string | undefined;

    constructor(data?: ICreateUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"];
            this.username = _data["username"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): CreateUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId;
        data["username"] = this.username;
        data["email"] = this.email;
        return data;
    }
}

export interface ICreateUserRequest {
    memberId?: string;
    username?: string;
    email?: string | undefined;
}

export class DeleteUserDto implements IDeleteUserDto {
    deletionReason?: string;

    constructor(data?: IDeleteUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deletionReason = _data["deletionReason"];
        }
    }

    static fromJS(data: any): DeleteUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deletionReason"] = this.deletionReason;
        return data;
    }
}

export interface IDeleteUserDto {
    deletionReason?: string;
}

export class VersionResponse implements IVersionResponse {
    app?: string;
    version?: string;
    commit?: string | undefined;

    constructor(data?: IVersionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.app = _data["app"];
            this.version = _data["version"];
            this.commit = _data["commit"];
        }
    }

    static fromJS(data: any): VersionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VersionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["app"] = this.app;
        data["version"] = this.version;
        data["commit"] = this.commit;
        return data;
    }
}

export interface IVersionResponse {
    app?: string;
    version?: string;
    commit?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}